/**
 * Define namespaces in window
 */
//jshint ignore:start
(function () {

    'use strict';

    /** @namespace joyr */
    window.joyr = {};

    /** @namespace joyr.core */
    window.joyr.core = {};

    /**
     * Defines event names to be used inside the library.
     * @namespace events
     */
    window.joyr.events = {};

    /** @namespace joyr.bm */
    window.joyr.bm = {};

    /** @namespace joyr.booking */
    window.joyr.booking = {};

    /** @namespace joyr.catalog */
    window.joyr.catalog = {};

    /** @namespace joyr.tunnel */
    window.joyr.tunnel = {};

    /** @namespace joyr.giftcard */
    window.joyr.giftcard = {};

    /** @namespace joyr.order */
    window.joyr.order = {};

    /** @namespace joyr.user */
    window.joyr.user = {};
    
    /** @namespace joyr.store */
    window.joyr.store = {};

    /** @namespace joyr.wallet */
    window.joyr.wallet = {};

})();

(function (joyr) {
    'use strict';

    var _eventMap = {};
    var _promiseList = [];
    var _initialized = false;
    var _prepared = false;

    /**
     * Adds a new [event handler]{@link joyr.EventHandler} to the list of event handlers of a specific event.
     * @param {string} eventName - The name of the event.
     * @param {joyr.EventHandler} eventHandler - The event handler that will handle the event.
     * @param {string} [identifier] - An optional identifier that references this event handler for the event
     * <code>eventName</code>
     */
    joyr.core.on = function (eventName, eventHandler, identifier) {
        if (typeof eventName !== 'string') {
            throw new TypeError('[eventName] must be a string.');
        }

        if (!eventHandler || !(eventHandler instanceof joyr.EventHandler)) {
            throw new TypeError('[eventHandler] must be a valid object of type joyr.EventHandler');
        }

        var handlers = _eventMap[eventName];
        if (!handlers) {
            handlers = [];
            _eventMap[eventName] = handlers;
        }

        var handler = {
            id: identifier,
            handler: eventHandler
        };

        handlers.push(handler);
    };

    /**
     * Raises an event with a specific name and event data
     * @param {string} eventName - The name of the event.
     * @param {Object} sender - The sender of the event.
     * @param {Object} eventData - Information about the event
     * @param {bool} [canBeStopped=false] - Whether the calling of the associated event handlers will stop if one
     * of the event handlers sets [handled]{@link joyr.EventArgs#handled} to <code>true</code>.
     */
    joyr.core.trigger = function (eventName, sender, eventData, canBeStopped) {
        var eventArgs = new joyr.EventArgs(eventName, sender, eventData);

        var handlers = _eventMap[eventName];

        if (!handlers || !handlers.length) {
            return;
        }

        var length = handlers.length;
        for (var i = 0; i < length; i++) {
            var handler = handlers[i];
            handler.handler.handlerexecute(eventArgs);

            if (canBeStopped && handler.handled) { //stop calling event handlers
                return;
            }
        }
    };

    /**
     * Remove an event handler from the list of event handlers associated with a specific event.
     * @param {string} eventName - The name of the event.
     * @param {joyr.EventHandler | string} handler - The event handler to remove, or the identifier of the event
     * habler to remove (the one used in the call to [on]{@link joyr.core.on}).
     * handler to remove.
     */
    joyr.core.off = function (eventName, handler) {
        if (!eventName || !handler) {
            return;
        }

        var handlers = _eventMap[eventName];

        if (!handlers || !handlers.length) {
            return;
        }

        var i = 0;
        var isIdentifier = typeof handler === 'string';
        while (i < handlers.length) {
            var _handler = handlers[i];
            var found = isIdentifier ? _handler.id === handler : _handler.handler === handler;
            if (found) {
                handlers.splice(i, 1);
            }
        }

    };

    ////////////// Initialization

    function prepareCategories(category) {
        for (var i = 0; i < category.subcategories.length; i++) {
            var subcategory = category.subcategories[i];
            subcategory.parentCategory = category;
            if (subcategory.subcategories && subcategory.subcategories.length) {
                prepareCategories(subcategory);
            }
        }
    }

    function waitForPromises() {
        _prepared = true; //Don't await for more initialization promises.
        joyr.Promise.all(_promiseList).done(function () {
            joyr.core.trigger(joyr.events.loaded, joyr.core);
            
        }).Catch(function (error) {
            joyr.core.trigger(joyr.events.loadError, joyr.core, error);
            
        }).Finally(function () {
            _initialized = true;
        });
    }

    /**
     * Indicates whether joyr.core has been initialized or not.
     * @type {bool}
     * @name joyr.core#initialized
     * @readonly
     */
    Object.defineProperty(joyr.core, 'initialized', {
        get: function () { return _initialized; }
    });

    /**
     * Adds a promise to the list of promises that must be loaded during the initialization of the library.
     * The [loaded]{@link joyr.events.loaded} event won't be fired until all of these promises fulfill.
     * @param {joyr.Promise} promise - The promise to add to the list.
     */
    joyr.core.addPromise = function (promise) {
        if (!promise || !(promise instanceof joyr.Promise)) {
            throw new TypeError('[promise] must be a non-null joyr.Promise');
        }
        if (_prepared) {
            return;
        }

        _promiseList.push(promise);
    };

    inditex.onReady(function () {
        
        if (inditex.iCategoryTreeJSON && inditex.iCategoryTreeJSON.categories) {
            for (var i = 0; i < inditex.iCategoryTreeJSON.categories.length; i++) {
                prepareCategories(inditex.iCategoryTreeJSON.categories[i]);
            }
        }
        
        setTimeout(waitForPromises, 10);

    }, true);
}(window.joyr));

/**
 * A Promises/A+ compliant implementation of promises
 */
(function (joyr) {

    'use strict';

    function resolve(promise, o) {
        if (promise === o) {
            throw new TypeError();
        }
        try {
            var then = o && o.then;
            if (then && (typeof then === 'function')) {
                then.call(o, function (value) {
                    resolve(promise, value);
                }, function (reason) {
                    promise.reject(reason);
                });
            } else {
                promise.resolve(o);
            }
        } catch (e) {
            promise.reject(e);
        }
    }

    /**
     * A Promise/A+ compliant Promise. See {@link https://promisesaplus.com/} for further information.
     * @constructor
     * @member joyr
     * @param {Function} resolveRejectCallback - A function that receives two callbacks, 'resolve', and 'reject'. When
     *  the asynchronous operation represented by the promise succeeds, it must call 'resolve' with a resolution
     *  value, which will become the value of the Promise. If it fails, it must call 'reject' with a reason for
     *  the failure (usually, an Error object). This will became the Promise's reason for the fail.
     * @example
     * var promise = new joyr.Promise(function(reject, resolve) {
     *     getJSON({
               succeed: function(json) {
                   resolve(json);
               },
               fail: function(errorMessage) {
                   reject(new Error(errorMessage));
               }
           });
     * });
     */
    joyr.Promise = function (resolveRejectCallback) {
        var _value;
        var _reason;
        var _state = joyr.Promise.States.PENDING;
        this._successCallbacks = [];
        this._failCallbacks = [];
        this._finallyCallbacks = [];

        /**
         * Get the value of the Promise. It's undefined if the Promise is not in the FULFILLED state.
         * @returns {*} The value of the Promise.
         * @member {joyr.Promise}
         * @method
         */
        this.value = function () {
            return _value;
        };
        /**
         * Get the reason why the Promise was rejected. It's undefined if the Promise is not in the REJECTED state.
         * @returns {*} The reason for failure of the Promise.
         * @member {joyr.Promise}
         * @method
         */
        this.reason = function () {
            return _reason;
        };
        /**
         * Get the state of the Promise.
         * @returns {joyr.Promise.States} the state of the Promise: PENDING, FULFILLED or REJECTED.
         * @member {joyr.Promise}
         * @method
         */
        this.state = function () {
            return _state;
        };

        var _this = this;
        this.resolve = function (value) {
            if (_state !== joyr.Promise.States.PENDING) {
                return;
            }
            _state = joyr.Promise.States.FULFILLED;
            _value = value;
            _this.processCallbacks();
        };

        this.reject = function (reason) {
            if (_state !== joyr.Promise.States.PENDING) {
                return;
            }
            _state = joyr.Promise.States.REJECTED;
            _reason = reason;
            _this.processCallbacks();
        };

        var _resolve = function (value) {
            _this.resolve(value);
        };

        var _reject = function (value) {
            _this.reject(value);
        };

        if (typeof resolveRejectCallback === 'function') {
            try {
                resolveRejectCallback(_resolve, _reject);
            } catch (e) {
                _this.reject(e);
            }
        }
    };

    /**
     * The possible states in which a Promise can be.
     * @enum {number}
     * @readonly
     */
    joyr.Promise.States = {
        /** The underlying asynchronous operation has not yet finished */
        PENDING: 0,
        /** The underlying asynchronous operation completed successfully */
        FULFILLED: 1,
        /** The underlying asynchronous operation failed */
        REJECTED: 2
    };

    /**
     * Adds a callback to the Promise that will be invoked when it transits to the FULFILLED state, or immediately
     * if it is already in that state.<br />
     * This method is just a simplifed way of calling
     * [<code>then(callback, undefined, undefined)</code>]{@link joyr.Promise#then}.
     * @param {Function} callback - The callback that will be invoked.
     * @returns {joyr.Promise} - A new promise chained to the current one.
     */
    joyr.Promise.prototype.done = function (callback) {
        return this.then(callback);
    };

    /**
     * Adds a callback to the Promise that will be invoked when it transits to the REJECTED state, or immediately
     * if it is already in that state.<br />
     * This method is just a simplifed way of calling
     * [<code>then(undefined, callback, undefined)</code>]{@link joyr.Promise#then}.
     * @param {Function} callback - The callback that will be invoked.
     * @returns {joyr.Promise} - A new promise chained to the current one.
     */
    joyr.Promise.prototype.Catch = function (callback) {
        return this.then(undefined, callback);
    };

    /**
     * Adds a callback to the Promise that will be invoked when it completes, whether fulfilled or rejected, or
     * immediately if the Promise is already in one of those two states.<br />
     * This method is just a simplifed way of calling
     * [<code>then(undefined, undefined, callback)</code>]{@link joyr.Promise#then}.
     * @param {Function} callback - The callback that will be invoked.
     * @returns {joyr.Promise} - A new promise chained to the current one.
     */
    joyr.Promise.prototype.Finally = function (callback) {
        return this.then(undefined, undefined, callback);
    };

    /**
     * Executes a callback function when the Promise reaches one of the completed states (FULFILLED or REJECTED).
     * If the Promise fulfills and <code>success</code> is a function, it will be called with the value of the Promise
     * as its only argument. If it fails, and <code>fail</code> is a function, it will be called with the reason of the
     * rejection as its only argument. If <code>always</code> is a function, it will be called in either case,
     * and both the value and the reason will be passed as arguments, though one of them will be always
     * <code>undefined</code>, depending on whether the Promise suceeded or not.<br />
     * This method returns a new Promise chained to the current one. This Promise will fulfill or reject depending on:
     * <ul>
     * <li>If the callback going to be executed (<code>success</code> or <code>fail</code>) returns something, and
     * that something is not a <em>thenable</em>, the value returned will be the value which with the returning
     * Promise will fulfill. If it returns nothing, the value will be <code>undefined</code>.</li>
     * <li>If the callback going to be executed (<code>success</code> or <code>fail</code>) returns something, and
     * that something is a <em>thenable</em>, then the returned Promise will fulfill or reject depending on whether
     * that <em>thenable</em> fulfill or rejects, and with the same value / reason.</li>
     * <li>If the callback going to be executed (<code>success</code> or <code>fail</code>) throws an uncaught
     * exception, the returned Promise will reject with the <code>Error</code> object representing the exception
     * as its reason.</li>
     * <li>If the callback going to be executed is not a function, then the new Promise will keep the same state
     * as the current Promise, and the same value / reason.</li>
     * <li>If only <code>always</code> has value, then the returned Promise will never fulfill or reject.</li>
     * </ul>
     * @param {Function} [success] - The callback that will be invoked when the Promise fulfills.
     * @param {Function} [fail] - The callback that will be invoked when the Promise fails.
     * @param {Function} [always] - A callback that will be invoked in any case.
     * @returns {joyr.Promise} A new Promise chained to the current one.
     */
    joyr.Promise.prototype.then = function (success, fail, always) {
        var promise = new joyr.Promise();
        if (typeof success === 'function') {
            success._promise = promise;
        } else {
            success = {value: success, _promise: promise};
        }
        if (typeof fail === 'function') {
            fail._promise = promise;
        } else {
            fail = {value: fail, _promise: promise};
        }

        this._successCallbacks.push(success);
        this._failCallbacks.push(fail);
        if (typeof always === 'function') {
            this._finallyCallbacks.push(always);
        }

        if (this.state() !== joyr.Promise.States.PENDING) {
            this.processCallbacks();
        }
        return promise;
    };

    joyr.Promise.prototype.processCallbacks = function () {
        var _this = this;
        if (_this.state() === joyr.Promise.States.PENDING) {
            return;
        }
        var callback;
        setTimeout(function () {
            if (_this.state() === joyr.Promise.States.FULFILLED) {
                while (_this._successCallbacks.length) {
                    callback = _this._successCallbacks.shift();
                    _this._call(callback, true);
                }
            } else {
                while (_this._failCallbacks.length) {
                    callback = _this._failCallbacks.shift();
                    _this._call(callback, false);
                }
            }
            //final callbacks, if any
            while (_this._finallyCallbacks.length) {
                callback = _this._finallyCallbacks.shift();
                try {
                    callback(_this.value(), _this.reason());
                } catch (e) {} //ignore errors happening here.
            }
        }, 0);
    };

    joyr.Promise.prototype._call = function (callback, bFulfilled) {
        if (!callback._promise) {
            return;
        }
        if (typeof callback !== 'function') {
            if (bFulfilled) {
                callback._promise.resolve(this.value());
            } else {
                callback._promise.reject(this.reason());
            }
            return;
        }
        try {
            var result = callback(bFulfilled ? this.value() : this.reason());
            resolve(callback._promise, result);
        } catch (e) {
            callback._promise.reject(e);
            if (window.console) {
                console.log(e);
            }
        }
    };

    /**
     * Create a promise that fulfills when all the promises passed fulfill, and rejects otherwise. This method
     * admits a comma-separated list of objects as arguments, or an array. If an array is passed as the first
     * argument, the rest of the arguments are ignored.<br />
     * In case a non promise-like object is passed, it will be treated as a fulfilled Promise and the value
     * of such Promise.<br />
     * If the returned Promise fulfills, its value will be an array with the values of all passed promises in the
     * same order as they were passed as arguments or in the array. If it rejects, the reason will be the reason
     * of the first internal Promise that rejects.
     * @returns {joyr.Promise} a Promise that awaits for all the passed promises.
     */
    joyr.Promise.all = function () {
        var promise = new joyr.Promise();
        var list = (Object.prototype.toString.call(arguments[0]) === '[object Array]') ? arguments[0] : arguments;
        var results = new Array(list.length);
        var pending = 0;
        for (var i = 0; i < list.length; i++) {
            (function (i) {
                var _promise = list[i];
                if (_promise && (typeof _promise.then === 'function')) { //thenable, promise-like object
                    pending++;
                    _promise.then(function (value) {
                        results[i] = value;
                        pending--;
                        if (!pending) {
                            promise.resolve(results);
                        }
                    }, function (error) {
                        promise.reject(error);
                    });
                } else {
                    results[i] = _promise;
                }
            })(i);
        }

        return promise;
    };

    /**
     * Create a promise that always fulfills, and whose value will be an array composed of either the value of
     * the corresponding Promise (if it fulfilled) or null (if it rejected). This method admits a comma-separated
     * list of objects as arguments, or an array. If an array is passed as the first argument, the rest of
     * the arguments are ignored.<br />
     * In case a non promise-like object is passed, it will be treated as a fulfilled Promise and the value
     * of such Promise.<br />
     * @returns {joyr.Promise} a Promise that, when fulfilled, will have as its value the values of all the promises
     * that fulfilled
     */
    joyr.Promise.onlyFulfilled = function () {
        var promise = new joyr.Promise();
        var list = (Object.prototype.toString.call(arguments[0]) === '[object Array]') ? arguments[0] : arguments;
        var results = new Array(list.length);
        var pending = 0;
        for (var i = 0; i < list.length; i++) {
            (function (i) {
                var _promise = list[i];
                if (_promise && (typeof _promise.then === 'function')) { //thenable, promise-like object
                    pending++;
                    _promise.then(function (value) {
                        results[i] = value;
                        pending--;
                        if (!pending) {
                            promise.resolve(results);
                        }
                    }, function () {
                        results[i] = null;
                        pending--;
                        if (!pending) {
                            promise.resolve(results);
                        }
                    });
                } else {
                    results[i] = _promise;
                }
            })(i);
        }

        return promise;
    };

    /**
     * Create a promise that rejects when all the promises passed reject, and fulfills otherwise. This method
     * admits a comma-separated list of objects as arguments, or an array. If an array is passed as the first
     * argument, the rest of the arguments are ignored.<br />
     * In case a non promise-like object is passed, it will be treated as a fulfilled Promise and will also be the
     * value of such Promise.<br />
     * If the returned Promise fulfills, its value will be the value of the first Promise that fulfils.
     * If it rejects, the reason will be null, as this method is intended to wait for only one operation os many
     * alternatives to fulfill, and so the reasons of the failure are not important.
     * @returns {joyr.Promise} a Promise that awaits for just one of the passed promises.
     */
    joyr.Promise.any = function () {
        var promise = new joyr.Promise();
        var list = (Object.prototype.toString.call(arguments[0]) === '[object Array]') ? arguments[0] : arguments;
        var pending = 0;
        for (var i = 0; i < list.length; i++) {
            var _promise = list[i];
            pending++;
            if (_promise && (typeof _promise.then === 'function')) { //thenable, promise-like object
                _promise.then(function (value) {
                    promise.resolve(value);
                }, function () {
                    pending--;
                    if (!pending) {
                        promise.reject();
                    }
                });
            } else {
                promise.resolve(_promise);
            }
        }

        return promise;
    };

    /**
     * Creates a promise in the rejected state.
     * @param {Error} reason - The reason for the error. It might be of any type, but it is best if is an Error object.
     * @returns {joyr.Promise} A rejected Promise.
     */
    joyr.Promise.rejected = function (reason) {
        return new joyr.Promise(function (resolve, reject) {
            reject(reason);
        });
    };

    /**
     * Creates a Promise in the FULFILLED state.
     * @param {*} value - The value of the Promise.
     * @returns {joyr.Promise} A fulfilled promise.
     */
    joyr.Promise.resolved = function (value) {
        return new joyr.Promise(function (resolve) {
            resolve(value);
        });
    };

    /**
     * Turns any object into a Promise.
     * @param {Object} o - The object that will inherit Promise capabilities.
     */
    joyr.Promise.makePromise = function (o) {
        joyr.Promise.call(o);
    };

    /**
     * Creates a proxy {@link joyr.Promise} for any <em>thenable</em> object.<br />
     * A <em>thenable</em> is any object that can act as a Promise, meaning it has a <code>then</code> method
     * that can receive two callbacks, one for success and other for rejection. A jQuery <code>Deferred</code> is
     * an example of <em>thenable</em>.<br />
     * The main purpose of this method is to turn promise-like objects that are not Promise/A+ compliant
     * into {@link joyr.Promise} objects
     * @param {Object} thenable - The <em>thenable</em> object that will control the Promise being created. If the
     * it is not a <em>thenable</em> object, the returned Promise will reject with a javascript Error.
     * @returns {joyr.Promise} a Promise that acts as a proxy of the passed <em>thenable</em>.
     */
    joyr.Promise.cast = function (thenable) {
        var promise = new joyr.Promise();
        try {
            thenable.then(function (value) {
                promise.resolve(value);
            }, function (reason) {
                promise.reject(reason);
            });
        } catch (error) {
            promise.reject(error);
        }

        return promise;
    };

})(window.joyr);

/**
 *
 * @namespace
 */

/** global inditex */
/** global jQuery */
/** global $ */
(function (joyr) {

    'use strict';

    /**
     * This namespace defines methods for promise-based access to Inditex e-commerce REST API.
     * Every method defined in this namespace returns a Promise/A+ compliant promise object.
     * When a promise returned by these methods fulfills, the value (returned by the promise's
     * 'value()' method or passed to the success callbacks added
     * through 'then()' or 'done()' methods) will contain an object with the data returned by
     * the server. This object is the one described in the 'returns' section of each method.
     * If the request was a unary one, this 'value' will be, directly, the data returned by
     * the server. If the request contained two or more subrequests,
     * 'value' will be an array containing the different responses to each subrequest.
     * @namespace
     * @alias joyr.rest
     */
    var rest = {};

    /**
     * Check if array
     * @param obj
     * @returns {boolean}
     */
    function isArray(obj) {
        var str = Object.prototype.toString.call(obj);
        return str === '[object Array]';
    }

    /**
     * Parse error
     * @param message
     * @param code
     * @param key
     * @param causes
     * @param keepError
     * @returns {*}
     */
    function RestError(message, code, key, causes, keepError) {
        var err = Error.call(this, message);
        err.name = 'RestError';
        err.code = code;
        err.errorKey = key;
        err.errorMessage = message;
        err.causes = {};
        if (causes && causes.length && !keepError) {
            err.errorKey = causes[0].code;
            switch (err.errorKey) {
                case '_ERR_NEWSLETTER_SUBSCRIPTION_ALREADY_EXIST':
                    err.errorMessage = causes[0].description.replace('{0}', inditex.iStoreJSON.details.supportPhone);
                    break;
                default:
                    err.errorMessage = causes[0].description;
            }
        }

        return err;
    }

    try {
        if (!Object.create) {
            RestError.prototype = Error.prototype;
        } else {
            RestError.prototype = Object.create(Error.prototype, {
                constructor: { value: RestError }
            });
        }
    }
    catch (error) {
        RestError.prototype = Error.prototype;
    }

    /**
     * Execute request using inditex request utility
     * @param actions
     * @param {array} keepError - If true returns original error instead of manage it
     * @returns {*|Promise}
     */
    rest.xRestExecute = function (actions, keepError) {
        
        //if (actions.toString() != '[object array')
        return new joyr.Promise(function (resolve, reject) {
            inditex.execute({
                actions: actions,
                onFinish: function () {
                    
                    var status = arguments[0];
                    var results = [];
                    for (var i = 1; i < arguments.length; i++) {
                        results.push(arguments[i]);
                    }
                    if (status === 0) {
                        var error = (results && results[0]) ?
                            new RestError(results[0].description, results[0].code, results[0].key, results[0].causes, keepError) :
                            new RestError('generic error');
                        
                        reject(error);
                    }
                    else {
                        resolve(results);
                    }
                }
            });
        });
    };


    /**
     * Get geolocation of the current user.
     */
    rest.xGetGeolocation = function () {
        var action = {
            action: 'akamai:location'
        };
        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /*************************************************************/
    /* GET and SET requests                                      */
    /*************************************************************/

    /**
     * Gets the value of the variable varName
     * @param varName
     * @param inSessionStorage - with value true find in SessionStorage.
     */
    rest.xGet = function (varName, inSessionStorage) {
        if(inSessionStorage === true){
            try{
				return JSON.parse(sessionStorage.getItem(varName));
			} catch (e){ }
        }else{
            var action = {
                action: 'get',
                key: varName
            };

            return rest.xRestExecute([action]).done(function (values) {
                return values ? values[0] : null;
            });
        }
    };

    /**
     * Sets de value of the variable varName
     * @param varName - the name of the variable to set.
     * @param value - the value of the variable to set.
     * @param inSessionStorage - with value true save in SessionStorage.
     * @returns {*|Promise}
     */
    rest.xSet = function (varName, value, inSessionStorage) {
        if(inSessionStorage === true){
            try{
				return sessionStorage.setItem(varName, JSON.stringify(value));
			} catch (e){ }
        }else{
            var action = {
                action: 'set',
                key: varName,
                value: value
            };

            return rest.xRestExecute([action]);
        }
    };

    /*************************************************************/
    /* Catalog requests                                          */
    /*************************************************************/


    /**
     * Get category info returns a Category object
     * @param {number} categoryId - the ID of the category.
     */
    rest.xRestGetCategory = function (categoryId) {
        var action = {
            action: 'catalog:category',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get product list by category returns an array of products
     * @param {number} categoryId - the ID of the category.
     * @param {bool} [includeSubcategories=false] - whether to retrieve the products of child categories of not.
     */
    rest.xRestGetProductsByCategory = function (categoryId, includeSubcategories) {
        var action = {
            action: 'catalog:products',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId,
                withSubCategories: includeSubcategories || undefined,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].products;
        });
    };

    /**
    * Get category filters by categoryId
    * @param {number} categoryId - the ID of the category.
    */
    rest.xRestGetCategoryFilter = function (categoryId) {
        return new joyr.Promise(function (resolve, reject) {
            inditex.getCategoryFilter(categoryId, function (values) {
                resolve(values);
            });
        });
    };

    /**
     * Get product list by search term
     * @param {string} searchTerm - The search term to search for. It may be the name of a product, some keyword, the
     *  model ('1234') or a model/quality ('1234/234')
     * @param {number} [maxProducts] - indicates the maximum number of products to retrieve.
     */
    rest.xRestGetProductsByCriteria = function (searchTerm, maxProducts) {
        var action = {
            action: 'catalog:productsBySearchTerm',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                searchTerm: searchTerm,
                max: maxProducts,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].products;
        });
    };


    /**
     * Get product detail
     * @param {number} productId - the ID of the product to get.
     * @param {number} [categoryId=0] - The ID of a category the product is assigned to.
     */
    rest.xRestGetProductDetail = function (productId, categoryId) {
        var action = {
            action: 'catalog:productDetail',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId || 0,
                productId: productId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * get the stock of a list of products
     * @param {number|number[]} productId - A product ID or list of products IDs for which to retrieve the stocks.
     * @returns {Stock[]}
     */
    rest.xRestGetProductStock = function (productId) {
        var action = {
            action: null,
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                languageId: inditex.iLangId
            }
        };

        if (isArray(productId)) {
            action.action = 'catalog:productsStock';
            action.params.productIds = productId.join(',');
        } else {
            action.action = 'catalog:productStock';
            action.params.productId = productId;
        }

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].stocks;
        });
    };

    /**
     * get the stocks for the products of a given category
     * @param {number} categoryId - The ID of the category
     * @param {bool} [includeSubCategories=false] - Whether to include the stocks of products belonging to child
     *  categories
     * @return {Stock[]}
     */
    rest.xRestGetCategoryStock = function (categoryId, includeSubCategories) {
        var action = {
            action: 'catalog:categoryStock',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId,
                withSubCategories: includeSubCategories || false,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].stocks;
        });
    };


    /**
     * Request that an e-mail be sent to the user when the specified SKU is available again.
     * @param {number} categoryId - The ID of a category related to the product.
     * @param {number} productId - The ID of the product the SKU belongs to.
     * @param {number} skuId - The ID of the SKU in which the user is interested.
     * @param {number} [quantity] - Minimum number of items available. Only when at least the specified number of items
     *  exist in stock will the e-mail be delivered.
     * @param {Object} mailInfo - Information about the user requesting information.
     * @param {string} mailInfo.email - The e-mail address of the user.
     * @param {string} [mailInfo.name] - The name of the user.
     */
    rest.xRestRequestStockNotification = function (categoryId, productId, skuId, quantity, mailInfo) {
        if (mailInfo == null) {
            return Promise.rejected(new RestError('[mailInfo] cannot be null'));
        }
        var action = {
            action: 'catalog:stockNotification',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                categoryId: categoryId,
                productId: productId,
                languageId: inditex.iLangId
            },
            data: {
                'sku': skuId,
                'email': mailInfo.email,
                quantity: quantity || undefined,
                name: mailInfo.name || undefined,
                
            }
        };

        return rest.xRestExecute([action]);
    };

    /*************************************************************/
    /* Coming Soon Back Soon requests                            */
    /*************************************************************/

    rest.xRestStockNotificationRequest = function(email) {
        var action = {
            action: 'user:stockNotificationRequest',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'email': email
            }
        };

        return rest.xRestExecute([action]);
    };

    rest.xRestStockNotificationRequestConfirmation = function(email, hashCode){
        var action = {
            action: 'user:stockNotificationConfirmation',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'email': email,
                'hashValue': hashCode || undefined
            }
        };
        return rest.xRestExecute([action]);
    };

    rest.xRestStockNotificationDelete = function(email, hashCode) {
        var action = {
            action: 'user:stockNotificationDelete',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId,
                email: email,
                hashValue: hashCode || undefined
            }
        };
        return rest.xRestExecute([action]);
    };

    /*************************************************************/
    /* OAM requests                                              */
    /*************************************************************/

    /**
     * Get the value of an XCONFIGURACION variable.
     * @param {string|string[]} varName - The name (or names, if it is an array of strings) of the variable(s).
     * @returns {Object} - returns an object with the variable value if a single variable was passed, or an object
     *  acting as map of name/value pairs if an array was passed.
     */
    rest.xRestGetXConfiguration = function (varName) {
        if ($.isArray(varName)) {
            return rest.xRestGetXConfigurationValues(varName);
        }
        var action = {
            action: 'oam:xconfiguracion',
            params: {
                storeId: inditex.iStoreId,
                variable: varName,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].value;
        });
    };

    /**
     * Get the values of an array of XCONFIGURACION variables.
     * @param {string[]} varNameArray - an array of names of the variables to retrieve.
     * @returns {Object} - a map of name/value pairs, the name being the variable's name and the value, an object
     *  containing its value.
     */
    rest.xRestGetXConfigurationValues = function (varNameArray) {
        //use the session storage (if available) as cache
        var cache;
        if (window.sessionStorage) {
            cache = JSON.parse(window.sessionStorage.getItem('X_CONF_CACHE'));
        }
        cache = cache || {};
        var result = {};
        var _auxArray = [];
        for (var i = 0; i < varNameArray.length; i++) {
            var varName = varNameArray[i];
            if (cache.hasOwnProperty(varName)) {
                result[varName] = cache[varName];
            } else {
                _auxArray.push(varName);
            }
        }

        if (_auxArray.length) {
            var action = {
                action: 'oam:xconfiguracion',
                params: {
                    storeId: inditex.iStoreId,
                    variable: _auxArray,
                    languageId: inditex.iLangId
                }
            };

            return rest.xRestExecute([action]).done(function (data) {
                var resultArray = data[0];
                var name;
                if ($.isArray(resultArray)) {
                    for (var i = 0; i < resultArray.length; i++) {
                        var keyValue = resultArray[i];
                        name = keyValue.key.replace(new RegExp(' ', 'g'), '_');
                        cache[name] = result[name] = keyValue.value;
                    }
                } else {
                    name = resultArray.key.replace(new RegExp(' ', 'g'), '_');
                    cache[name] = result[name] = resultArray.value;
                }

                //save cache
                if (window.sessionStorage) {
                    window.sessionStorage.setItem('X_CONF_CACHE', JSON.stringify(cache));
                }
                return result;
            });
        } else {
            return new joyr.Promise(function (resolve, reject) {
                resolve(result);
            });
        }

    };

    /*************************************************************/
    /* BAM requests                                              */
    /*************************************************************/

    /**
     * Get a collection of physical stores for an online store.
     * @param {Object} criteria - Criteria for narrowing the search.
     * @param {bool} [criteria.favouriteStores=false] - If true, the favourite stores of the user are included in the
     *  results. Only valid for registered users.
     * @param {bool} [criteria.lastStores=false] - If true, the last stores used in previous orders are included in
     *  the results. Only valid for registered users.
     * @param {bool} [criteria.closerStores] - If true, returns the closest stores, based on longitude and
     *  latitude properties.
     * @param {number} [criteria.latitude] - The latitude of the point from which to search. Mandatory if
     *  closerStores is true.
     * @param {number} [criteria.longitude] - The longitude of the point from which to search. Mandatory if
     *  closerStores is true.
     * @param {number} min - The minimum desired number of stores to get.
     * @param {number} max - The maximum desired number of stores to get.
     * @param {number} radioMax - The maximum distance to search stores for.
     * @param {bool} [receiveEcommerce] - If true, the result list will exclude any stores that don't receive
     *  e-commerce orders.
     * @param {bool} [showBlockedMaxPackage] - If true, the receiveEcommerce param is ignored. Returns all 
     * the stores and indicates if the store is blocked by maximum package in the flag isBlocked.
     * @param {string} [countryCode] - If included, the result list will include only stores belonging to the
     *  indicated country.
     * @returns {Object} - An object with three arrays: favouriteStores, lastStores and closerStores, containing
     *  Store objects. The array may be empty depending on the options passed.
     */
    rest.xRestGetPhysicalStores = function (criteria) {
        var action = {
            action: 'bam:physicalStores1',
            params: {
                storeId: inditex.iStoreId,
                favouriteStores: criteria.favouriteStores || false,
                lastStores: criteria.lastStores || false,
                closerStores: criteria.closerStores || false,
                latitude: criteria.latitude,
                longitude: criteria.longitude,
                min: criteria.min,
                max: criteria.max,
                radioMax: criteria.radioMax,
                receiveEcommerce: criteria.receiveEcommerce,
                showBlockedMaxPackage: criteria.showBlockedMaxPackage,
                countryCode: criteria.countryCode,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get information about a physical store.
     * @param {number} physicalStoreId - The ID of the physical store.
     */
    rest.xRestGetPhysicalStore = function (physicalStoreId) {
        var action = {
            action: 'bam:physicalStore',
            params: {
                storeId: inditex.iStoreId,
                physicalStoreId: physicalStoreId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get list of all physical stores in country.
    */
    rest.xRestGetPhysicalStoresByCountry = function () {
        var action = {
            action: 'bam:physicalStores2',
            params: {
                storeId: inditex.iStoreId,
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    //get the stock for a given SKU in a number of physical stores.
    //paramters:
    // * sku: the ID of the SKU to search for.
    // * latitude: optional. The latitude of the centre from which to search for stores.
    //   If 0, null or undefined, will be ignored.
    // * longitude: optional. The longitude of the centre from which to search for stores.
    //   If 0, null or undefined, will be ignored.
    // * min: the minimum number of stores where to check the stock. Optional.
    //   If 0, null or undefined will be ignored.
    // * max: the maximum number of stores where to check the stock.
    // * countryCode: the code of the country of the stores to check. Optional.
    //   If 0, null or undefined will be ignored.
    //returns an array containing:
    // * physicalStore: a PhysicalStore object.
    // * sizes: an array of BamStockSize objects.
    /**
     * Get the stock for a given SKU in a collection of closers stores.
     * @param {number} skuId - The ID of the SKU to search for.
     * @param {Object} criteria - The criteria to search for stores.
     * @param {number} [criteria.latitude] - The latitude of the central point of the search.
     * @param {number} [criteria.longitue] - The longitude of the central point of the search.
     * @param {number} criteria.max - The maximum number of stores to get.
     * @param {number} [criteria.min] - The minimum number of stores to get.
     * @param {string} [countryCode] - The country to which the search will be restricted.
     * @returns {Object} - An object containing an array of PhysicalStore (physicalStore) and an array of
     *  BamStockSize (sizes).
     */
    rest.xRestGetStock = function (skuId, criteria) {
        if (!criteria) {
            return Promise.rejected(new RestError('Paramater [criteria] must be included'));
        }
        var action = {
            action: 'bam:bamStock',
            params: {
                storeId: inditex.iStoreId,
                cantentryId: skuId,
                latitude: criteria.latitude || undefined,
                longitude: criteria.longitude || undefined,
                min: criteria.min || undefined,
                max: criteria.max,
                countryCode: criteria.countryCode || undefined,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get a list of droppoints close to the indicated postal code.
     * @param {string} countryCode - The code of the country in which to search.
     * @param {string} postalCode - The Postal code to use for searching.
     * @param {string} [city] - The city to user for searching.
     * @param {number} [longitude] - The longitude of the central point of the search.
     * @param {number} [latitude] - The latitude of the central point of the search.
     */
    rest.xRestGetDroppoints = function (countryCode, postalCode, city, latitude, longitude) {
        var action = {
            action: 'bam:dropPoint',
            params: {
                storeId: inditex.iStoreId,
                countryCode: countryCode,
                postalCode: postalCode,
                latitude: latitude || undefined,
                longitude: longitude || undefined,
                city: city || undefined,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].dropPoints;
        });
    };

        /**
     * Get a list of droppoints classified by type
     * @param {DropPointParams} parameters An object with parameters for drop point search.
     * @param {string} [DropPointParams.countryCode] The code of the country in which to search.
     * @param {string} [DropPointParams.postalCode] The Postal code to use for searching.
     * @param {string} [DropPointParams.city] The city to user for searching.
     * @param {number} [DropPointParams.longitude] The longitude of the central point of the search.
     * @param {number} [DropPointParams.latitude] The latitude of the central point of the search.
     */
    rest.xRestGetDroppointList = function(parameters) {
        var action = {
            action: 'bam:dropPointLists',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            }
        }

        // read the 'configurations' array and determine which parameters to send
        var params = null;
        for (var i = 0; i < inditex.iStoreJSON.configurations.length; i++) {
            var configuration = inditex.iStoreJSON.configurations[i];
            if (configuration.parametro === 'dropPointParameters') {
                params = configuration.valor && configuration.valor.split('|');
            }
        }

        if (!params) {
            return joyr.Promise.rejected(new Error('drop point parameters not configured'));
        }
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            action.params[param] = parameters[param] || undefined;
        }

        return joyr.rest.xRestExecute([action]).done(function (data) {
            var result = [];
            for (var i = 0; i < data[0].providers.length; i++) {
                var group = data[0].dropPoints[data[0].providers[i]];
                if (group && group.droppointInfo) {
                    Array.prototype.push.apply(result, group.droppointInfo);
                }
            }
            return result;
        });
    };

    //search for available Drop points.
    //If Postal code is not null or undefined, it will look for drop points near it.
    //Otherwise, it will search based on state, municipality and colony.
    //returns an array of DropPoint.
    /**
     * Search for available drop points. If 'postalCode' is included, it'll be used  for the search and state,
     * municipality and colony will be ignored. If not included, the other three parameters are mandatory.
     * @param {string} [countryCode='MX'] - The code of the country in which to search.
     * @param {string} [postalCode] - The postal code in which to search for drop points.
     * @param {string} [stateName] - The name of the state in which to search. Mandatory if 'postalCode' is not
     *  included.
     * @param {string} [municipalityName] - The name of the municipality in which to search. Mandatory if 'postalCode'
     *  is not included.
     * @param {string} [colonyName] - The name of the colony in which to search. Mandatory if 'postalCode' is not
     *  included.
     */
    rest.xRestGetItxDropPoints = function (countryCode, postalCode, stateName, municipalityName, colonyName) {
        var action = {
            action: 'bam:dropPointItx',
            params: {
                storeId: inditex.iStoreId,
                countryCode: countryCode || 'MX',
                state: stateName,
                municipality: municipalityName,
                colony: colonyName,
                postalCode: postalCode || undefined,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0].dropPoints;
        });
    };

    /*************************************************************/
    /* User requests                                             */
    /*************************************************************/

    /**
     * Performs a guest login. The property inditex.iUserJSON will be updated accordingly.
     */
    rest.xRestGuestLogin = function () {
        var action = {
            action: 'user:loginGuest',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Perform a logout of the current user.
     */
    rest.xRestLogout = function () {
        var action = {
            action: 'user:logout',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            //HOTFIX VIP.. 
            sessionStorage.removeItem('VIPCART');

            return undefined;
        });
    };

    //register a new user.
    //the format of the userData parameter can be consulted in the Inditex REST API documentation
    //It doesn't return anything. If everything goes all right, the user will be automatically logged in,
    //and the property inditex.iUserJSON will be updated accordingly
    /**
     * Register a new user. The property inditex.iUserJSON will be updated accordingly.
     * @param {Object} userData - Information about the user to be registered
     * @param {Object} [options] - Extra options for registering.
     * @param {bool} [options.rememberMe] - if true, and allowed by the current store, the user will be logged
     *  permanently with a long term cookie.
     * @param {string} [options.emailGuestUser] - The e-mail of the current anonymous user, used for buying as a guest.
     *  Including this parameter will cause the orders purchased by the anoymous user to be associated to the user
     *  being registered.
     * @param {string} [options.guestToken] - the guestToken associated with a guest order id. It is used to associate
     *  an order with the user being registered, when the guest user is not in session anymore. Requires orderId.
     * @param {number} [options.orderId] - The ID of the order that will be associated with the user being registered.
     *  Requires guestToken.
     */
    rest.xRestRegister = function (userData, options) {
        var action = {
            action: 'user:register',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: userData
        };

        if (options) {
            if (options.rememberMe && inditex.iStoreJSON.details.rememberMe === '1') {
                action.data.rememberMe = '1';
            }
            if (options.migrationGuestUser) {
                action.data.migrationGuestUser = !!options.migrationGuestUser;
            }
            if (options.guestToken && options.orderId) {
                action.params.guestToken = options.guestToken;
                action.params.orderId = options.orderId;
            }
        }

        return rest.xRestExecute([action])
    };

    /**
     * Start the process to reset a forgotten password.
     * @param {string} email - The user's e-mail.
     * @param {string} type - reset via 'EMAIL' or 'SMS'
     * @param {Object} captcha
     */
    rest.xRestResetPassword = function (email, type, captcha) {
        var action = {
            action: 'user:resetPassword',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'email': email,
                'type': type || 'EMAIL'
            }
        };

        if (captcha) {
            // If captcha.captchaId, new captcha method is being used, so it has to send captchaId and captchaValue params
            if (captcha.captchaId) {
                action.data.captchaId = captcha.captchaId;
                action.data.captchaValue = captcha.captchaValue;
            } else {
                action.data.captcha = captcha.captchaValue === undefined ? ' ' : captcha.captchaValue;
            }
        }

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    rest.xRestResetPasswordPhone = function (phone) {
        var logon = inditex.iStoreJSON.details.phoneCountryCode + phone;
        var action = {
            action: 'user:resetPassword',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'logon': logon,
                'type': 'SMS'
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Completes the process of resetting the user's password. The Activation code is received by the user in the
     *  e-mail, usually as part of a link.
     * @param {string} email - The user's e-mail. Must be the same e-mail used to start the resetting process.
     * @param {string} activationCode - The activation code.
     * @param {string} newPassword - The new user's password.
     * @param {Object} captcha
     * @param {boolean} isCrm - Definde si la consulta está relacionada con servicios de Massimo Dutti Feel
     */
    rest.xRestUpdateResetUserPassword = function (email, activationCode, newPassword, captcha, isCrm) {
        var action = {
            action: 'user:updateResetUserPassword',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'email': email,
                'code': activationCode,
                'newPassword': newPassword,
                'newPasswordConfirm': newPassword
            }
        };

        // Elimina la propiedad "email" solo si es una operación vinculada a Massimo Dutti Feel
        if (isCrm) {
            delete action.data.email;
        }

        if (captcha) {
            // If captcha.captchaId, new captcha method is being used, so it has to send captchaId and captchaValue params
            if (captcha.captchaId) {
                action.data.captchaId = captcha.captchaId;
                action.data.captchaValue = captcha.captchaValue;
            } else {
                action.data.captchaResponse = captcha.captchaValue || undefined;
            }
        }

        return rest.xRestExecute([action]).done(function (data) {
            return undefined;
        });
    };

    rest.xRestUpdateResetUserPasswordPhone = function (phone, code, newPassword, captcha) {
        
        var logon = inditex.iStoreJSON.details.phoneCountryCode + phone;
        var action = {
            action: 'user:updateResetUserPassword',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'logon': logon,
                'code': code,
                'newPassword': newPassword,
                'newPasswordConfirm': newPassword
            }
        };

        if (captcha) {
            // If captcha.captchaId, new captcha method is being used, so it has to send captchaId and captchaValue params
            if (captcha.captchaId) {
                action.data.captchaId = captcha.captchaId;
                action.data.captchaValue = captcha.captchaValue;
            } else {
                action.data.captchaResponse = captcha.captchaValue || undefined;
            }
        }

        return rest.xRestExecute([action]).done(function (data) {
            return undefined;
        });
    };

    /**
     * Update the user's e-mail address.
     * @param {string} password - The user's password.
     * @param {string} newEmail - The user's new e-mail address.
     */
    rest.xRestUpdateUserEmail = function (password, newEmail) {
        var action = {
            action: 'user:updateUserEmail',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'password': password,
                'newEmail': newEmail,
                'newEmailConfirm': newEmail
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return undefined;
        });
    };

    /**
     * Updates the user's password.
     * @param {string} oldPassword - The user's current password.
     * @param {string} newPassword - The user's new password.
     * @param {Object} captcha - A captcha object containing the captcha information: the id (opt) and the text
     */
    rest.xRestUpdateUserPassword = function (oldPassword, newPassword, captcha) {
        var action = {
            action: 'user:updateUserPassword',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'oldPassword': oldPassword,
                'newPassword': newPassword,
                'newPasswordConfirm': newPassword
            }
        };

        if (captcha) {
            // If captcha.captchaId, new captcha method is being used, so it has to send captchaId and captchaValue params
            if (captcha.captchaId) {
                action.data.captchaId = captcha.captchaId;
                action.data.captchaValue = captcha.captchaValue;
            } else {
                action.data.captchaResponse = captcha.captchaValue === undefined ? ' ' : captcha.captchaValue;
            }
        }

        return rest.xRestExecute([action]);
    };

    rest.addressBookCache = [];
    rest.addressInfoCache = {};
    rest.xRestUseAddressCache = false;

    /**
     * Get the current user's address book.
     */
    rest.xRestGetAddressBook = function (fromCache) {
        if (fromCache && rest.addressBookCache.length) {
            return new joyr.Promise(function (resolve) {
                resolve(rest.addressBookCache);
            });
        }

        var action = {
            action: 'user:addressBook',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId,
                t: Date.now()
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            //FIXME:Extract this funcionality to a utility method
            if (inditex.iCountryCode === 'KR') {
                for (var i = 0; i < data[0].addresses.length; i++) {
                    data[0].addresses[i].addressLines[0] = data[0].addresses[i].city + (data[0].addresses[i].addressLines[0] !== '-' ? ' ' + data[0].addresses[i].addressLines[0] : '');
                }
            }
            rest.addressBookCache = data[0].addresses;
            return data[0].addresses;
        });
    };

    /**
     * Get an address by its ID.
     * @param {string} addressId - The ID of the address to get.
     * @param {bool} [forceCommerce=false] - If true, indicates that the address is a commerce address, not a wallet
     *  address.
     * @param {string} [guestToken] - This parameter must be included to get an address associated with an order
     *  purchased by a guest user, when the guest user is no longer on session. Requires 'orderId'.
     * @param {number} [orderId] - The ID of the order to which the address being requested is associated. Requires
     *  'guestToken'.
     */
    rest.xRestGetAddressInfo = function (addressId, forceCommerce, guestToken, orderId) {
        var key;
        if (rest.xRestUseAddressCache) {
            key = addressId + ((forceCommerce) ? '_f' : '');
            var promise = rest.addressInfoCache[key];
            if (promise) {
                return promise;
            }
        }

        var action = {
            action: 'user:addressInfoById',
            params: {
                storeId: inditex.iStoreId,
                addressId: addressId,
                forceCommerce: forceCommerce ? '1' : undefined,
                languageId: inditex.iLangId
            }
        };

        if (guestToken && orderId) {
            action.action = 'user:addressInfoByIdGuest';
            action.params.guestToken = guestToken;
            action.params.orderId = orderId;
        }

        return (rest.addressInfoCache[key] = rest.xRestExecute([action]).done(function (data) {
            //FIXME:Extract this funcionality to a utility method
            if (inditex.iCountryCode === 'KR' && data[0]) {
                data[0].addressLines[0] = data[0].city + (data[0].addressLines[0] !== '-' ? ' ' + data[0].addressLines[0] : '');
            }
            return data[0];
        }));
    };

    /**
     * Sets the invoiced receiving option for the current user.
     * @param {bool} receiveInvoice - Whether the user will receive invoices from now on, or not.
     */
    rest.xRestSetInvoiceReceive = function (receiveInvoice) {
        var action = {
            action: 'user:receiveNotReceiveInvoice',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'invoice': receiveInvoice ? '1' : '0'
            }
        };

        return rest.xRestExecute([action]);
    };



    /**
     * Confirms a subscription to the newsletter.
     * @param {string} email - The e-mail address of the user.
     * @param {string} newsletter - The name of the newsletter.
     * @param {bool} fromMyAccount - If true, indicates that the user that is subscribing is the current logged
     *  user. In this case, a previous call to {@link joyr.rest.xRestSubscribeToNewsletter} is not required.
     * @param {string} [hashCode] - the hash code that identifies the request. Required if 'fromMyAccount' is set
     *  to false, ignored otherwise.
     */
    rest.xRestSubscribeToNewsletterConfirmation = function (email, newsletter, fromMyAccount, hashCode) {
        var action = {
            action: 'user:subscribeNewsletterConfirmation',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'address': {
                    'email': email
                },
                'newsletter': newsletter,
                'myAccount': fromMyAccount,
                'hashValue': fromMyAccount ? undefined : hashCode
            }
        };

        return rest.xRestExecute([action]);
    };

    /**
     * Confirms an unsubscription to the newsletter.
     * @param {string} email - The e-mail address of the user.
     * @param {bool} fromMyAccount - If true, indicates that the user that is unsubscribing is the current logged
     *  user. In this case, a previous call to {@link joyr.rest.xRestUnsubscribeToNewsletter} is not required.
     * @param {string} [hashCode] - the hash code that identifies the request. Required if 'fromMyAccount' is set
     *  to false, ignored otherwise.
     */
    rest.xRestUnsubscribeToNewsletterConfirmation = function (email, fromMyAccount, hashCode) {
        var action = {
            action: 'user:unsubscribeNewsletterConfirmation',
            params: {
                storeId: inditex.iStoreId,
                email: email,
                myAccount: fromMyAccount,
                hashValue: fromMyAccount ? undefined : hashCode,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]);
    };


    /*********************************************************************/
    /* ORDER REQUESTS                                                    */
    /*********************************************************************/


    rest.shippingMethodsCache = {};

    /**
     * Get the list of restricted methods by zip code. In China, it searchs by district instead.
     * @param {string} zipCode - The zip code (or district) for which to search.
     * @param {boolean} [searchRestricted=false] - If true, the search returns the restricted methods for that zip code
     * @param {boolean} [ignoreCache=false] - If true, ignores cache and asks again for methods
     *  (or district), if any. It it is false, it will return the allowed methods.
     * @returns {ShippingMethod[]} - An array of shipping methods.
     */

    rest.xRestGetShippingMethodsByZipCode = function (zipCode, searchRestricted, ignoreCache) {
        var _restricted = zipCode + (searchRestricted ? '_1' : '_0');
        if(!ignoreCache) {
            var promise = rest.shippingMethodsCache[_restricted];
            if (promise) {
                return promise;
            }
        }

        var action = {
            action: 'order:shippingMethods2',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                zipCode: zipCode,
                searchType: searchRestricted ? 1 : 0,
                languageId: inditex.iLangId
            }
        };

        return (rest.shippingMethodsCache[_restricted] = rest.xRestExecute([action]).done(function (data) {
            return data[0].shippingMethods;
        }));
    };

    /**
     * Get the available payment modes for a specific payment method.
     * @param {number} orderId - The ID of the order.
     * @param {string} paymentType - The type of payment, as in the property PaymentMethod.type.
     * @param {string} cardNumber - The number or the card to user for payment.
     * @param {string} vatin - The vatin associated with the card.
     * @param {number} [orderAmount] - The amount to pay
     * @returns {PaymentMode[]} - An array of PaymentMode.
     */
    rest.xRestGetPaymentModes = function (orderId, paymentType, cardNumber, vatin, orderAmount) {
        var action = {
            action: 'order:paymentModes',
            params: {
                storeId: inditex.iStoreId,
                orderId: orderId,
                policy: paymentType,
                languageId: inditex.iLangId
            },
            data: {
                'number': cardNumber,
                'vatin': vatin,
                'amount': orderAmount || undefined
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get an Order
     * @param {number} orderId - The ID of the order.
     * @param {bool} [withSuborders=false] - If true and the order has suborders, then each orderItem will have
     *  a differente suborderId, even if they have the same SKU. If false (the default), orderIterms will be
     *  grouped by their SKU.
     * @returns {Order} - An Order.
     */
    rest.xRestGetOrder = function (orderId, withSuborders) {
        var action = {
            action: 'order:order',
            params: {
                storeId: inditex.iStoreId,
                orderId: orderId,
                languageId: inditex.iLangId
            }
        };

        if (withSuborders) {
            action.params.suborders = true;
        }

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get an Order made by a guest user no longer in session.
     * @param {number} orderId - The ID of the order.
     * @param {number} guestToken - The token for the order.
     * @param {bool} [withSuborders=false] - If true and the order has suborders, then each orderItem will have
     *  a different suborderId, even if they have the same SKU. If false (the default), orderIterms will be
     *  grouped by their SKU.
     * @returns {Order} - An Order.
     */
    rest.xRestGetOrderGuest = function (orderId, guestToken, withSuborders) {
        var action = {
            action: 'order:orderGuest',
            params: {
                storeId: inditex.iStoreId,
                orderId: orderId,
                tokenGuest: guestToken,
                languageId: inditex.iLangId
            }
        };

        if (withSuborders) {
            action.params.suborders = true;
        }

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Get an order for the confirmation phase or the purchase process.
     * @param {number} orderId - The ID of the order.
     * @param {bool} [withSuborders=false] - If true and the order has suborders, then each orderItem will have
     *  a different suborderId, even if they have the same SKU. If false (the default), orderIterms will be
     *  grouped by their SKU.
     * @returns {Order} - An Order object with extended properties.
     */
    rest.xRestGetOrderConfirmation = function (orderId, withSuborders) {
        var action = {
            action: 'order:orderConfirmation',
            params: {
                storeId: inditex.iStoreId,
                catalogId: inditex.iCatalogId,
                orderId: orderId,
                languageId: inditex.iLangId
            }
        };

        if (withSuborders) {
            action.params.suborders = true;
        }

        return rest.xRestExecute([action]).done(function (data) {
            var order = data[0];
            return data[0];
        });
    };

    /**
     * Add gift packing and/or custom message to an order.
     * @param {number} orderId - The ID of the order.
     * @param {string} [message] - The custom message. If not set, it will be deleted.
     * @param {bool} [onlyMessage] - If true, only the custom message will be set, not the gift packing.
     */
    // rest.xRestAddGiftPacking = function (orderId, message, onlyMessage) {
    //     var action = {
    //         action: 'order:addGiftpacking',
    //         params: {
    //             storeId: inditex.iStoreId,
    //             orderId: orderId,
    //             message: message || '',
    //             onlyMessage: onlyMessage,
    //             languageId: inditex.iLangId
    //         }
    //     };

    //     return rest.xRestExecute([action]);
    // };

    /**
     * Delete the gift packing and/or custom message from an order.
     * @param {number} orderId - The ID of the order.
     * @param {bool} onlyGiftPacking - If true, deletes only the gift packing.
     * @param {bool} [onlyMessage] - If true, deletes only the custom message.
     */
    // rest.xRestDeleteGiftPacking = function (orderId, onlyGiftPacking, onlyMessage) {
    //     var action = {
    //         action: 'order:deleteGiftPacking',
    //         params: {
    //             storeId: inditex.iStoreId,
    //             orderId: orderId,
    //             languageId: inditex.iLangId,
    //             onlyGiftPacking: onlyGiftPacking || undefined,
    //             onlyMessage: onlyMessage || undefined
    //         }
    //     };

    //     return rest.xRestExecute([action]);
    // };

    /**
     * Sets or unsets the gift ticket option for an order.
     * @param {number} orderId - The ID of the order.
     * @param {bool} giftTicket - Whether to set (true) or unset (fals) the gift ticket option.
     */
    // rest.xRestSetGiftTicket = function (orderId, giftTicket) {
    //     var action = {
    //         action: 'order:getGiftTicket',
    //         params: {
    //             storeId: inditex.iStoreId,
    //             orderId: orderId,
    //             gifticket: giftTicket ? 1 : 0,
    //             languageId: inditex.iLangId
    //         }
    //     };

    //     return rest.xRestExecute([action]);
    // };

    /**
     * Get order from barcode (GiftTicket)
     * @param {string} barcode - The text of the barcode.
     * @param {string} captcha - The text of the captcha.
     */
    rest.xRestGetOrderIdFromBarCode = function (barcode, captcha) {
        var action = {
            action: 'order:getOrderIdfromBarcode',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId,
                barcode: barcode,
                captcha: captcha
            }
        };

        return rest.xRestExecute([action]);
    };

    /**
     * Get information about the payment method used to purchase an order.
     * @param {number} orderId - The ID of the order.
     */
    rest.xRestGetPaymentSelected = function (orderId) {
        var action = {
            action: 'order:paymentSelected',
            params: {
                storeId: inditex.iStoreId,
                orderId: orderId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /********************************************************************/
    /* BOOKING REQUESTS                                                 */
    /********************************************************************/

    /**
     * Get stock information about a product in physical stores.
     * @param {Object[]} stores - An array of PhysicalStore objects. The stores in which to search.
     * @param {string} campaign - The season part of a partnumber: In '0123412312303-V2016' would be 'V2016'
     * @param {string} partNumber - The partnumber of the product, without the season. In '0123412312303-V2016'
     *  would be '0123412312303'.
     */
    rest.xRestStockPhysicalStore = function (stores, campaign, partNumber) {

        return rest.xRestGetXConfiguration(joyr.constants.rest.REST_STOCK_PRODUCT_PHSTORE_URL)
            .done(function (result) {
                var urlStock = result.replace('_campaign_', campaign).replace('_part-number_', partNumber);
                var physicalStoreIds = '?';
                for (var i = 0; i < stores.length; i++) {
                    var store = stores[i];
                    physicalStoreIds += 'physicalStoreId=' + store.id + '&';
                }
                var action = {
                    action: urlStock + physicalStoreIds
                };
                return rest.xRestExecute([action]).done(function (data) {
                    return (data[0]);
                });
            });
    };

    /********************************************************************/
    /* GIFT CARD REQUESTS                                               */
    /********************************************************************/

    /**
     * Get information about the physical gift card in this store. If no catalog is specified, the current
     * catalog will be used.
     * @param {number} [catalogId] - The ID of a catalog from which the get the information.
     * @returns {Product} - a product object representing the gift card with its different prices.
     */
    rest.xRestGetPhysicalGiftCard = function (catalogId) {
        var action = {
            action: 'giftCard:physicalGiftCard',
            params: {
                storeId: inditex.iStoreId,
                catalogId: catalogId || inditex.iCatalogId,
                languageId: inditex.iLangId
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };
    /**
     * Adds a physical gift cart to the shopping cart.
     * @param {number} sku - The ID of the SKU representing the gift card.
     * @param {number} quantity - The number of items to add to the shopping cart.
     * @param {Object} sendInfo - Information about the sender and receiver of the gift card.
     * @param {string} sendInfo.senderName - The name of the sender.
     * @param {string} sendInfo.receiverName - The name of the receiver.
     * @param {string} sendInfo.receiverPhone - The phone number of the receiver.
     * @param {string} sendInfo.message - A personal message for the receiver.
     * @param {boolean} quantity - user logged or not
     */
    rest.xRestAddPhysicalGiftCardToShopCart = function (sku, quantity, sendInfo, logged) {
        if (!sendInfo) {
            return Promise.rejected(new RestError('The parameter [sendInfo] must be passed.'));
        }
        if (inditex.iUserJSON.identity.userId === -1002 && !logged) {
            return joyr.rest.xRestGuestLogin().done(function () {
                return joyr.rest.xRestAddPhysicalGiftCardToShopCart(sku, quantity, sendInfo, true);
            });
        }
        var action = {
            action: 'giftCard:addPhysicalGiftCardToShopCart',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'sku': sku,
                'quantity': quantity,
                'senderName': sendInfo.senderName,
                'receiverName': sendInfo.receiverName,
                'receiverPhone': sendInfo.receiverPhone,
                'message': sendInfo.message
            }
        };

        return rest.xRestExecute([action]);
    };

    //updates the data for a specific physical gift card, identified by its order item ID.
    //all parameters are optional. If any parameter is set to undefined, it'll be ignored and its original value
    //won't be modified
    /**
     * Modify the data about a specific physical gift card in the shopcart. All parameters but orderItemId are
     *  optional. If not included they'll keep their original values.
     * @param {number} orderItemId - The ID of the order item representing the gift card.
     * @param {number} [quantity] - The number of items to add to the shopping cart.
     * @param {Object} [sendInfo] - Information about the sender and receiver of the gift card.
     * @param {string} [sendInfo.senderName] - The name of the sender.
     * @param {string} [sendInfo.receiverName] - The name of the receiver.
     * @param {string} [sendInfo.receiverPhone] - The phone number of the receiver.
     * @param {string} [sendInfo.message] - A personal message for the receiver.
     */
    rest.xRestUpdatePhysicalGiftCard = function (orderItemId, quantity, sendInfo) {
        var action = {
            action: 'giftCard:updatePhysicalGiftCardData',
            params: {
                storeId: inditex.iStoreId,
                orderItemId: orderItemId,
                languageId: inditex.iLangId
            },
            data: {
                'quantity': quantity || undefined,
                'senderName': (sendInfo && sendInfo.senderName) ? sendInfo.senderName : undefined,
                'receiverName': (sendInfo && sendInfo.receiverName) ? sendInfo.receiverName : undefined,
                'receiverPhone': (sendInfo && sendInfo.receiverPhone) ? sendInfo.receiverPhone : undefined,
                'message': (sendInfo && sendInfo.message) ? sendInfo.message : undefined
            }
        };

        return rest.xRestExecute([action]);
    };

    /**
     * Get the balance of gift card.
     * @param {string} cardNumber - The number of the card.
     * @param {number} cvv - The CVV2 code of the card.
     * @param {string} [catpcha] - The text of the captcha, if any.
     */
    rest.xRestGetGiftCardBalance = function (cardNumber, cvv, captcha) {
        var action = {
            action: 'giftCard:giftCardBalance',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'number': cardNumber,
                'cvv': cvv,
                'captchaResponse': captcha || ''
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /**
     * Activate a gift card.
     * @param {string} cardNumber - The number of the card.
     * @param {number} cvv - The CVV2 code of the card.
     * @param {string} activationCode - The activation code for the card.
     * @param {string} [catpcha] - The text of the captcha, if any.
     */
    rest.xRestActiveGiftCard = function (cardNumber, cvv, activationCode, captchaResponse) {
        var action = {
            action: 'giftCard:activateGiftCard',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                'number': cardNumber,
                'cvv': cvv,
                'activationCode': activationCode,
                'captchaResponse': captchaResponse === undefined ? undefined : captchaResponse
            }
        };

        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };

    /********************************************************************/
    /* WALLET REQUESTS                                                  */
    /********************************************************************/

    /**
     * Get the content of an URL the returned promise, when fulfilled, will contain the contents of the URL
     * @param url
     * @returns {Promise}
     */
    rest.xRestGetJSONP = function (url) {
        return new joyr.Promise(function (resolve) {
            var callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
            window[callbackName] = function (data) {
                delete window[callbackName];
                document.body.removeChild(script);
                resolve(data);
            };
            var script = document.createElement('script');
            script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
            document.body.appendChild(script);
        });
    };


    /**
     * Validates ActivationCode
     * @param {string} validationCode - the validation code
     * @param {string} email - the email to reset
     * @param {number} type - validation type
     * @returns {Promise}  - The object to construct klarna objects
     */
    rest.xRestValidateSMSCode = function (validationCode, email, type) {
        var action = {
            action: 'user:validateSMSCode',
            params: {
                storeId: inditex.iStoreId,
                languageId: inditex.iLangId
            },
            data: {
                data : {mail: email},
                validationCode: validationCode,
                type: type
            }
        };
        
        return rest.xRestExecute([action]).done(function (data) {
            return data[0];
        });
    };
    
    joyr.rest = rest;

})(window.joyr);


(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.utils
     */
    var utils = {
        /**
         * Este método permite formatear precios en el formato adecuado para la tienda 
         * @function formatPrice
         * @return {string} Precio formateado
         * @param {number} Price - Precio a formatear 
         * @param {string} classWrapperToCurrency - Envolvería con un span (si no se le indica otro tag mediante el tercer parámetro) el símbolo monetario con la clase pasada.
         * @param {string} tagWrapperToCurrency - Envolvería con este tag el símbolo monetario, con la clase pasada en el segundo párametro.
         * @example inditex.formatprice(495);
         */
        formatPrice : function(price,classWrapperToCurrency,tagWrapperToCurrency) {
            var self = this;
            var num = new Number(price);
            var s = Math.abs(num).toString();
            var locale = inditex.iStoreJSON.details.locale;
            var decimals = Math.abs(locale.currencyDecimals);
            var pattern = price >= 0 ? locale.currencyFormatPosHtml
                    : locale.currencyFormatNegHtml;
            var i, max;
            var result;
            var sint, sdec, fint, fdec;
            var prefix, suffix;
            var tmp;
            var grouping;
            var gchar;
            var dchar;
            var sustCurr;
            
            gchar = inditex.iStoreJSON.details.locale.currencygroupingCharHtml ? inditex.iStoreJSON.details.locale.currencygroupingCharHtml : ",";
            dchar = inditex.iStoreJSON.details.locale.currencydecimalCharHtml ? inditex.iStoreJSON.details.locale.currencydecimalCharHtml : ".";
            if(classWrapperToCurrency){
                tagWrapperToCurrency = tagWrapperToCurrency || "span";
                sustCurr = "<"+tagWrapperToCurrency+" class='"+classWrapperToCurrency+"'>"+inditex.iStoreJSON.details.locale.currencySymbolHtml+"</"+tagWrapperToCurrency+">";
            }
            
            tmp = pattern.match(/[#0][#0,.]*[#0]/)[0];
            i = tmp.indexOf(".");
            if (i == -1) {
                fint = tmp;
                fdec = "";
            } else {
                fint = tmp.substring(0, i);
                fdec = tmp.substring(i + 1);
            }

            i = fint.lastIndexOf(",");
            if (i == -1) {
                grouping = 0;
            } else {
                grouping = fint.length - 1 - i;
            }

            max = decimals + 1 - s.length;
            for (i = 0; i < max; i++) {
                s = "0" + s;
            }

            i = s.length - decimals;

            sint = s.substring(0, i);
            sdec = s.substring(i);

            result = "";
            max = sint.length;
            for (i = 0; i < max; i++) {
                if (i > 0 && grouping > 0 && ((max - i) % grouping) == 0) {
                    result += gchar;
                }

                result += sint[i];
            }

            if (self.iForceCurfmtdescNumberpattern == '0') {
                max = Math.max(fdec.replace(/#/g, "").length, sdec.length);
            } else {
                max = Math.max(fdec.replace(/#/g, "").length, Math.min(fdec.length,
                        sdec.length));
            }

            for (i = 0; i < max; i++) {
                if (i == 0) {
                    result += dchar;
                }
                result += sdec[i] ? sdec[i] : "0";
            }

            result = pattern.replace(/[#0][#0,.]*[#0]/, result);
            if(sustCurr){
                result = result.split(inditex.iStoreJSON.details.locale.currencySymbolHtml).join(sustCurr);
            }
            return result;
        },
        /**
         * Get pageName url
         * @throws {ReferenceError} [[Description]]
         * @param {string} pageName
         * @param {boolean} isMobile
         * @param {boolean} isAjax
         * @returns {String}
         */
        getCommonPageUrl: function (pageName, isMobile, isAjax) {
            if (!pageName) {
                throw new ReferenceError('Missing parameter: pageName');
            }

            return inditex.encodeUrl({
                action : pageName,
                params : {
                    storeId : inditex.iStoreId,
                    langId : inditex.iLangId,
                    catalogId : inditex.iCatalogId
                },
                isMobile : isMobile ? isMobile : false,
                isAjax : isAjax ? isAjax : false
            });
        },
        /**
         * Get operating system using userAgent browser(iOS or Android)
         * @throws {ReferenceError} [[Description]]
         * @param {string} userAgent
         * @returns {String}
         */
        getOperatingSystem: function (userAgent) {
            if (!userAgent) {
                throw new ReferenceError('Missing parameter: userAgent');
            }
            if (userAgent.match(/iPhone|iPad|iPod/i)) {
                return 'iOS';
            }
            if (userAgent.match(/Android/i)) {
                return 'android';
            }
            return;
        },
        /** Find a category in category tree
         * @throws {ReferenceError} [[Description]]
         * @param {integer} categoryId
         * @param {array} categories
         * @returns {object}
         */
        findCategory: function (categoryId, categories) {
            if (!categoryId) {
                throw new ReferenceError('Missing parameter: categoryId');
            }
            if (!categories) {
                throw new ReferenceError('Missing parameter: categories');
            }
            var categoryJSON = null;
            
            var categoryArray = [];
            for (var i = 0; i < categories.length; i++){
                categoryArray.push(categories[i]);
            }

            while (categoryArray.length>0){ 
                categoryJSON = categoryArray.splice(0,1)[0];
                //console.log('CatArray',categoryJSON)
               
                if (categoryJSON.id == categoryId){
                   
                    return categoryJSON;
                } else {
                    if (categoryJSON.subcategories && categoryJSON.subcategories.length>0){
                        for (var i = 0; i < categoryJSON.subcategories.length; i++){
                            categoryArray.push(categoryJSON.subcategories[i]);
                        }
                    }
                                    
                }
            }
            
            return null;
        },
        /**
         * Gets the value of the variable varName
         * @param varName
         */
        getData: function (varName) {
            return new joyr.Promise(function (resolve, reject) {
                var value = inditex.readCookie(varName);
                resolve(value);
            });
        },
        /**
         * Sets de value of the variable varName
         * @param varName - the name of the variable to set.
         * @param value - the value of the variable to set.
         * @returns {*|Promise}
         */
        setData: function (varName, value) {
            return new joyr.Promise(function (resolve) {
                inditex.writeCookie(varName, value);
                resolve();
            });
        },

        /**
         * Extends an object with properties from another. Similar to jQuery.extend().
         * @param {object} oDest - The object to be extended. This object won't be modified.
         * @param {object} oSource - The object to extend the oDest. This object won't be modified.
         * @returns A clone of oDest with the extended properties.
         */
        extend: function(oDest, oSource) {
            if (!oSource) {
                oSource = {};
            }
            if (!oDest) {
                oDest = oSource;
                oSource = {};
            }

            var result = {};
            for (var prop in oDest) {
                var sourceProp = oSource[prop];
                result[prop] = sourceProp || oDest[prop];
            }

            // add properties in oSource not in oDest
            if (oSource) {
                for (var prop in oSource) {
                    if (!(prop in oDest)) {
                        result[prop] = oSource[prop];
                    }
                }
            }

            return result;
        }
    };

    joyr.utils = utils;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.constants
     */
    var constants = {

        product: {
            /** ProductBean */
            PRODUCT_BEAN: 'ProductBean',

            /** BundleBean */
            BUNDLE_BEAN: 'BundleBean'
        },

        user: {
            /** GUEST */
            GUEST: 'G',

            /** SEMI_GUEST */
            SEMI_GUEST: 'S',

            /** REGISTER */
            REGISTER: 'R',

            /** WALLET */
            WALLET: 'W',

            /** SEMI_WALLET */
            SEMI_WALLET: 'WS'
        },

        rest: {
            /** VAR XCONF FULL_ADDRESS_MASK */
            FULL_ADDRESS_MASK: 'FULL_ADDRESS_MASK',

            /** VARIABLE XCONF URL SERVICIO REST STOCK EN TIENDA FISICA */
            REST_STOCK_PRODUCT_PHSTORE_URL: 'REST_STOCK_PRODUCT_PHSTORE_URL'
        },

        visibility: {
            /** HIDDEN VISIBILITY ID */
            HIDDEN_VISIBILITY : 'hidden',

            /** SOLD_OUT VISIBILITY ID */
            SOLD_OUT_VISIBILITY : 'sold_out',

            /** SHOW VISIBILITY ID */
            SHOW_VISIBILITY : 'show',

            /** BACK_SOON VISIBILITY ID */
            BACK_SOON_VISIBILITY : 'back_soon',

            /** COMMING_SOON VISIBILITY ID*/
            COMMING_SOON_VISIBILITY : 'coming_soon',

            /** DISABLED VISIBILITY ID */
            DISABLED_VISIBILITY : 'disabled'
        },

        store: {
            /** SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK */
            SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK: 'SHOW',
            /** SHOW PRODUCT SIZES WITH NO STOCK  */
            SHOW_PRODUCT_SIZES_SKU_NO_STOCK: 'SHOW'
        },

        filters: {
            /** COLOR_TYPE_FILTER */
            COLOR_TYPE_FILTER: 'XCOLFILTER',
            ATTR_TYPE_FILTER: ['XCATFILTER', 'XCALFILTER', 'XTYPEFILTER']
        },

        order: {
            /** MORE_RELEVANT_ORDERING */
            MORE_RELEVANT_ORDERING: 'MORE_RELEVANT',

            /** NEWER_ORDERING */
            NEWER_ORDERING: 'NEWER',

            /** PRICE_ORDERING */
            PRICE_ORDERING: 'PRICE'
        },

        shippingMethods: {
            PICKUP: 'pickup',
            DELIVERY: 'delivery',
            DROPPOINT: 'droppoint',
            DROPBOX: 'dropbox',
            ITXDROPPOINT: 'itxdroppoint',
            DEFINED_DELIVERY_DATE: 'defineddeliverydate'
        },

        paymentMethods: {
            CREDIT_CARD: 'credit_card',
            CREDIT_CARD_INSTALLMENTS: 'credit_card_installments',
            CREDIT_CARD_INSTALLMENTS_UNIQUEID: 'credit_card_installments_uniqueID',
            AFFINITY: 'affinity',
            PAYPAL: 'paypal',
            SOFORT: 'sofort',
            KACCOUNT: 'kaccount',
            KINVOICE: 'kinvoice',
            IDEAL: 'ideal',
            P24: 'p24',
            POD: 'POD',
            COD: 'COD',
            ALIPAY_WALLET: 'Alipay_Wallet',
            ALIPAY_MOBILE: 'Alipay_Mobile',
            ALIPAY_QR: 'Alipay_QR',
            ALIPAY_INTERNATIONAL: 'Alipay_International',
            ALIPAY_BANKS: 'Alipay_Banks',
            WALLET_CARD: 'walletcard',
            KCPC: 'KCPCyberSource',
            GIFT_CARD: 'gift_card',
            MULTIBANK: 'multibanco',
            OXXO:'OXXO_payments',
            WECHAT: 'Wechat_Quick',
            BANCONTACT: 'Bancontact_card',
            BANCONTACT_QR: 'Bancontact_QR',
            KLARNA_PAY_LATER: 'KlarnaPayLater',
            KLARNA_SLICE_IT: 'KlarnaSliceIt',
            PSE: 'PSE',
            sessionTypes: {
                CARDINAL: 'cardinal_session'
            },
            '2C2PAPM': '2C2PAPM'
        },

        defaultSizes: {
            XS: 1,
            S: 2,
            M: 3,
            L: 4,
            XL: 5,
            XXL: 6
        }
    };

    joyr.constants = constants;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.validation
     */
    var validation = {
        /**
         * Regular expressions
         * @namespace
         * @alias joyr.validation.regex
         */
        regex: {
            /**
             * Get email regular expression
             * @returns {RegExp}
             */
            email: function () {
                return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            },
            /**
             * Get phoneprefix expression
             * @returns {RegExp}
             */
            phonePrefix: function () {
                return /^\+\d{1,3}$/;
            },
            /**
             * Get password regular expression
             * @returns {RegExp}
             */
            password: function () {
                return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
            },
            /**
             * Get zipCodes regular expressions
             * @returns {Object}
             * @example
             * joyr.validation.regex.zipCode().AT
             */
            zipCode: function () {
                return {
                    AM : /^[0-9]{4}$/,
                    AT : /^[0-9]{4}$/,
                    AU : /^[0-9]{4}$/,
                    BE : /^[0-9]{4}$/,
                    BG : /^[0-9]{4}$/,
                    CA : /^.*$/,
                    CH : /^[0-9]{4}$/,
                    CY : /^[0-9]{4}$/,
                    CN : /^[0-9]{6}$/,
                    CZ : /^[0-9]{3} {0,1}[0-9]{2}$/,
                    DE : /^[0-9]{5}$/,
                    DK : /^[0-9]{4}$/,
                    DZ : /^[0-9]{5}$/,
                    EE : /^[0-9]{5}$/,
                    ES : /^[0-9]{5}$/,
                    ESCN : /^[0-9]{5}$/,
                    FI : /^(FI-){0,1}[0-9]{5}$/,
                    FR : /^[0-9]{5}$/,
                    GB : /^(GIR 0AA|[A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW]) {0,1}[0-9][ABD-HJLNP-UW-Z]{2})$/,
                    GR : /^[0-9]{5}$/,
                    HR : /^(HR-){0,1}[0-9]{5}$/,
                    HU : /^(H-){0,1}[0-9]{4}$/,
                    IC : /^[0-9]{5}$/,
                    IE : /^.*$/,
                    IN : /^[0-9]{6}$/,
                    IT : /^[0-9]{5}$/,
                    JP : /^([0-9]){3}[-]([0-9]){4}$/,
                    KR : /^([0-9]{5})|(([0-9]){3}[-]([0-9]){3})$/,
                    LT : /^(LT-){0,1}[0-9]{5}$/,
                    LU : /^(L-)?[0-9]{4}$/,
                    LV : /^(LV-){0,1}[0-9]{4}$/,
                    MC : /^[0-9]{5}$/,
                    MT : /^[A-Z]{3}\s?[0-9]{4}$/,
                    MX : /^[0-9]{5}$/,
                    MY : /^[0-9]{5}$/,
                    NL : /^[0-9]{4}\s?[A-Z]{2}$/,
                    NO : /^[0-9]{4}$/,
                    PH : /^[0-9]{4}$/,
                    PL : /^[0-9]{2}-?[0-9]{3}$/,
                    PT : /^[0-9]{4}-[0-9]{3}$/,
                    RU : /^[0-9]{6}$/,
                    SA : /^[0-9]{5}(-[0-9]{4})?$/,
                    SE : /^[0-9]{3}[ ]?[0-9]{2}$/,
                    SI : /^(SI-){0,1}[0-9]{4}$/,
                    SK : /^[0-9]{3} {0,1}[0-9]{2}$/,
                    TR : /^[0-9]{5}$/,
                    US : /^[0-9]{5}$/,
                    RO : /^[0-9]{6}$/,
                    TH : /^[0-9]{5}$/
                };
            },
            /**
             * Get phones regular expressions
             * @returns {Object}
             * @example
             * joyr.validation.regex.phone().ES
             */ 
            phone: function () {
                return {
                    AE : /^(\d{9,10}){1}$/,
                    AL : /^(\d{8,9}){1}$/,
                    AM : /^(\d{8}){1}$/,
                    AT : /^(\d{9,14}){1}$/,
                    AZ : /^(\d{9}){1}$/,
                    BA : /^(\d{8}){1}$/,
                    BE : /^(\d{9,10}){1}$/,
                    BG : /^(\d{1,9}){1}$/,
                    BH : /^(\d{8}){1}$/,
                    CA : /^(\d{9,14}){1}$/,
                    CO : /^(\d{7,10}){1}$/,
                    CH : /^(\d{9,13}){1}$/,
                    CY : /^(\d{8}){1}$/,
                    CZ : /^(\d{1,9}){1}$/,
                    CN : /^(?=\d{11}$)^1(?:3\d|4[57]|5[^4\D]|66|7[^249\D]|8\d|9[89])\d{8}$/,
                    DE : /^(\d{9,14}){1}$/,
                    DK : /^(\d{1,8}){1}$/,
                    DZ : /^(\d{9,10}){1}$/,
                    EE : /^(\d{1,8}){1}$/,
                    EG : /^(\d{10}){1}$/,
                    ES : /^(\d{9}){1}$/,
                    ESCN : /^(\d{9}){1}$/,
                    FI : /^(\d{1,10}){1}$/,
                    FR : /^(\d{9,10}){1}$/,
                    GB : /^(\d{9,11}){1}$/,
                    GR : /^(\d{9,10}){1}$/,
                    HK : /^([23569]{1})(\d{7})$/,
                    HR : /^(\d{1,10}){1}$/,
                    HU : /^(\d{1,9}){1}$/,
                    IC : /^(\d{9}){1}$/,
                    IE : /^(\d{9,12}){1}$/,
                    IL : /^(\d{8,10}){1}$/,
                    IT : /^(\d{9,12}){1}$/,
                    IN : /^(\d{10}){1}$/,
                    JO : /^(\d{8,9}){1}$/,
                    JP : /^([0]\d{1,10}){0,1}$/,
                    KR : /^(\d{10,11}){1}$/,
                    KW : /^(\d{8}){1}$/,
                    LB : /^(\d{2})( )?(\d{5,6}){1}$/,
                    LT : /^(\d{1,8}){1}$/,
                    LU : /^(\d{9,12}){1}$/,
                    LV : /^(\d{1,8}){1}$/,
                    MA : /^(\d{9}){1}$/,
                    MC : /^(\d{9,10}){1}$/,
                    MT : /^(\d{1,8}){1}$/,
                    MX : /^(\d{9,10}){1}$/,
                    NL : /^(\d{9,11}){1}$/,
                    NO : /^(\d{8}){1}$/,
                    PH : /^(\d{9,10}){1}$/,
                    PL : /^(\d{9,10}){1}$/,
                    PT : /^(\d{9,12}){1}$/,
                    RO : /^(\d{1,9}){0,1}$/,
                    RU : /^(\d{10}){1}$/,
                    SA : /^(\d{9}){1}$/,
                    SE : /^(\d{9,14}){1}$/,
                    SI : /^(\d{1,8}){1}$/,
                    SK : /^(\d{1,10}){1}$/,
                    TR : /^(\d{9}){1}$/,
                    US : /^(\d{9,12}){1}$/,
                    UA : /^(\d{9}){1}$/,
                    QA : /^(\d{8}){1}$/,
                    RS : /^(\d{9}){1}$/,
                    ID : /^(\d{10,12})$/,
                    KZ : /^(\d{10}){1}$/,
                    TN : /^(\d{8}){1}$/,
                    TW : /^(\d{9}){1}$/,
                    GE : /^(\d{9}){1}$/,
                    SG : /^(\d{8}){1}$/,
                    TH : /^(\d{10}){1}$/,
                    MK :  /^(\d{8}){1}$/,
                    MY :  /^(\d{8,10}){1}$/,
                    VN : /^(\d{9,10}){1}$/,
                    XK : /^(\d{8}){1}$/,
                };
            },
            /**
             * Get klarnaDate regular expressions
             * @returns {Object}
             * @example
             * joyr.validation.regex.klarnaDate().ES
             */
            klarnaDate: function () {
                return {
                    DE : /^[0-9]{8}$/,
                    AT : /^[0-9]{8}$/,
                    NL : /^[0-9]{8}$/,
                    NO : /^[0-9]{11}$/,
                    FI : /^[0-9]{6}[-]{0,1}[0-9A-Za-z]{4}/,
                    SE : /^[0-9]{10}$/,
                    DK : /^[0-9]{10}$/
                };
            },
            /**
             * Get nif regular expressions
             * @returns {Object}
             * @example
             *        validator = joyr.validation.regex.nif()[inditex.iStoreJSON.countryCode];
             *        if (result = validator.regExp.exec(modelValue)) {
             *            return validator.parse(result).isValid();
             *        }
             */
            nif: function () {
                return {
                    AE : {
                		regExp : /^([0-9]{15})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    AM : {
                        regExp : /^([a-zA-Z0-9]{2})[0-9]{7}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    }, 
                	AT : {
                		regExp : /^([a-zA-Z0-9]{2})?[a-zA-Z0-9]{9}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             /**
                             * 
                             * Format:
                             * A(1)+N(1-7)+C(1)
                             * A(1)={U}
                             * 
                             * Control:
                             * S=N(1)+2#N(2)+N(3)+2#N(4)+N(5)+2#N(6)+N(7)
                             * C(1)=10-(S+4)%10; if C(1)=10, C(1)=0
                             * 
                             * Ex:
                             * U12345675
                             */
                             
                        	 if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'AT') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 9) {
                        		 return false;
                        	 }
                        	                  			 
                 			 if (nifTemp[0] !== 'U' 
                 				 || !_.isFinite(Number(nifTemp[1])) 
                 				 || !_.isFinite(Number(nifTemp[2]))
                 				 || !_.isFinite(Number(nifTemp[3]))
                 				 || !_.isFinite(Number(nifTemp[4]))
                 				 || !_.isFinite(Number(nifTemp[5]))
                 				 || !_.isFinite(Number(nifTemp[6]))
                 				 || !_.isFinite(Number(nifTemp[7]))
                 				 || !_.isFinite(Number(nifTemp[8]))) {
                 				 return false;
                 			 }
                             
                             var s = Number(nifTemp[1]) +
                                getSostenido(2, Number(nifTemp[2])) +
                                Number(nifTemp[3]) + 
                                getSostenido(2, Number(nifTemp[4])) + 
                                Number(nifTemp[5]) +
                                getSostenido(2, Number(nifTemp[6])) +
                                Number(nifTemp[7]);

                             var res = 10 - (s + 4) % 10;
                             if (res === 10) {
                                res = 0;
                             }
 
                             return res === Number(nifTemp[8])
                         }
                	},
                	AU : {
                		regExp : /^\d{9}$/,
                		parse : function() {
                            return {
                            	isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    BE : {
                		regExp : /^[a-zA-Z0-9]{10}([a-zA-Z0-9]{2})?$/,
                		parse : function(result) {
                            return {
                            	nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             /*
                             * 
                             * Format:
                             * N(1-8)+C(1-2)
                             * N(2)>1
                             * 
                             * Control:
                             * C(1-2)=97-N(1-7)%97
                             */
                             
                        	 if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'BE') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 10) {
                        		 return false;
                        	 }
                             
                             if (!_.isFinite(Number(nifTemp[0])) 
                 				 || !_.isFinite(Number(nifTemp[1]))
                 				 || !_.isFinite(Number(nifTemp[2]))
                 				 || !_.isFinite(Number(nifTemp[3]))
                 				 || !_.isFinite(Number(nifTemp[4]))
                 				 || !_.isFinite(Number(nifTemp[5]))
                 				 || !_.isFinite(Number(nifTemp[6]))
                 				 || !_.isFinite(Number(nifTemp[7]))) {
                 				 return false;
                 			 }
                             
                             if (Number(nifTemp[1]) <= 1) {
                                 return false;
                             }
                             
                             var c = parseInt(nifTemp.substring(8,10));
                             var n = Number(nifTemp.substring(0,8));
                             n = 97 - n % 97;
                             
                             return n === c;
                         }
                	},
                    BG : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    CA : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    CH : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    CN : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    CY : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    CZ : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    DE : {
                        regExp : /^([a-zA-Z]{2})?[0-9]{9}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             /*
                             * 
                             * Format:
                             * N(1-8)+C(1)
                             * N(1-8)>0
                             * 
                             * Control:
                             * S=0
                             * FOR I=1 TO 8
                             * S=2*((N(I)+S+9)%10+1)%11
                             * NEXT I
                             * C(1)=11-S; if C(1)=10, C(1)=0
                             */
                             
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'DE') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 9) {
                        		 return false;
                        	 }
                             
                             if (Number(nifTemp.substring(0,8)) <= 0) {
                                return false;
                             }
                             
                             var s = 0;
                             for(var i = 1; i <= 8; i++) {
                                 s = 2 * ((Number(nifTemp[i-1]) + s + 9) % 10 + 1) % 11;
                             }
                             var t = Number(nifTemp[8]);
                             s = 11 - s;
                             
                             return (t == 0 && s == 10) || (t < 10 && t == s)
                         }
                    },
                    DK : {
                        regExp : /^([a-zA-Z]{2})?[0-9]{8}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             /*
                             * 
                             * Format:
                             * N(1-8)
                             * N(1)>0
                             * 
                             * Control:
                             * S=2*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)+N(8)
                             * if S%11=0, right
                             */
                             
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'DK') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 8) {
                        		 return false;
                        	 }
                             
                             var s = 2 * Number(nifTemp[0]) + 7 * Number(nifTemp[1]) + 6 * Number(nifTemp[2]) + 5 * Number(nifTemp[3]) + 4 * Number(nifTemp[4]) + 3 * Number(nifTemp[5]) + 2 * Number(nifTemp[6]) + Number(nifTemp[7]);
			                 s = s % 11;
                             
                             return s === 0;
                         }
                    },
                    EG : {
                        regExp : /^[0-9]{14}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    EE : {
                        regExp : /^EE[0-9]{9}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    ES : {
                        regExp : /^(([XYZ]{1})(\d{7})([A-Z]{1})|(\d{8})([A-Z]{1}))$/,
                        parse : function(result) {
                            var nieMap = {
                                X : 0,
                                Y : 1,
                                Z : 2
                            };
                            return {
                                number : result[0],
                                controlNumber : result[5] || nieMap[result[2]] + result[3],
                                controlKey : result[6] || result[4],
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return 'TRWAGMYFPDXBNJZSQVHLCKE'
                                    .charAt(this.controlNumber % 23) === this.controlKey;
                        }
                    },
                    FI : {
                        regExp : /^([a-zA-Z]{2})?[0-9]{8}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    FR : {
                        regExp : /^([a-zA-Z]{2})?[0-9a-zA-Z]{11}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'FR') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 11) {
                        		 return false;
                        	 }
                             
                             if (_.isFinite(Number(nifTemp[0])) && _.isFinite(Number(nifTemp[1]))) {
                                 /*
                                 * Old system
                                 * 
                                 * Format:
                                 * C(1-2)+N(1-9)
                                 * N(1-9)>0
                                 * 
                                 * Control:
                                 * C(1-2)=(N(1-9)*100+12)%97
                                 */
                                 
                                 if (!checkAllDigits(nifTemp)) {
                                     return false;
                                 }
                                 
                                 var x = Number(nifTemp.substring(0, 2));
                                 var y = Number(nifTemp.substring(2, 11));
                                 
                                 
                                 if (y <= 0) {
                                     return false;
                                 }
                                 
                                 var s = (y * 100 + 12) % 97;
                                 
                                 return s == x;
                             } else {
                                 /*
                                 * New system.
                                 * 
                                 * Format:
                                 * C(1-2)+N(1-9)
                                 * N(1-9)>0
                                 * C(1-2)={A-H,J-N,P-Z} | {0-9}
                                 * si C(1) es alfabetico, C(2) ha de ser numerico y al reves.
                                 * 
                                 * Control:
                                 * C{0-9,A-H,J-N,P-Z} ? C{0-33}
                                 * si C(1)<10, S=C(1)*24+C(2)-10
                                 * si C(1)>9, S=C(1)*34+C(2)-100
                                 * X=S%11
                                 * S=S\11+1
                                 * Y=(N(1-9)+S)%11
                                 * si X=Y, correcto
                                 */
                                 
                                 /**
                                 * Check if a char is a valid nif char
                                 * 
                                 * Valid chars: {A-H,J-N,P-Z}.
                                 *
                                 * @param {String} char 
                                 * @return {Boolean}
                                 */
                                 /**
                                 * Check if a char is a valid nif char
                                 * 
                                 * Valid chars: {A-H,J-N,P-Z}.
                                 *
                                 * @param {String} char 
                                 * @return {Boolean}
                                 */
                                 var checkNifFrValidChar = function(c) {
                                     var charNifFrancia = ['A','B','C','D','E','F','G','H','J','K','L','M','N','P','Q','R','S','T','U','V','W','Y','Z'];
                                     
                                     if (!c) {
                                         return false;
                                     }
                                     
                                     return charNifFrancia.indexOf(c.toUpperCase()) !== -1;
                                 }
                                 
                                 /**
                                  * 
                                  * @param {String}  char 
                                  * @return {Number}
                                  */
                                 var controlDigitFrToNumber = function(c) {
                                    var controlDigits = [['0', 0],
                                                         ['1', 1],
                                                         ['2', 2],
                                                         ['3', 3],
                                                         ['4', 4],
                                                         ['5', 5],
                                                         ['6', 6],
                                                         ['7', 7],
                                                         ['8', 8],
                                                         ['9', 9],
                                                         ['A', 10],
                                                         ['B', 11],
                                                         ['C', 12],
                                                         ['D', 13],
                                                         ['E', 14],
                                                         ['F', 15],
                                                         ['G', 16],
                                                         ['H', 17],
                                                         ['J', 18],
                                                         ['K', 19],
                                                         ['L', 20],
                                                         ['M', 21],
                                                         ['N', 22],
                                                         ['P', 23],
                                                         ['Q', 24],
                                                         ['R', 25],
                                                         ['S', 26],
                                                         ['T', 27],
                                                         ['U', 28],
                                                         ['V', 29],
                                                         ['W', 30],
                                                         ['X', 31],
                                                         ['Y', 32],
                                                         ['Z', 33]
                                                        ]; 
                                     
                                     var upperCaseChar = c.toUpperCase();
                                     
                                     return _.find(controlDigits, function(item) {
                                         return item[0] === upperCaseChar;
                                     })[1];
                                 }
                                 
                                 var x = nifTemp[0];
                                 var y = nifTemp[1];
                                 
                                 if (_.isFinite(Number(x))) {
                                     if (_.isFinite(Number(y))) {
                                         return false;
                                     } else {
                                         if (!checkNifFrValidChar(y)) {
                                             return false;
                                         }
                                     }
                                 } else {
                                     if (!_.isFinite(Number(y))) {
                                         return false;
                                     }
                                     if (!checkNifFrValidChar(x)) {
                                         return false;
                                     }
                                 }
                                 
                                 var z = Number(nifTemp.substring(2, 11));
                                 var controlDigit1 = controlDigitFrToNumber(x);
                                 var controlDigit2 = controlDigitFrToNumber(y);
                                 
                                 var s = 0;
                                 if (controlDigit1 < 10) {
                                     s = controlDigit1 * 24 + controlDigit2 - 10;
                                 } else {
                                     s = controlDigit1 * 34 + controlDigit2 - 100;
                                 }
                                 var result = s % 11;
                                 s = s / 11 + 1;
                                 s = (z + s) % 11;
                                 
                                 return result == s;
                             }
                             
                            
                         }
                    },
                    GB : {
                        regExp : /^./,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             var _this = this;
                             
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'GB') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                             
                             _this.NIF_TYPE_UNKNOWN = -1;
                             _this.NIF_TYPE_GB_GOB_DEP = 1;
                             _this.NIF_TYPE_GB_SAN_AUT = 2;
                             _this.NIF_TYPE_GB_STANDARD = 3;
                             _this.NIF_TYPE_GB_COMERCIAL_GROUP = 4;
                             _this.NIF_TYPE_GB_ISLE_OF_MAN = 5;
                             _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP = 6;
                             
                             function checkNifTypeGB(nif) {
                                 switch (nif.length) {
                                     case 5:
                                         var x = nif.charAt(0);
                                         var y = nif.charAt(1);

                                         if (x === 'G' && y === 'D') {
                                             return _this.NIF_TYPE_GB_GOB_DEP;
                                         }
                                         if (x === 'H' && y === 'A') {
                                             return _this.NIF_TYPE_GB_SAN_AUT;
                                         }
                                         return _this.NIF_TYPE_UNKNOWN;
                                     case 9:
                                         return _this.NIF_TYPE_GB_STANDARD;
                                     case 10:
                                         return _this.NIF_TYPE_GB_COMERCIAL_GROUP;
                                     case 12:
                                         return _this.NIF_TYPE_GB_ISLE_OF_MAN;
                                     case 13:
                                         return _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP;
                                     default:
                                         return _this.NIF_TYPE_UNKNOWN;
                                 }
                             }
                             
                             /**
                             * Gob dep
                             * 
                             * Format:
                             * A(1-2)+N(1-3)
                             * A(1-2)={GD}
                             * N(1-3)<500
                             */
                             function checkNifGBGobDep(nif) {
                                 if (nif.length !== 5) {
                                     return false;
                                 }
                                 
                                 if (nif[0] != 'G' || nif[1] != 'D'){
                                     return false;
                                 }
                                 
                                 if (!_.isFinite(Number(nif[2])) || !_.isFinite(Number(nif[3])) || !_.isFinite(Number(nif[4]))) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(2,5)) >= 500) {
                                     return false;
                                 }
                                 
                                 return true;
                             }
                             
                             /**
                             * San Aut
                             * 
                             * Format:
                             * A(1-2)+N(1-3)
                             * A(1-2)={HA}
                             * N(1-3)>499
                             */
                             function checkNifGBSanAut(nif) {
                                 if (nif.length !== 5) {
                                     return false;
                                 }
                                 
                                 if (nif[0] != 'H' || nif[1] != 'A'){
                                     return false;
                                 }
                                 
                                 if (!_.isFinite(Number(nif[2])) || !_.isFinite(Number(nif[3])) || !_.isFinite(Number(nif[4]))) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(2,5)) < 500) {
                                     return false;
                                 }
                                 
                                 return true;
                             }
                             
                             /**
                             * Standard
                             * 
                             * Format:
                             * N(1-9)
                             * N(1-7)={0000001-0019999,1000000-9999999}
                             * N(8-9)<97
                             * 
                             * Control:
                             * S=8*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)+10*N(8)+N(9)
                             * if S%97=0, valid
                             */
                             function checkNifGBStandard(nif) {
                                 if (nif.length !== 9) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nif)) {
                                     return false;
                                 }
                                 
                                 var x = Number(nif.substring(0,7));
                                 if ((x < 0) || (x >= 20000 && x < 1000000) || (x > 9999999)) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(7,9)) >= 97) {
                                     return false;
                                 }
                                 
                                 var s = 8 * Number(nif[0]) 
                                         + 7 * Number(nif[1]) 
                                         + 6 * Number(nif[2]) 
                                         + 5 * Number(nif[3]) 
                                         + 4 * Number(nif[4]) 
                                         + 3 * Number(nif[5]) 
                                         + 2 * Number(nif[6]) 
                                         + 10 * Number(nif[7]) 
                                         + Number(nif[8]);
                                 
                                 return s % 97 === 0;
                             }
                             
                             /**
                             * Comercial Group
                             * 
                             * Format:
                             * N(1-10)
                             * N(1-7)={0000001-0019999,1000000-9999999}
                             * N(8-9)<97
                             * N(10)={3}
                             * 
                             * Control:
                             * S=8*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)+10*N(8)+N(9)
                             * if S%97=0, valid
                             */
                             function checkNifGBComercialGroup(nif) {
                                 if (nif.length !== 10) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nif)) {
                                     return false;
                                 }
                                 
                                 var x = Number(nif.substring(0,7));
                                 if ((x < 0) || (x >= 20000 && x < 1000000) || (x > 9999999)) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(7,9)) >= 97) {
                                     return false;
                                 }
                                 
                                 if (Number(nif[9]) !== 3) {
                                     return false;
                                 }
                                 
                                 var s = 8 * Number(nif[0]) 
                                         + 7 * Number(nif[1]) 
                                         + 6 * Number(nif[2]) 
                                         + 5 * Number(nif[3]) 
                                         + 4 * Number(nif[4]) 
                                         + 3 * Number(nif[5]) 
                                         + 2 * Number(nif[6]) 
                                         + 10 * Number(nif[7]) 
                                         + Number(nif[8]);
                                 
                                 return s % 97 === 0;
                             }
                             
                             /**
                             * Isle of Man
                             * 
                             * Format:
                             * N(1-12)
                             * N(1-3)={000,001}
                             * N(4-10)={0000001-0019999,1000000-9999999}
                             * N(11-12)<97
                             * 
                             * Control:
                             * S=8*N(4)+7*N(5)+6*N(6)+5*N(7)+4*N(8)+3*N(9)+2*N(10)+10*N(11)+N(12)
                             * if S%97=0, valid
                             */
                             function checkNifGBIsleOfMan(nif) {
                                 if (nif.length !== 12) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nif)) {
                                     return false;
                                 }
                                 
                                 var x = Number(nif.substring(0, 3));
                                 if (x !== 0 && x !== 1) {
                                     return false;
                                 }
                                 
                                 var y = Number(nif.substring(3, 10));
                                 if ((y < 0) || (y >= 20000 && y < 1000000) || (y > 9999999)) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(10, 12)) >= 97) {
                                     return false;
                                 }
                                 
                                 var s = 8 * Number(nif[3]) 
                                         + 7 * Number(nif[4]) 
                                         + 6 * Number(nif[5]) 
                                         + 5 * Number(nif[6]) 
                                         + 4 * Number(nif[7]) 
                                         + 3 * Number(nif[8]) 
                                         + 2 * Number(nif[9]) 
                                         + 10 * Number(nif[10]) 
                                         + Number(nif[11]);
                                 
                                 return s % 97 === 0;
                             }
                             
                             /**
                             * Comercial Group Isle of Man
                             * 
                             * Format:
                             * N(1-13)
                             * N(1-3)={000,001}
                             * N(4-10)={0000001-0019999,1000000-9999999}
                             * N(11-12)<97
                             * N(13)={3}
                             * 
                             * Control:
                             * S=8*N(4)+7*N(5)+6*N(6)+5*N(7)+4*N(8)+3*N(9)+2*N(10)+10*N(11)+N(12)
                             * if S%97=0, valid
                             */
                             function checkNifGBIsleOfManComercialGroup(nif) {
                                 if (nif.length !== 13) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nif)) {
                                     return false;
                                 }
                                 
                                 var x = Number(nif.substring(0, 3));
                                 if (x !== 0 && x !== 1) {
                                     return false;
                                 }
                                 
                                 var y = Number(nif.substring(3, 10));
                                 if ((y < 0) || (y >= 20000 && y < 1000000) || (y > 9999999)) {
                                     return false;
                                 }
                                 
                                 if (Number(nif.substring(10, 12)) >= 97) {
                                     return false;
                                 }
                                 
                                 if (Number(nif[12]) !== 3) {
                                     return false;
                                 }
                                 
                                 var s = 8 * Number(nif[3]) 
                                         + 7 * Number(nif[4]) 
                                         + 6 * Number(nif[5]) 
                                         + 5 * Number(nif[6]) 
                                         + 4 * Number(nif[7]) 
                                         + 3 * Number(nif[8]) 
                                         + 2 * Number(nif[9]) 
                                         + 10 * Number(nif[10]) 
                                         + Number(nif[11]);
                                 
                                 return s % 97 === 0;
                             }
                             
                             switch (checkNifTypeGB(nifTemp)) {
                                 case _this.NIF_TYPE_GB_GOB_DEP:
                                     return checkNifGBGobDep(nifTemp);
                                 case _this.NIF_TYPE_GB_SAN_AUT: 
                                     return checkNifGBSanAut(nifTemp);
                                 case _this.NIF_TYPE_GB_STANDARD:
                                     return checkNifGBStandard(nifTemp);
                                 case _this.NIF_TYPE_GB_COMERCIAL_GROUP:
                                     return checkNifGBComercialGroup(nifTemp);
                                 case _this.NIF_TYPE_GB_ISLE_OF_MAN:
                                     return checkNifGBIsleOfMan(nifTemp);
                                 case _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP:
                                     return checkNifGBIsleOfManComercialGroup(nifTemp);
                                 case _this.NIF_TYPE_UNKNOWN:
                                     return false;
                                 default:
                                     return false;
                             }
                             
                             
                         }
                    },
                    GE : {
                        regExp : /^([0-9]{9}|[0-9]{11})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    GR : {
                        regExp : /^./,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'GR') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length === 8) {
                        		 /**
                                 * 7 digits
                                 * 
                                 * Format:
                                 * N(1-7)+C(1)
                                 * 
                                 * Control:
                                 * S=128*N(1)+64*N(2)+32*N(3)+16*N(4)+8*N(5)+4*N(6)+2*N(7)
                                 * C(1)=S%11; if C(1)=10, C(1)=0
                                 */
                                 if (nifTemp.length !== 8) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nifTemp)) {
                                     return false;
                                 }
                                 
                                 var s = 128 * Number(nifTemp[0]) 
                                         + 64 * Number(nifTemp[1]) 
                                         + 32 * Number(nifTemp[2]) 
                                         + 16 * Number(nifTemp[3]) 
                                         + 8 * Number(nifTemp[4]) 
                                         + 4 * Number(nifTemp[5]) 
                                         + 2 * Number(nifTemp[6]);
			                     
                                 s = s % 11;
                                 var x = Number(nifTemp[7]);
                                 
                                 return (s === 10 && x === 0) || (s === x);
                        	 } else {
                                 /**
                                 * 8 digits
                                 * 
                                 * Format:
                                 * N(1-8)+C(1)
                                 * 
                                 * Control:
                                 * S=256*N(1)+128*N(2)+64*N(3)+32*N(4)+16*N(5)+8*N(6)+4*N(7)+2*N(8)
                                 * C(1)=S%11; if C(1)=10, C(1)=0
                                 */
                                 if (nifTemp.length !== 9) {
                                     return false;
                                 }
                                 
                                 if (!checkAllDigits(nifTemp)) {
                                     return false;
                                 }
                                 
                                 var s = 256 * Number(nifTemp[0])
                                         + 128 * Number(nifTemp[1]) 
                                         + 64 * Number(nifTemp[2]) 
                                         + 32 * Number(nifTemp[3]) 
                                         + 16 * Number(nifTemp[4]) 
                                         + 8 * Number(nifTemp[5]) 
                                         + 4 * Number(nifTemp[6]) 
                                         + 2 * Number(nifTemp[7]);
			                     
                                 s = s % 11;
                                 var x = Number(nifTemp[8]);
                                 
                                 return (s === 10 && x === 0) || (s === x);
                             }
                         }
                    },
                    HR : {
                		regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    HU : {
                		regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    IC : {
                        regExp : /^(([XYZ]{1})(\d{7})([A-Z]{1})|(\d{8})([A-Z]{1}))$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                             
                             var validator = joyr.validation.regex.nif()['ES'];
                             var result = validator.regExp.exec(this.nif);
                             if (result) {
                                 return validator.parse(result).isValid();
                             }
                             return false;
                         }
                    },
                    IE : {
                		regExp : /^([a-zA-Z]{2})?[0-9a-zA-Z+*]{8}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             /**
                             * Ex
                             * IE9S99999L = IE + 8 digits. "S" can be a letter (A-Z), digit (0-9); "+" or "*"
                             */
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'IE') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                             
                             if (nifTemp.length !== 8) {
                                 return false;
                             }
                             
                             var irlandNif = ['W','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V'];
                             
                             if (_.isFinite(Number(nifTemp[1]))) {
                                 /**
                                 * New Nif
                                 * 
                                 * Format:
                                 * N(1-7)+C(1)
                                 * N(1-7)>0
                                 * 
                                 * Control:
                                 * S=8*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)
                                 * C(1)=S%23
                                 * C{0-22} ? C{W,A-V}
                                 */
                                 var x = nifTemp.substring(0,7);
                                 
                                 if (!checkAllDigits(x)) {
                                     return false;
                                 }
                                 
                                 if (Number(x) <= 0) {
                                     return false;
                                 }
                                 
                                 var s = 8 * Number(nifTemp[0])
                                        + 7 * Number(nifTemp[1]) 
                                        + 6 * Number(nifTemp[2]) 
                                        + 5 * Number(nifTemp[3]) 
                                        + 4 * Number(nifTemp[4]) 
                                        + 3 * Number(nifTemp[5]) 
                                        + 2 * Number(nifTemp[6]);
			                     
                                 s = s % 23;
                                 
                                 return irlandNif[s] === nifTemp[7];
                             } else {
                                 /**
                                 * Old Nif
                                 * 
                                 * Format:
                                 * N(1)+A(1)+N(2-6)+C(1)
                                 * N(1)>6
                                 * A(1)={A-Z,+,*}
                                 * 
                                 * Control:
                                 * S=7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(1)
                                 * C(1)=S%23
                                 * C{0-22} ? C{W,A-V}
                                 */
                                 if (!_.isFinite(Number(nifTemp[0])) 
                                        || !_.isFinite(Number(nifTemp[2]))
                                        || !_.isFinite(Number(nifTemp[3]))
                                        || !_.isFinite(Number(nifTemp[4]))
                                        || !_.isFinite(Number(nifTemp[5]))
                                        || !_.isFinite(Number(nifTemp[6]))) {
                                     return false;
                                 }
                                 
                                 if (Number(nifTemp[0]) <= 6) {
                                     return false;
                                 }
                                 
                                 var s = 7 * Number(nifTemp[2]) 
                                        + 6 * Number(nifTemp[3]) 
                                        + 5 * Number(nifTemp[4]) 
                                        + 4 * Number(nifTemp[5]) 
                                        + 3 * Number(nifTemp[6]) 
                                        + 2 * Number(nifTemp[0]);
                                 
                                 s = s % 23;
                                 
                                 return irlandNif[s] === nifTemp[7];
                             }
                         }
                	},
                    IT : {
                        regExp : /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|^([0-9]{11})$|^(IT[0-9]{11})$/,
                        parse : function(result) {
                            return {
                                number : result[0],
                                controlNumber : result[2],
                                controlKey : result[1],
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    JP : {
                		regExp : /^([a-zA-Z]{2})?[0-9a-zA-Z_]{14}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'JP') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 14) {
                        		 return false;
                        	 }
                             
                             if (!_.isFinite(Number(nifTemp[0]))
                                    || !_.isFinite(Number(nifTemp[1]))
                                    || !_.isFinite(Number(nifTemp[2]))
                                    || !_.isFinite(Number(nifTemp[3]))
                                    || _.isFinite(Number(nifTemp[4])) || nifTemp[4] !== '_'
                                    || !_.isFinite(Number(nifTemp[5]))
                                    || !_.isFinite(Number(nifTemp[6]))
                                    || _.isFinite(Number(nifTemp[7])) || nifTemp[7] !== '_'
                                    || !_.isFinite(Number(nifTemp[8]))
                                    || !_.isFinite(Number(nifTemp[9]))
                                    || !_.isFinite(Number(nifTemp[10]))
                                    || !_.isFinite(Number(nifTemp[11]))
                                    || !_.isFinite(Number(nifTemp[12]))
                                    || !_.isFinite(Number(nifTemp[13]))) {
                                 return false;
                             }
                             
                             return true;
                         }
                	},
                    KR : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    LB : {
                		regExp : /^[0-9]{1,}-601$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    LT : {
                        regExp : /^[0-9]{9,12}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    LU : {
                        regExp : /^([a-zA-Z]{2})?[0-9a-zA-Z]{8}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'LU') {
                        		 nifTemp = nifTemp.substring(2);
                        	 }
                        		 
                        	 if (nifTemp.length !== 8) {
                        		 return false;
                        	 }
                             
                             if (!checkAllDigits(nifTemp)) {
                                 return false;
                             }
                             
                             var x = Number(nifTemp.substring(0,6));
                             if (x <= 0) {
                                 return false;
                             }
                             
                             var y = Number(nifTemp.substring(6,8));
                             return y === (x % 89);
                         }
                    },
                    LV : {
                        regExp : /^LV[0-9]{11}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    MA : {
                		regExp : /^([0-9]{15})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    MC : {
                        regExp : /^([a-zA-Z]{2})?[0-9a-zA-Z]{11}$/,
                		parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             if (!this.nif) {
                        		 return false;
                        	 }
                        	 
                        	 var nifTemp = this.nif.toUpperCase();
                        	 var nifCountry = nifTemp.substring(0, 2);
                        	 
                        	 if (nifCountry === 'MC') {
                        		 nifTemp = nifTemp.substring(2);
                                 var nifTempCountry = nifTemp.substring(0, 2);
                                 if (nifTempCountry === 'FR') {
                                     return false;
                                 }
                        	 }
                             
                             var validator = joyr.validation.regex.nif()['FR'];
                             var result = validator.regExp.exec(nifTemp);
                             if (result) {
                                 return validator.parse(result).isValid();
                             }
                             return false;
                         }
                    },
                    MT : {
                        regExp : /^./,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    MX : {
                        regExp: /^((([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\d])|[3][01])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\d])|[3][0])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\d])([A-Z0-9]{3}))|(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3})))$/,
                        parse : function() {
                           return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    NL : {
                        regExp: /^([a-zA-Z]{2})?[0-9a-zA-Z]{12}$/,
                        parse : function(result) {
                           return {
                               nif : result && result.input ? result.input : null,
                               isValid : this.validator
                           };
                        },
                        validator : function() {
                            /**
                             * Format:
                             * N(1-8)+C(1)+A(1)+N(9-10)
                             * N(1-8)>0
                             * A(1)={B}
                             * 
                             * Control:
                             * S=9*N(1)+8*N(2)+7*N(3)+6*N(4)+5*N(5)+4*N(6)+3*N(7)+2*N(8)
                             * C(1)=S%11; if C(1)=10, invalid.
                             */
                            if (!this.nif) {
                                return false;
                            }
                            
                            var nifTemp = this.nif.toUpperCase();
                            var nifCountry = nifTemp.substring(0, 2);
                            
                            if (nifCountry === 'NL') {
                                nifTemp = nifTemp.substring(2);
                            }
                            
                            if (nifTemp.length !== 12) {
                                return false;
                            }
                            
                            if (!_.isFinite(Number(nifTemp[0]))
                                    || !_.isFinite(Number(nifTemp[1]))
                                    || !_.isFinite(Number(nifTemp[2]))
                                    || !_.isFinite(Number(nifTemp[3]))
                                    || !_.isFinite(Number(nifTemp[4]))
                                    || !_.isFinite(Number(nifTemp[5]))
                                    || !_.isFinite(Number(nifTemp[6]))
                                    || !_.isFinite(Number(nifTemp[7]))
                                    || !_.isFinite(Number(nifTemp[10]))
                                    || !_.isFinite(Number(nifTemp[11]))) {
                                return false;
                            }
                            
                            if (nifTemp[9] !== 'B') {
                                return false;
                            }
                            
                            var x = Number(nifTemp.substring(0,8));
                            if (x <= 0) {
                                return false;
                            }
                            
                            var s = 9 * Number(nifTemp[0]) 
                                    + 8 * Number(nifTemp[1]) 
                                    + 7 * Number(nifTemp[2]) 
                                    + 6 * Number(nifTemp[3]) 
                                    + 5 * Number(nifTemp[4]) 
                                    + 4 * Number(nifTemp[5]) 
                                    + 3 * Number(nifTemp[6]) 
                                    + 2 * Number(nifTemp[7]);
			             
                            s = s % 11;
                            
                            return (s !== 10) && (s === Number(Number(nifTemp[8])));
                        }
                    },
                    NO : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    PL : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    PT : {
                        regExp: /^([a-zA-Z]{2})?[0-9]{9}$/,
                        parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            /**
                             * Format:
                             * N(1-8)+C(1)
                             * N(1)>0
                             * 
                             * Control:
                             * S=9*N(1)+8*N(2)+7*N(3)+6*N(4)+5*N(5)+4*N(6)+3*N(7)+2*N(8)
                             * C(1)=11-S%11; si C(1)=10, C(1)=0; si C(1)=11, C(1)=0
                             */
                            if (!this.nif) {
                                return false;
                            }
                            
                            var nifTemp = this.nif.toUpperCase();
                            var nifCountry = nifTemp.substring(0, 2);
                            
                            if (nifCountry === 'PT') {
                                nifTemp = nifTemp.substring(2);
                            }
                            
                            if (nifTemp.length !== 9) {
                                return false;
                            }
                            
                            if (!checkAllDigits(nifTemp)) {
                                return false;
                            }
                            
                            if (Number(nifTemp[0]) <= 0) {
                                return false;
                            }
                            
                            var s = 9 * Number(nifTemp[0]) 
                                    + 8 * Number(nifTemp[1]) 
                                    + 7 * Number(nifTemp[2]) 
                                    + 6 * Number(nifTemp[3]) 
                                    + 5 * Number(nifTemp[4]) 
                                    + 4 * Number(nifTemp[5]) 
                                    + 3 * Number(nifTemp[6]) 
                                    + 2 * Number(nifTemp[7]);
                            
                            s = 11 - s % 11;
                            
                            return (Number(nifTemp[8]) === s) || (Number(nifTemp[8]) === 0 && (s === 10 || s === 11));
                        }
                    },
                    RO : {
                        regExp: /[rR][oO][0-9]{2,10}/,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    RU : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    SA : {
                		regExp : /^([0-9]{15})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    SE : {
                        regExp: /^([a-zA-Z]{2})?[0-9]{12}$/,
                        parse : function(result) {
                            return {
                                nif : result && result.input ? result.input : null,
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            /**
                             * Format:
                             * N(1-9)+C(1)+N(10-11)
                             * N(10-11)>0
                             * 
                             * Control:
                             * S=2#N(1)+N(2)+2#N(3)+N(4)+2#N(5)+N(6)+2#N(7)+N(8)+2#N(9)
                             * C(1)=10-S%10; if C(1)=10, C(1)=0.
                             */
                            if (!this.nif) {
                                return false;
                            }
                            
                            var nifTemp = this.nif.toUpperCase();
                            var nifCountry = nifTemp.substring(0, 2);
                            
                            if (nifCountry === 'SE') {
                                nifTemp = nifTemp.substring(2);
                            }
                            
                            if (nifTemp.length !== 12) {
                                return false;
                            }
                            
                            if (!checkAllDigits(nifTemp)) {
                                return false;
                            }
                            
                            if (Number(nifTemp[10]) === 0 && Number(nifTemp[11]) === 0) {
                                return false;
                            }
                            
                            var s = getSostenido(2, Number(nifTemp[0])) + Number(nifTemp[1]) 
                                    + getSostenido(2, Number(nifTemp[2])) + Number(nifTemp[3]) 
                                    + getSostenido(2, Number(nifTemp[4])) + Number(nifTemp[5]) 
                                    + getSostenido(2, Number(nifTemp[6])) + Number(nifTemp[7]) 
                                    + getSostenido(2, Number(nifTemp[8]));
                            
                            s = 10 - s % 10;
                            
                            return ((Number(nifTemp[9]) === 0 && s === 10) || (Number(nifTemp[9]) === s));
                        }
                    },
                    SI : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    SK : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    TR : {
                        regExp: /^([0-9]{11})$/,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    US : {
                        regExp: /^./,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    }
                };
            },
            /**
             * Get cif regular expressions
             * @returns {Object}
             * @example
             *        validator = joyr.validation.regex.cif()[inditex.iStoreJSON.countryCode];
             *        if (result = validator.regExp.exec(modelValue)) {
             *            return validator.parse(result).isValid();
             *        }
             */
            cif: function () {
                return {
                    AM : {
                        regExp : /^[0-9]{9}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    }, 
                    EG : {
                        regExp : /^[0-9]{9}$/,
                        parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    EE : {
                        regExp : /^EE[0-9]{9}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    ES : {
                        regExp : /^([ABCDEFGHJPQRSUVNW]{1})([\w\d]{8})$/,
                        parse : function(result) {
                            return {
                                number : result[0],
                                controlNumber : result[2],
                                controlKey : result[1],
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    GE : {
                        regExp : /^([0-9]{9}|[0-9]{11})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    HU : {
                        regExp: /^[0-9]{8}[\-][0-9][\-][0-9]{2}$/,
                        parse : function() {
                           return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    IC : {
                        regExp : /^([ABCDEFGHJPQRSUVNW]{1})([\w\d]{8})$/,
                        parse : function(result) {
							return {
								number : result[0],
								controlNumber : result[2],
								controlKey : result[1],
								isValid : this.validator
							};
						},
						validator : function() {
							return true;
						}
                    },
                    IT : {
                        regExp : /^([A-Za-z]{6}[0-9lmnpqrstuvLMNPQRSTUV]{2}[abcdehlmprstABCDEHLMPRST]{1}[0-9lmnpqrstuvLMNPQRSTUV]{2}[A-Za-z]{1}[0-9lmnpqrstuvLMNPQRSTUV]{3}[A-Za-z]{1})$|^([0-9]{11})$|^(IT[0-9]{11})$/,
                        parse : function(result) {
                            return {
                                number : result[0],
                                controlNumber : result[2],
                                controlKey : result[1],
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    LB : {
                		regExp : /^[0-9]{1,}-601$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    LT : {
                        regExp : /^[0-9]{9,12}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    LV : {
                        regExp : /^LV[0-9]{11}$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                    },
                    MA : {
                		regExp : /^([0-9]{15})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    MX : {
                        regExp: /^((([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\d])|[3][01])([A-Z0-9]{3}))$|^(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\d])|[3][0])([A-Z0-9]{3}))$|^(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\d])([A-Z0-9]{3}))$|^(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3})))$/,
                        parse : function() {
                           return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    RU : {
                        regExp: /^[0-9]{10}$/,
                        parse : function() {
                           return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    },
                    SA : {
                		regExp : /^([0-9]{15})$/,
                		parse : function() {
                            return {
                                isValid : this.validator
                            };
                         },
                         validator : function() {
                             return true;
                         }
                	},
                    TR : {
                        regExp: /(^[0-9]{10})$/,
                        parse : function() {
                           return {
                                isValid : this.validator
                            };
                        },
                        validator : function() {
                            return true;
                        }
                    }
                };
            }
        },
        phoneMaxDigits: {
            AE: 9,
            AL: 9,
            AT: 14,
            AM: 8,
            AZ: 9,
            BE: 10,
            BG: 9,
            BH: 8,
            CA: 14,
            CO: 10,
            CH: 13,
            CY: 8,
            CZ: 9,
            CN: 14,
            DE: 14,
            DK: 8,
            EE: 8,
            EG: 10,
            ES: 9,
            ESCN: 9,
            FI: 10,
            FR: 10,
            GB: 11,
            GR: 10,
            HK: 8,
            HR: 10,
            HU: 9,
            IC: 9,
            IE: 12,
            IL: 10,
            IN: 10,
            IT: 12,
            JO: "8,9",
            JP: 10,
            KR: 11,
            KW: 8,
            LB: 8,
            LT: 8,
            LU: 12,
            LV: 8,
            MA: 9,
            MC: 10,
            MT: 8,
            MX: 10,
            NL: 11,
            NO: 8,
            PL: 10,
            PT: 12,
            RO: 9,
            RU: 10,
            SA: 9,
            SE: 14,
            SI: 8,
            SK: 10,
            TR: 10,
            TW: 9,
            UA: 9,
            US: 12,
            RS: 9,
            VN: 10,
            XK: 8,
            TE: 8, 
        }
    };
    
    /**
	 * Multiplies two numbers smaller than or equal to 9 and returns the sum of the digits of the result.
	 * Ex: 2*6 = 12 -> 1 + 2 = 3. -> 2#6 = 3
	 *
	 * @param a the a
	 * @param b the b
	 * @return the int
	 */
    function getSostenido(a, b) { 
        var i = 0;
		var r = Number(a*b);
		var re = r.toString();
		var j = (Number(re[0]));
		if (parseInt(r) > 9) {
			i = Number(re[1]);
		}
		return (j + i);
	}
    
    function checkAllDigits(a) {
        for (var i = 0; i < a.length; i++) {
            if (!_.isFinite(Number(a[i]))) {
                return false;
            }
        }
        return true;
    }

    joyr.validation = validation;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.validation
     */
    var format = {
        /**
         * formats
         * @namespace
         * @alias joyr.format
         */
        klarnaDate: function () {
            return {
                AT : 'ddMMyyyy',
                DE : 'ddMMyyyy',
                NL : 'ddMMyyyy',
                FI : 'ddMMyyyy'
            };
        }
    };

    joyr.format = format;

})(window.joyr);

(function (joyr) {
    'use strict';

    /**
     * Initialization event. Fired when all initialization promises fulfill.
     * @event joyr.core#loaded
     * @property {Object} eventData - Information about the event ({@link joyr.EventArgs#eventData})
     */
    joyr.events.loaded = 'joyr.core.loaded';

    /**
     * Initialization error event. Fired when any of the initializatio promises fail.
     * @event joyr.core#loadError
     * @property {Object} eventData - Information about the event ({@link joyr.EventArgs#eventData})
     */
    joyr.events.loadError = 'joyr.core.loadError';

}(window.joyr));

(function (joyr) {
    'use strict';

    /**
     * An object that encapsulates data to be passed to an [event handler]{@link joyr.EventHandler}.
     * It also can prevent the execution of queued [event handlers]{@link joyr.EventHandler} for an specific
     * ocurrence of an event.
     * @constructor
     * @param {string} eventName - The name of the event being fired.
     * @param {Object} sender - The object that fired the event.
     * @param {eventData} [eventData] - Information about the event.
     */
    joyr.EventArgs = function (eventName, sender, eventData) {
        if (typeof eventName !== 'string') {
            throw new TypeError('[eventName] must be a valid string');
        }
        if (!sender) {
            throw new TypeError('[sender] must point to an object');
        }
        /**
         * The name of the event
         * @member {string}
         */
        this.eventName = eventName;

        /**
         * The object that fired the event.
         * @member {Object}
         */
        this.sender = sender;
        /**
         * Information about the event.
         * @member {Object}
         */
        this.eventData = eventData;

        /**
         * If set to true by an event handler, it may prevent other event handlers from receiving notifications of the
         * event.
         * @member {bool}
         */
        this.handled = false;
    };
}(window.joyr));

(function (joyr) {
    'use strict';

    /**
     * This class defines event handlers, objects that encapsulate callbacks that will be invoked
     * in response to certain events. It allows to use as event handlers either standalone functions, or methods
     * of specific instances of a class.
     * @constructor
     * @param {function} handler - The function that will handle the event. This function will receive a single
     * argument, an object of type {@link joyr.EventArgs}.
     * @param {Object} [handlerObject] - The object that will be set as the context for the call to
     * <code>handler</code>.
     *
     */
    joyr.EventHandler = function (handler, handlerObject) {
        if (!handler || (typeof handler !== 'function')) {
            throw new TypeError('[hanlder] must be a function.');
        }

        this.handler = handler;
        this.handlerObject = handlerObject;
    };

    /**
     * Execute the event handler. If <code>handlerObject</code> is not <code>undefined</code> or <code>null</code>,
     * that object will be set as the context for the invoking
     * (the value of <code>this</code> inside the handler function)
     * @param {joyr.EventArgs} eventArgs - Information about the event fired, that will be passed to the
     * <code>handler</code> function.
     */
    joyr.EventHandler.prototype.execute = function (eventArgs) {
        this.handler.call(this.handlerObject, eventArgs);
    };

}(window.joyr));

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.bm.utils
     */
    var utils = {

    };

    joyr.bm.utils = utils;

})(window.joyr);

/**
 * Helper Module for stock in store functionality
 */
(function (joyr) {
    'use strict';

    function StockInStoreObject(criteria) {
        if (!criteria) {
            throw new ReferenceError('Missing parameter: criteria');
        }
        if (!criteria.partNumber) {
            throw new ReferenceError('Missing parameter: criteria.partNumber');
        }
        if (!criteria.campaign) {
            throw new ReferenceError('Missing parameter: criteria.campaign');
        }
        if (!criteria.longitude) {
            throw new ReferenceError('Missing parameter: criteria.longitude');
        }
        if (!criteria.latitude) {
            throw new ReferenceError('Missing parameter: criteria.latitude');
        }
        this.criteria = criteria;
        this.storeStocks = null;

        return getStockInStoreData.call(this);
    }

    /**
     * Get all XHR data required.
     * @returns {joyr.Promise}
     */
    function getStockInStoreData() {
        
        var _this = this;
        return new joyr.Promise(function (resolve, reject) {
            joyr.rest.xRestGetPhysicalStores(_this.criteria)
            .done(function (results) {
                var stores = [];
                stores = stores.concat(results.closerStores);
                stores = stores.concat(results.favouriteStores);
                stores = stores.concat(results.lastUsedStores);
                return joyr.rest.xRestStockPhysicalStore(stores, _this.criteria.campaign, _this.criteria.partNumber)
                .done(function (result) {
                    _this.storeStocks = [];
                    for (var i = 0;i < stores.length;i++) {
                        var store = stores[i],stocks;
                        for (var j = 0;j < result.stocks.length;j++) {
                            if (parseInt(store.id) === parseInt(result.stocks[j].physicalStoreId)) {
                                stocks = result.stocks[j];
                            }
                        }
                        if (stocks != null) {
                            var sizeStocks = [];
                            for (j = 0;j < stocks.sizeStocks.length;j++) {
                                if (stocks.sizeStocks[j].quantity > inditex.iStoreJSON.details.stockProductPhstoreMin) {
                                    sizeStocks.push(stocks.sizeStocks[j]);
                                }
                            }
                            store.sizeStocks = sizeStocks;
                            if (store.sizeStocks.length > 0) {
                                _this.storeStocks.push(store);
                            }
                        }
                    }
                    resolve(_this);
                }).Catch(function (error) {
                    reject(error);
                });
            }).Catch(function (error) {
                reject(error);
            });
        });
    }

    /**
     * Build a new Stock Object
     * @throws ReferenceError
     * @param {Object} criteria - Criteria object to obtain the stock in store
     * @param {Boolean} criteria[].favouriteStores - If true, returns the favourite stores of the user
     * @param {Boolean} criteria[].lastStores - If true, returns the last stores the user used in their orders
     * @param {Boolean} criteria[].closerStores - If true, returns the closest stores
     * @param {Number} criteria[].latitude - Indicates the latitude for the center of the search
     * @param {Number} criteria[].longitude - Indicates the longitude for the center of the search
     * @param {Number}  criteria[].min - Indicates the minimum desired number of stores to return.
     * @param {Number}  criteria[].max - Indicates the maximum number of stores to return.
     * @param {Boolean} criteria[].receiveEcommerce - Include or not the stores that receive e-commerce orders
     * @param {String} criteria[].countryCode - Exclude or not any stores that doesn't belong in that country.
     * @returns {Promise}
     * @constructor
     * @memberof joyr.booking
     * @example
     * new joyr.booking.StockInStore({partNumber: 'XXXXXXXXXXXXX-VXXXX',campaign:'VXXXX', favouriteStores:true,
     *          closerStores:true, lastStores:true, latitude:40.4, longitude: -3.6})
     *  .done(function(stock) { })
     *  .Catch(function(error) { });
     */
    joyr.booking.StockInStore = StockInStoreObject;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.booking.utils
     */
    var utils = {

        /**
        * Indicates whether a user is able to make bookings
        * @returns {boolean}
        */
        isBookingAllowed: function () {
            return inditex.iStoreJSON.details.visibleBookings !== 'HIDDEN' || inditex.iUserJSON.restrictedBooking;
        },

        /**
        * Get stores with specified sizes
        * @param {Array} stores - stores to filter
        * @param {Array} selectedSizes
        * @returns {joyr.Promise}
        */
        getStoresByPartNumber: function(stores, selectedSizes) {
            var partNumber = selectedSizes[0].partnumber.split('-')[0],
                campaign = selectedSizes[0].partnumber.split('-')[1];
            return new joyr.Promise(function (resolve, reject) {
                joyr.rest.xRestStockPhysicalStore(stores, campaign, partNumber)
                    .done(function (result) {
                        var storeStocks = [];
                        for (var i = 0;i < stores.length;i++) {
                            var store = stores[i], stocks = null;
                            for (var j = 0;j < result.stocks.length;j++) {
                                if (parseInt(store.id) === parseInt(result.stocks[j].physicalStoreId)) {
                                    stocks = result.stocks[j];
                                }
                            }
                            if (stocks) {
                                var sizeStocks = [];
                                for (j = 0; j < stocks.sizeStocks.length; j++) {
                                    if (stocks.sizeStocks[j].quantity > inditex.iStoreJSON.details.stockProductPhstoreMin) {
                                        for (var k = 0; k < selectedSizes.length; k++) {
                                            if (parseInt(selectedSizes[k].mastersSizeId) === stocks.sizeStocks[j].size) {
                                                stocks.sizeStocks[j].originalSize = selectedSizes[k];
                                                sizeStocks.push(stocks.sizeStocks[j]);
                                            }
                                        }
                                    }
                                }
                                store.sizeStocks = sizeStocks;
                                if (store.sizeStocks.length > 0) {
                                    storeStocks.push(store);
                                }
                            }
                        }
                        resolve(storeStocks);
                    }).Catch(function (error) {
                        reject(error);
                    });
            });
        }
    };

    joyr.booking.utils = utils;

})(window.joyr);

/**
 * Helper Module for Category functionality
 */
(function (joyr) {
    'use strict';

    function CategoryObject(configuration) {
        var _this = this;
        
        if (configuration && configuration.categoryId) {
            _this.categoryId = configuration.categoryId;
        }
        else {
            if (inditex.iCategoryId) {
                _this.categoryId = inditex.iCategoryId;
            }
            else {
                throw new ReferenceError(
                    'Missing parameter: categoryId not provided and cannot retrieve it from the environment');
            }
        }
        this.includeSubCategories =
            configuration && configuration.includeSubCategories ? configuration.includeSubCategories : false;

        this.noStock =
            configuration && configuration.noStock ? configuration.noStock : false;

        if (configuration.xConfiguration && configuration.xConfiguration instanceof Array) {
            _this.xConfiguration = configuration.xConfiguration;
        } else {
            _this.xConfiguration = [];
        }

        _this.category = null;
        _this.products = null;
        _this.stock = null;
        _this.categoryFilter = null;
        _this.visibleProducts = null;
        _this.visibilityMap = [];

        return getCategoryData.call(_this);
    }

    /**
     * Get all XHR data required
     * @returns {joyr.Promise}
     */
    function getCategoryData() {
        
        var _this = this;
        return new joyr.Promise(function (resolve, reject) {
            
            var promises = [];
            promises.push(joyr.rest.xRestGetCategory(_this.categoryId));
            promises.push(joyr.rest.xRestGetProductsByCategory(_this.categoryId, _this.includeSubCategories));
            promises.push(joyr.rest.xRestGetCategoryStock(_this.categoryId, _this.includeSubCategories));

            if (_this.xConfiguration.length) {
                promises.push(joyr.rest.xRestGetXConfigurationValues(_this.xConfiguration));
            }

            joyr.Promise.all(promises)
                .done(function (results) {
                    
                    _this.category = results[0];
                    _this.products = results[1];
                    _this.stock = results[2];
                    _this.visibilityMap = inditex.getProductVisibilityMap(_this.products, _this.stock);
                    if (_this.xConfiguration.length) {
                        _this.xConfiguration = results[3];
                    }
                    var specialQualities = inditex.iStoreJSON.details.specialQualities &&
                        inditex.iStoreJSON.details.specialQualities.split(',');
                    _this.visibleProducts = [];
                    var product;
                    for (var i = 0; i < _this.products.length; i++) {
                        product = _this.products[i];
                        var filteredItems = joyr.catalog.utils.processProductVisibility(product, _this.stock, _this.noStock, _this.products, _this.visibilityMap, specialQualities);
                        
                        if(filteredItems[0]){
                            filteredItems[0].gridElemType = product.gridElemType;
                            _this.visibleProducts = _this.visibleProducts.concat(filteredItems);
                        }                                          
                    }
                    //Change color order to xmedia color order
                    if (inditex.iStoreJSON.details.xmedia) {
                        for(var i = 0; i < _this.visibleProducts.length; i++) {
                            var product = _this.visibleProducts[i];
                            if (product.detail.xmedia && product.type === joyr.constants.product.PRODUCT_BEAN && !product.isMocaco) {
                                var newOrderColor = [];
                                for (var j = 0; j < product.detail.xmedia.length; j++) {
                                    var xMediaColor = product.detail.xmedia[j].colorCode;
                                    for (var k = 0; k < product.detail.colors.length; k++) {
                                        if (product.detail.colors[k].id == xMediaColor) {
                                            newOrderColor.push(product.detail.colors[k]);
                                            product.detail.colors[k].pushed = true;
                                        }
                                    }
                                }
                                for (var l = 0; l < product.detail.colors.length; l++) {
                                    if (!product.detail.colors[l].pushed) {
                                        newOrderColor.push(product.detail.colors[l]);
                                        product.detail.colors[l].pushed = true;
                                    }
                                }
                                product.detail.colors = newOrderColor;
                            }
                        }
                    }
                    resolve(_this);
                })
                .Catch(function (error) {
                    reject(error);
                });
        });
    }

    /**
     * Build a new Category Object
     * @throws ReferenceError
     * @param {Object} configuration - configuration object
     * @param {Number} configuration[].categoryId - Retrieves info of specified categoryId.
     *      If not provided uses inditex.iCategoryId instead
     * @param {Boolean} configuration[].includeSubCategories - IncludeSubCategories.
     *      If not provided uses false as default value
     * @param {String[]} configuration[].xConfiguration - Array of xConfiguration keys to retrieve.
     * @returns {Promise}
     * @constructor
     * @memberof joyr.catalog
     * @example
     * new joyr.catalog.Category({
     *          categoryId:inditex.iCategoryId,
     *          includeSubCategories: false,
     *          xConfiguration: ['KEY1', 'KEY2']
     *      })
     *     .done(function (category) { })
     *     .Catch(function (error) { });
     */
    joyr.catalog.Category = CategoryObject;

})(window.joyr);

/**
 * Helper Module for Filter Products functionality
 */
(function (joyr) {
    'use strict';

    function FilterObject(products, categoryId, additionalFilters) {
        if (!products) {
            throw new ReferenceError(
                    'Missing parameter: products');
        }
        if (!categoryId) {
            throw new ReferenceError(
                    'Missing parameter: categoryId');
        }
        this.products = products;
        this.categoryId = categoryId;
        this.productsFiltered = null;
        this.filters = null;
        this.filtersToApply = [passAttrFilter, passColorFilter,
                               passPriceFilter, passSizeFilter, passDescriptionFilter];
        if (additionalFilters && additionalFilters.length > 0) {
            while (additionalFilters.length) {
                this.filtersToApply.push(additionalFilters.shift());
            }
        }
        return getFilterData.call(this);
    }

    /**
     * Get all XHR data required
     * @returns {joyr.Promise}
     */
    function getFilterData() {
       
        var _this = this;
        return new joyr.Promise(function (resolve, reject) {
            joyr.rest.xRestGetCategoryFilter(_this.categoryId)
            .done(function (results) {
                if (!results) {
                    _this.filters = [];
                } else {
                    _this.filters = results.filters;
                }
                if (_this.filters[0]) {
                    _this.productsFiltered = filterProducts(_this.products, _this.filters[0], _this.filtersToApply);
                } else {
                    _this.productsFiltered = _this.products;
                }
                resolve(_this);
            })
            .Catch(function (error) {
                reject(error);
            });
        });
    }

    function filterProducts(productList, filterValues, filtersToApply) {
        var filtered = [];
        if (filtersToApply.length > 0) {
            for (var i = 0; i < productList.length; i++) {
                var included = true;
                for (var j = 0; j < filtersToApply.length; j++) {
                    if (!filtersToApply[j](productList[i], filterValues)) {
                        included = false;
                        break;
                    }
                }
                if (included) {
                    filtered.push(productList[i]);
                }
            }
        }
        else {
            filtered = productList;
        }

        return filtered;
    }

    function objectToArray(objectArr) {
        var strArr = [];

        if (objectArr != null) {
            for (var i = 0; i < objectArr.length; i++) {
                strArr.push(objectArr[i].value);
            }
        }
        return strArr;
    }

    function passColorFilter(product, filterValues) {
        var colors = objectToArray(filterValues.colors);
        if (!colors || colors.length === 0) {
            return true;
        }

        for (var i = 0; i < product.attributes.length; i++) {
            if (product.attributes[i].type === joyr.constants.filters.COLOR_TYPE_FILTER &&
                colors.indexOf(product.attributes[i].name) >= 0) {
                return true;
            }
        }

        return false;
    }

    function passPriceFilter(product, filterValues) {
        var pass, fromPrice, toPrice;

        if (!filterValues.prices) {
            return true;
        }

        if ((filterValues.prices.min !==0) && (!filterValues.prices.min || !filterValues.prices.max)) {
            return true;
        }

        pass = false;
        fromPrice = filterValues.prices.min;
        toPrice = filterValues.prices.max;

        if (joyr.catalog.utils.isBundle(product)) {
            for (var i = 0; i < product.bundleProductSummaries.length; i++) {
                pass = pass || passPriceFilter(product.bundleProductSummaries[i], filterValues);
            }
        } else {
            if (joyr.catalog.utils.isProduct(product)) {
                var auxPrices = getProdPrices(product);
                pass = isBetween(auxPrices, fromPrice, toPrice);
            }
        }
        return pass;
    }

    function getProdPrices(product) {
        var prices = [];

        for (var i = 0; i < product.detail.colors.length; i++) {
            for (var j = 0; j < product.detail.colors[i].sizes.length; j++) {
                prices.push(product.detail.colors[i].sizes[j].price);
            }
        }

        return prices;
    }

    function isBetween(values, fromValue, toValue) {
        var isBet = false;

        for (var i = 0; i < values.length; i++) {
            if (values[i] >= fromValue && values[i] <= toValue) {
                return true;
            }
        }
        return isBet;
    }

    function passAttrFilter(product, filterValues) {

        if (!filterValues || (filterValues && !filterValues.attributes)) {
            return true;
        }

        var allAttrPassed = true;

        joyr.constants.filters.ATTR_TYPE_FILTER.forEach(function (attrType) {
            var attributes = filterValues.attributes.filter(function (attr) {
                return attr.type === attrType;
            });

            if (attributes.length && !pass(product, attributes, attrType)) {
                allAttrPassed = false;
            }
        });

        return allAttrPassed;

        function pass(product, attributes, attrType) {
            var reduced = objectToArray(attributes);
            if (reduced.length === 0) {
                return true;
            }
            var i;
            if (joyr.catalog.utils.isProduct(product)) {
                for (i = 0; i < product.attributes.length; i++) {
                    if (product.attributes[i].type === attrType &&
                        reduced.indexOf(product.attributes[i].name) >= 0) {
                        return true;
                    }
                }
            } else {
                if (joyr.catalog.utils.isBundle(product)) {
                    for (i = 0; i < product.bundleProductSummaries.length; i++) {
                        var attrs = product.bundleProductSummaries[i].attributes;
                        for (var j = 0; j < attrs.length; j++) {
                            if (attrs[j].type === attrType &&
                                reduced.indexOf(attrs[j].name) >= 0) {
                                return true;
                            }
                        }
                    }
                }
            }

            return false;
        }
    }

    function passSizeFilter(product, filterValues) {
        var pass = false;
        var sizes = filterValues.sizes;
        if (sizes != null && sizes.length > 0) {
            if (joyr.catalog.utils.isBundle(product)) {
                for (var i = 0; i < product.bundleProductSummaries.length; i++) {
                    pass = pass || passSizeFilter(product.bundleProductSummaries[i], filterValues);
                }
            } else {
                if (joyr.catalog.utils.isProduct(product)) {
                    var auxSizes = getProdSizes(product);
                    pass = isIn(sizes, auxSizes);
                }
            }
        } else {
            pass = true;
        }

        return pass;
    }

    function passDescriptionFilter(product, filterValues) {
        var pass = false;
        var descriptions = filterValues.descriptions;
        if (descriptions != null && descriptions.length > 0) {
            if (joyr.catalog.utils.isBundle(product)) {
                for (var i = 0; i < product.bundleProductSummaries.length; i++) {
                    pass = pass || passDescriptionFilter(product.bundleProductSummaries[i], filterValues);
                }
            } else if (joyr.catalog.utils.isProduct(product)) {
                var auxDescriptions = getProdDescriptions(product);
                pass = isIn(descriptions, auxDescriptions);
            }
        } else {
            pass = true;
        }
        return pass;
    }

    function isIn(value, values) {
        var truth = false;

        for (var j = 0; j < values.length; j++) {
            if (value.indexOf(values[j]) >= 0) {
                truth = true;
                break;
            }
        }
        return truth;
    }

    function getProdSizes(product) {
        var sizes = [];

        for (var i = 0; i < product.detail.colors.length; i++) {
            for (var j = 0; j < product.detail.colors[i].sizes.length; j++) {
                sizes.push(product.detail.colors[i].sizes[j].name);
            }
        }
        return sizes;
    }

    function getProdDescriptions(product) {
        var descriptions = [];

        for (var i = 0; i < product.detail.colors.length; i++) {
            for (var j = 0; j < product.detail.colors[i].sizes.length; j++) {
                var description = product.detail.colors[i].sizes[j].description;
                var size = product.detail.colors[i].sizes[j].name;
                if (description) {
                    descriptions.push('[[E]]' + description);
                }
                if (size) {
                    descriptions.push('[[S]]' + size);
                }
            }
        }
        return descriptions;
    }

    /**
	 * @function additionalFilter
  	 * @param {Object} product - Product to apply the filter
	 * @param {Object} filterValues - All the filters values
	 */
    /**
     * Build a new Filter Object. Initially the following filters are applied: color filter,
                attribute filter, range price filter, size filter, description filter
     * @throws ReferenceError
     * @param {Array} products - products to be filtered
     * @param {Number} categoryId - category to retrieve the filters to apply
     * @param {additionalFilter[]} additionalFilters - More filters to apply
     * @returns {Promise}
     * @constructor
     * @memberof joyr.catalog
     * @example
     * new joyr.catalog.Filter(products, inditex.iCategoryId, [_filter1])
     *     .done(function (products) { })
     *     .Catch(function (error) { });
     */
    joyr.catalog.Filter = FilterObject;

})(window.joyr);

/**
 * Helper Module for Product Detail functionality
 */
(function (joyr) {
    'use strict';

    function OrderObject(products, categoryId, additionalOrders) {
        this.products = products;
        this.categoryId = categoryId;
        this.orderFunctionsArray = [];

        /** Configure builtin order functions */
        this.orderFunctionsArray[joyr.constants.order.MORE_RELEVANT_ORDERING] = moreRelevantOrdering;
        this.orderFunctionsArray[joyr.constants.order.NEWER_ORDERING] = newerOrdering;
        this.orderFunctionsArray[joyr.constants.order.PRICE_ORDERING] = priceOrdering;
        if (additionalOrders && additionalOrders.length > 0) {
            while (additionalOrders.length) {
                var additionalOrder = additionalOrders.shift();
                this.orderFunctionsArray[additionalOrder.order] = additionalOrder.orderingFunction;
            }
        }
        this.productsOrdered = null;

        return getOrderData.call(this);
    }

    /**
     * Get all XHR data required
     * @returns {joyr.Promise}
     */
    function getOrderData() {
        
        var _this = this;
        return new joyr.Promise(function (resolve, reject) {
            joyr.rest.xRestGetCategoryFilter(_this.categoryId)
            .done(function (results) {
                _this.order = results.filters;
                if (_this.order[1]) {
                    var order = _this.order[1].order ? _this.order[1].order : '';
                    var reverse = _this.order[1].reverse ? _this.order[1].reverse : false;
                    if (_this.orderFunctionsArray[order]) {
                        _this.productsOrdered = _this.orderFunctionsArray[order](_this.products, reverse);
                    }
                    else {
                        _this.productsOrdered = simplyOrder(_this.products, reverse);
                    }
                }
                else {
                    _this.productsOrdered = _this.products;
                }
                resolve(_this);
            })
            .Catch(function (error) {
                reject(error);
            });
        });
    }

    function simplyOrder(products, reverse) {
        return reverse ? products.reverse() : products;
    }

    function moreRelevantOrdering(products, reverse) {
        return reverse ? products.reverse() : products;
    }

    function newerOrdering(products, reverse) {
        return reverse ? products.reverse() : products;
    }

    function priceOrdering(products, reverse) {
        var ordered = [];

        for (var i = 0; i < products.length; i++) {
            var auxPrecios = joyr.catalog.utils.getProductPriceRanges(products[i]);
            if (reverse) {
                insertOrderedByPrice(products[i], ordered, auxPrecios.maxPrice, reverse);
            } else {
                insertOrderedByPrice(products[i], ordered, auxPrecios.minPrice, reverse);
            }
        }
        return ordered;
    }

    function insertOrderedByPrice(product, ordered, price, reverse) {
        var inserted = false;
        for (var i = 0; i < ordered.length; i++) {
            var auxPrice = joyr.catalog.utils.getProductPriceRanges(ordered[i]);
            if (!reverse && price < auxPrice.minPrice) {
                ordered.splice(i, 0, product);
                inserted = true;
                break;
            } else if (reverse && price > auxPrice.maxPrice) {
                ordered.splice(i, 0, product);
                inserted = true;
                break;
            }
        }
        if (!inserted) {
            ordered.push(product);
        }
    }

    /**
	 * @function additionalOrder
  	 * @param {Array} products - Products to filter
	 * @param {Boolean} reverse - Reverse order or not
	 */
    /**
     * Build a new Order Object. Has 3 builtin orderings:
     * joyr.constants.order.MORE_RELEVANT_ORDERING, joyr.constants.order.NEWER_ORDERING,
     * joyr.constants.order.PRICE_ORDERING
     * @param {Number} products: products to be ordered
     * @param {Number} categoryId: category identifier
     * @param {additionalOrder[]} additionalOrder: Mapping between customized order names and its ordering function
     * @returns {Promise}
     * @constructor
     * @memberof joyr.catalog
     * @example
     * new joyr.catalog.Order(products, inditex.iCategoryId,
     * [{order: 'ADDITIONAL_ORDER_TYPE_1', orderingFunction: additionalOrderingFunction}])
     *     .done(function (productsOrderd) { })
     *     .Catch(function (error) { });
     */
    joyr.catalog.Order = OrderObject;

})(window.joyr);

/**
 * Helper Module for Product Detail functionality
 */
(function (joyr) {
    'use strict';

    function ProductObject(productId, categoryId) {
        var _this = this;

        _this.productId = productId;
        _this.categoryId = categoryId;
        _this.product = null;
        _this.stock = null;
        _this.visibilityMap = null;

        return getProductData.call(_this);
    }

    /**
     * Get all XHR data required
     * @returns {joyr.Promise}
     */
    function getProductData() {
        
        
        var _this = this;
        var specialQualities = inditex.iStoreJSON.details.specialQualities &&
                        inditex.iStoreJSON.details.specialQualities.split(',');
        return new joyr.Promise(function (resolve, reject) {
            joyr.Promise.all(
                joyr.rest.xRestGetProductDetail(_this.productId, _this.categoryId),
                joyr.rest.xRestGetProductStock(_this.productId))
                .done(function (results) {
                    _this.product = results[0];
                    _this.stock = results[1][0];
                    _this.visibilityMap = inditex.getProductVisibilityMap([_this.product], [_this.stock]);
                    
                    joyr.catalog.visibility.setVisibility(_this.product, _this.visibilityMap);

                    _this.products = joyr.catalog.utils.processProductVisibility(_this.product,
                        [_this.stock], false, null, null, specialQualities);

                    if (_this.products && _this.products.length > 0) {
                        _this.product = _this.products[0];
                    } else {
                        _this.product.detail.colors.forEach(function(color) {
                            color.sizes = [];
                        });
                    }

                    if (inditex.iStoreJSON.details.showProductCategorySkuNoStock ===
                        joyr.constants.store.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK) {
                        joyr.catalog.visibility
                            .setDisabledVisibility(_this.product, _this.visibilityMap, [_this.stock]);
                    }
                    if (inditex.iStoreJSON.details.xmedia) {
                        if (_this.product.detail.xmedia) {
                            if (_this.product.type === joyr.constants.product.PRODUCT_BEAN) {
                                var newOrderColor = [];
                                for (var j = 0; j < _this.product.detail.xmedia.length; j++) {
                                    var xMediaColor = _this.product.detail.xmedia[j].colorCode;
                                    for (var k = 0; k < _this.product.detail.colors.length; k++) {
                                        if (_this.product.detail.colors[k].id == xMediaColor) {
                                            newOrderColor.push(_this.product.detail.colors[k]);
                                            _this.product.detail.colors[k].pushed = true;
                                        }
                                    }
                                }
                                for (var l = 0; l < _this.product.detail.colors.length; l++) {
                                    if (!_this.product.detail.colors[l].pushed) {
                                        newOrderColor.push(_this.product.detail.colors[l]);
                                        _this.product.detail.colors[l].pushed = true;
                                    }
                                }
                                _this.product.detail.colors = newOrderColor;
                            } else {
                                for(var i = 0; i < _this.product.bundleProductSummaries.length; i++) {
                                    var product = _this.product.bundleProductSummaries[i];
                                    if (product.detail.xmedia && product.type === joyr.constants.product.PRODUCT_BEAN) {
                                        var newOrderColor = [];
                                        for (var j = 0; j < product.detail.xmedia.length; j++) {
                                            var xMediaColor = product.detail.xmedia[j].colorCode;
                                            for (var k = 0; k < product.detail.colors.length; k++) {
                                                if (product.detail.colors[k].id == xMediaColor) {
                                                    newOrderColor.push(product.detail.colors[k]);
                                                    product.detail.colors[k].pushed = true;
                                                }
                                            }
                                        }
                                        for (var l = 0; l < product.detail.colors.length; l++) {
                                            if (!product.detail.colors[l].pushed) {
                                                newOrderColor.push(product.detail.colors[l]);
                                                product.detail.colors[l].pushed = true;
                                            }
                                        }
                                        product.detail.colors = newOrderColor;
                                    }
                                }
                            }
                        }
                    }
                    resolve(_this);
                })
                .Catch(function (error) {
                    reject(error);
                });
        });
    }

    /**
     * Build a new Product Object
     * @param {Number} productId: product identifier
     * @param {Number} categoryId: category identifier
     * @returns {Promise}
     * @constructor
     * @memberof joyr.catalog
     * @example
     * new joyr.catalog.Product(inditex.iProductId, inditex.iCategoryId)
     *     .done(function (product) { })
     *     .Catch(function (error) { });
     */
    joyr.catalog.Product = ProductObject;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.catalog.utils
     */
    var utils = {

        /**
         * Check if store is open for sale
         * @returns {boolean}
         */
        isOpenForSale: function () {
            return inditex.iStoreJSON && inditex.iStoreJSON.isOpenForSale && ( inditex.iStoreJSON.type === 1 ||  inditex.iStoreJSON.type === 3 );
        },

        /**
         * Check if product is a ProductBean
         * @throws ReferenceError
         * @param {Object} product - the product
         * @returns {boolean}
         */
        isProduct: function (product) {
            if (!product) {
                throw new ReferenceError('Missing parameter: product');
            }
            return product.type === joyr.constants.product.PRODUCT_BEAN;
        },

        /**
         * Check if product is a BundleBean
         * @throws ReferenceError
         * @param {Object} product - the product
         * @returns {boolean}
         */
        isBundle: function (product) {
            if (!product) {
                throw new ReferenceError('Missing parameter: product');
            }
            return product.type === joyr.constants.product.BUNDLE_BEAN;
        },

        /**
         * Check if product is a Mocaco
         * @throws ReferenceError
         * @param {Object} product - the product
         * @returns {boolean}
         */
        isMocaco: function (product) {
            if (!product) {
                throw new ReferenceError('Missing parameter: product');
            }
            return product.type === joyr.constants.product.BUNDLE_BEAN && product.onSpecial;
        },

        /**
         * Check if product is a one product bundle
         * @throws ReferenceError
         * @param {Object} product - the product
         * @returns {boolean}
         */
        isOneProductBundle: function (product) {
            if (!product) {
                throw new ReferenceError('Missing parameter: product');
            }
            return product.type === joyr.constants.product.BUNDLE_BEAN && product.bundleProductSummaries.length === 1;
        },

        /**
         * Search Category by id in the categories array
         * @param {integer} id
         * @param {Category[]} categories
         */
        findCategoryById: function (id, categories) {
            var result;

            (function findCat(id, categories) {

                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];

                    if (category.id === id) {
                        result = category;
                        return;
                    }

                    if (category.subcategories && category.subcategories.length > 0) {
                        findCat(id, category.subcategories);
                    }
                }

            })(id, categories);

            return result;
        },

        /**
         * Get category page url
         * @throws ReferenceError
         * @param {Number} categoryId - category identifier
         * @param {Boolean} isMobile - if true, returns mobile url
         * @param {Boolean} isAjax - if true, returns ajax url
         * @param {object} extraParams - an object with extra params to add to the URL. If included, this object will be extended
         *  THIS FUNCTION IS A DEPRECATED FUNCTION...
         * @returns {String}
         */
        getCategoryUrl: function (categoryId, isMobile, isAjax, extraParams) {

            var injector = angular.injector(['ng', 'itxApp.common']);
            var Category = injector.get('Category');
            Category.getCategoryUrl(categoryId, isMobile, isAjax, extraParams);


            
        },

        /**
         * Get product page url
         * @throws ReferenceError
         * @param {Number} productId - product identifier
         * @param {Number} categoryId - category identifier
         * @param {String} keyword - keyword param
         * @param {Boolean} isMobile - if true, returns mobile url
         * @param {Boolean} isAjax - if true, returns ajax url
         * @param {Number} colorId - color identifier
         * @param {object} extraParams - object containing extra params for the URL. This object will be extended with the
         * usual Product params.
         * @returns {String}
         */
        getProductUrl: function (productId, categoryId, keyword, isMobile, isAjax, colorId, extraParams) {
           
            var injector = angular.injector(['ng', 'itxApp.common']);
            var Product = injector.get('Product');
            Product.getCategoryUrl(productId, categoryId, keyword, isMobile, isAjax, colorId, extraParams);
        },

        /**
         * Get the filter and order, if not exists create an empty one
         * throws ReferenceError
         * @function setCategoryFilter
         * @return {joyr.Promise}
         * @param {Number} categoryId - Category identifier
         * @example joyr.catalog.utils.getCategoryAndOrderFilter(categoryId)
         */
        getCategoryOrderAndFilter: function (categoryId) {
            return new joyr.Promise(function (resolve, reject) {
                return joyr.rest.xRestGetCategoryFilter(categoryId)
                    .done(function (results) {
                        var filterAndOrder;
                        if (results) {
                            filterAndOrder = results.filters;
                        }
                        else {
                            filterAndOrder = [{}, []];
                        }
                        resolve(filterAndOrder);
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        },

        /**
         * Get the catentries
         * throws ReferenceError
         * @function setCategoryFilter
         * @return {joyr.Promise}
         * @param {Number} categoryId - Category identifier
         */
        getCatentries: function (categoryId) {
            return new joyr.Promise(function (resolve, reject) {
                return joyr.rest.xRestGetCategoryFilter(categoryId)
                    .done(function (results) {
                        if (results && results.catentryIds) {
                            resolve(results.catentryIds);
                        } else {
                            resolve([]);
                        }
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        },

        /**
         * Set ONLY the filters of the category.
         * throws ReferenceError
         * @function setCategoryFilter
         * @return {joyr.Promise}
         * @param {Number} categoryId - Category identifier
         * @param {Object} aFilters - filters to save
         * @example joyr.catalog.utils.setCategoryFilter(categoryId, aFilters, aCatentries)
         */
        setCategoryFilter: function (categoryId, aFilters) {
            if (!aFilters || aFilters.length === 0) {
                throw new ReferenceError('Missing parameter: aFilters');
            }
            return new joyr.Promise(function (resolve, reject) {
                joyr.rest.xRestGetCategoryFilter(categoryId)
                    .done(function (results) {
                        var filters;
                        if (results && results.filters) {
                            filters = results.filters;
                        } else {
                            filters = [];
                            filters[1] = {};
                        }
                        filters[0] = aFilters[0];
                        inditex.setCategoryFilter(categoryId, filters, (results && results.catentryIds) || []);
                        resolve();
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        },

        /**
         * Set ONLY the order of the category
         * throws ReferenceError
         * @function setCategoryFilter
         * @return (joyr.Promise)
         * @param {Number} categoryId - Category identifier
         * @param {Object} aFilters - aFilters to save
         * @example joyr.catalog.utils.setCategoryOrder(inditex.iCategoryId,
         * {order: joyr.constants.order.PRICE_ORDERING, reverse: true})
         */
        setCategoryOrder: function (categoryId, aFilters) {
            if (!aFilters || aFilters.length === 0) {
                throw new ReferenceError('Missing parameter: aFilters');
            }
            return new joyr.Promise(function (resolve, reject) {
                joyr.rest.xRestGetCategoryFilter(categoryId)
                    .done(function (results) {
                        var filters;
                        if (results && results.filters) {
                            filters = results.filters;
                        }
                        else {
                            filters = [];
                            filters[0] = {};
                        }
                        filters[1] = aFilters[1];
                        inditex.setCategoryFilter(categoryId, filters, (results && results.catentryIds) || []);
                        resolve();
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        },

        /**
         * Set ONLY the catentries of the category
         * throws ReferenceError
         * @function setCategoryFilter
         * @return (joyr.Promise)
         * @param {Number} categoryId - Category identifier
         * @param {Object} aCantentries - aCantentries to save
         */
        setCategoryCatentries: function (categoryId, aCantentries) {
            if (!aCantentries || aCantentries.length === 0) {
                throw new ReferenceError('Missing parameter: aFilters');
            }
            return new joyr.Promise(function (resolve, reject) {
                joyr.rest.xRestGetCategoryFilter(categoryId)
                    .done(function (results) {
                        var filters;
                        if (results && results.filters) {
                            filters = results.filters;
                        } else {
                            filters = [];
                            filters[0] = {};
                        }
                        inditex.setCategoryFilter(categoryId, filters, aCantentries);
                        resolve();
                    })
                    .Catch(function (error) {
                        reject(error);
                    });
            });
        },

        setOrder: function (order, reverse, filters) {
            if (!order) {
                throw new ReferenceError('Missing parameter: order');
            }
            if (reverse === null || reverse === undefined) {
                throw new ReferenceError('Missing parameter: reverse');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }

            filters[1] = {};
            filters[1].order = order;
            filters[1].reverse = reverse;
        },

        /**
         * Add filter
         * throws ReferenceError
         * @param {Object} filter - filter to Add
         * @param {String} filter.name - name of the filter
         * @param {String} filter.value - value of the filter
         * @param {Object} filters - Filters to add especified filer.
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.addFilter({name:'name', value:'value'}, filters)
         */
        addFilter: function (filter, filters) {
            if (!filter) {
                throw new ReferenceError('Missing parameter: colorId');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            filters[0][filter.name] = filter.value;
        },

        /**
         * Add filter
         * throws ReferenceError
         * @param {Object} filterName - filter to Add
         * @param {Object} filters - Filters to add especified filer.
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.removeFilter('name', filters)
         */
        deleteFilter: function (filterName, filters) {
            if (!filterName) {
                throw new ReferenceError('Missing parameter: colorId');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            delete filters[0][filterName];
        },
        /**
         * Add/Remove color to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {object} color - Color to filter. If not exists adds it, else remove it
         * @param {object} filters - Filters to add especified filer.
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setColorFilter({value:'G-BLANCOS'}, filters)
         */
        setColorFilter: function (color, filters) {
            if (!color) {
                throw new ReferenceError('Missing parameter: colorId');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            var pushColor = true;
            if (filters[0].colors && filters[0].colors.length > 0) {
                for (var i = 0; i < filters[0].colors.length; i++) {
                    if (filters[0].colors[i].value === color.value) {
                        filters[0].colors.splice(i, 1);
                        pushColor = false;
                        break;
                    }
                }
            } else {
                filters[0].colors = [];
            }
            if (pushColor) {
                filters[0].colors.push(color);
            }
        },

        /**
         * Add/Remove toPrice to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {object} toPrice - To price to filter.  If not exists(or is distinct) adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setToPriceFilter({value:'10000'}, filters)
         */
        setToPriceFilter: function (toPrice, filters) {
            if (!toPrice) {
                throw new ReferenceError('Missing parameter: toPrice');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            if (filters[0].toPrice && filters[0].toPrice.length > 0 &&
                toPrice.value === filters[0].toPrice[0].value) {
                filters[0].toPrice = [];
            } else {
                filters[0].toPrice = [toPrice];
            }
        },

        /**
         * Add/Remove fromPrice to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {object} fromPrice - From price to filter.  If not exists(or is distinct) adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setFromPriceFilter({value:'10000'}, filters)
         */
        setFromPriceFilter: function (fromPrice, filters) {
            if (!fromPrice) {
                throw new ReferenceError('Missing parameter: fromPrice');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            if (filters[0].fromPrice && filters[0].fromPrice.length > 0 &&
                fromPrice[0].value === filters[0].fromPrice[0].value) {
                filters[0].fromPrice = [];
            } else {
                filters[0].fromPrice = [fromPrice];
            }
        },

        /**
         * Add/Remove attribute to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {object} attribute - Attribute to filter. If not exists adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setAttributeFilter({value: 'C-COTTON'}}, filters)
         */
        setAttributeFilter: function (attribute, filters) {
            if (!attribute) {
                throw new ReferenceError('Missing parameter: attribute');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            var pushAttr = true;
            if (filters[0].attributes && filters[0].attributes.length > 0) {
                for (var i = 0; i < filters[0].attributes.length; i++) {
                    if (filters[0].attributes[i].value === attribute.value) {
                        filters[0].attributes.splice(i, 1);
                        pushAttr = false;
                        break;
                    }
                }
            }
            else {
                filters[0].attributes = [];
            }
            if (pushAttr) {
                filters[0].attributes.push(attribute);
            }
        },

        /**
         * Add/Remove size to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {string} size - Size to filter. If not exists adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setAttributeFilter(size, filters)
         */
        setSizeFilter: function (size, filters) {
            if (!size) {
                throw new ReferenceError('Missing parameter: size');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            var pushSize = true;
            if (filters[0].sizes && filters[0].sizes.length > 0) {
                for (var i = 0; i < filters[0].sizes.length; i++) {
                    if (filters[0].sizes[i] === size) {
                        filters[0].sizes.splice(i, 1);
                        pushSize = false;
                        break;
                    }
                }
            }
            else {
                filters[0].sizes = [];
            }
            if (pushSize) {
                filters[0].sizes.push(size);
            }
        },

        /**
         * Add/Remove price to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {string} prices - Size to filter. If not exists adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setAttributeFilter(size, filters)
         */
        setPriceFilter: function (prices, filters) {
            if (!prices) {
                throw new ReferenceError('Missing parameter: prices');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            if (filters[0]) {
                filters[0].prices = prices;
            }
        },
        /**
         * Add/Remove description to filters.
         * To save the modified filters is necessary to invoke joyr.catalog.utils.setCategoryFilter
         * throws ReferenceError
         * @param {string} description - Description to filter. If not exists adds it, else remove it
         * @param {object} filters - Filters to add especified filer
         * Usually first element of filters retrieved by joyr.rest.xRestGetCategoryFilter
         * @return (void)
         * @example joyr.catalog.utils.setDescriptionFilter(description, filters)
         */
        setDescriptionFilter: function (description, filters) {
            if (!description) {
                throw new ReferenceError('Missing parameter: description');
            }
            if (!filters || filters.length === 0) {
                throw new ReferenceError('Missing parameter: filters');
            }
            var pushDesc = true;
            if (filters[0].descriptions && filters[0].descriptions.length > 0) {
                for (var i = 0; i < filters[0].descriptions.length; i++) {
                    if (filters[0].descriptions[i] === description) {
                        filters[0].descriptions.splice(i, 1);
                        pushDesc = false;
                        break;
                    }
                }
            }
            else {
                filters[0].descriptions = [];
            }
            if (pushDesc) { 
                filters[0].descriptions.push(description);
            }
        },
        /**
         * Get the summation of Shortest prices 
         * joyr.catalog.utils.getSummationBundlePricesShortestSize(bundleProduct);
         * @param {Object} bundleOrProduct
         */
        getSummationBundlePricesShortestSize: function (bundleProduct) {
            var summationPrices = 0;

            if (bundleProduct && bundleProduct.bundleProductSummaries &&
                bundleProduct.bundleProductSummaries.length > 0) {
                for (var i = 0; i < bundleProduct.bundleProductSummaries.length; i++) {
                    var product = bundleProduct.bundleProductSummaries[i];
                    summationPrices += parseInt( getShortestSizePriceProduct(product) );
                   
                }               
            }

            return summationPrices;
            

            function getShortestSizePriceProduct(product) {
                if(product.gridElemType == "MOCACO" && product.bundleProductSummaries.length > 0){
                    product = product.bundleProductSummaries[0];
                }
                if (product.detail && product.detail.colors && product.detail.colors.length > 0) {
                    var color = product.detail.colors[0];
                    if (color && color.sizes && color.sizes.length > 0) {
                        var szs = [];
                        for(var z = 0; z < color.sizes.length;z++){
                            szs.push( color.sizes[z].name );
                        }
                        var orderedSizes = inditex.sortSizes(szs );
                        var tallaMin = orderedSizes[0];                        
                        for (var j = 0; j < color.sizes.length; j++) {
                            if(tallaMin == color.sizes[j].name){
                                return color.sizes[j].price;
                            }
                        }
                    }
                } 
                return 0;
            }
        },
        /**
         * Get price range object
         * @param {Object} bundleOrProduct
         * @param {Object} color
         * @param {Object} size
         * @returns {PriceRangeObject}
         */
        getProductPriceRanges: function (bundleOrProduct, color, size) {
            if (joyr.catalog.utils.isBundle(bundleOrProduct)) {
                return rangePriceBundleProduct(bundleOrProduct, color);
            } else {
                return rangePriceProduct(bundleOrProduct, color, size);
            }

            function rangePriceBundleProduct(bundleProduct) {
                var minPrice = null;
                var maxPrice = null;
                var minOldPrice = null;
                var maxOldPrice = null;
                var rangeProductBundle = {};
                var products = [];
                if (bundleProduct && bundleProduct.bundleProductSummaries &&
                    bundleProduct.bundleProductSummaries.length > 0) {
                    var hasOldPrice = false;
                    for (var i = 0; i < bundleProduct.bundleProductSummaries.length; i++) {
                        var product = bundleProduct.bundleProductSummaries[i];
                        var rangeProduct = rangePriceProduct(product);
                        if (rangeProduct) {
                            products.push(rangeProduct);
                            if (minPrice == null && rangeProduct.minPrice != null) {
                                minPrice = rangeProduct.minPrice;
                            }
                            if (maxPrice == null && rangeProduct.maxPrice != null) {
                                maxPrice = rangeProduct.maxPrice;
                            }
                            minPrice = Math.min(minPrice, rangeProduct.minPrice);
                            maxPrice = Math.max(maxPrice, rangeProduct.maxPrice);
                            if (rangeProduct.minOldPrice != null) {
                                hasOldPrice = true;
                                if (minOldPrice == null && rangeProduct.minOldPrice != null) {
                                    minOldPrice = rangeProduct.minOldPrice;
                                }
                                if (maxOldPrice == null && rangeProduct.maxOldPrice != null) {
                                    maxOldPrice = rangeProduct.maxOldPrice;
                                }
                                minOldPrice = Math.min(minOldPrice, rangeProduct.minOldPrice);
                                maxOldPrice = Math.max(maxOldPrice, rangeProduct.maxOldPrice);
                            }
                            else {
                                minOldPrice = Math.min(minOldPrice, rangeProduct.minPrice);
                                maxOldPrice = Math.max(maxOldPrice, rangeProduct.maxPrice);
                            }
                        }
                    }
                    rangeProductBundle['productBundleId'] = bundleProduct.id;
                    rangeProductBundle['minPrice'] = minPrice;
                    rangeProductBundle['maxPrice'] = maxPrice;
                    rangeProductBundle['minOldPrice'] = hasOldPrice ? minOldPrice : null;
                    rangeProductBundle['maxOldPrice'] = hasOldPrice ? maxOldPrice : null;
                    rangeProductBundle['type'] = bundleProduct.type;
                    rangeProductBundle['products'] = products;
                } else {
                    //bundle && !bundleProductSummaries => colbenson bundle
                    rangeProductBundle['productBundleId'] = bundleProduct.id;
                    rangeProductBundle['minPrice'] = formatColbensonPrice(bundleProduct.minPrice);
                    rangeProductBundle['maxPrice'] = formatColbensonPrice(bundleProduct.maxPrice);
                    rangeProductBundle['minOldPrice'] = formatColbensonPrice(bundleProduct.minOldPrice);
                    rangeProductBundle['maxOldPrice'] = formatColbensonPrice(bundleProduct.maxOldPrice);
                    rangeProductBundle['type'] = bundleProduct.type;
                }
                return rangeProductBundle;
            }

            function rangePriceProduct(product, productColor, productSize) {
                var minPrice = null;
                var maxPrice = null;
                var minOldPrice = null;
                var maxOldPrice = null;
                var range = {};
                var hasPrice = false;
                if(product.gridElemType == "MOCACO" && product.bundleProductSummaries.length > 0){
                    product = product.bundleProductSummaries[0];
                }
                if (product.detail && product.detail.colors && product.detail.colors.length > 0) {
                    var partNumber = product.detail.reference.split('-')[0];
                    for (var i = 0; i < product.detail.colors.length; i++) {
                        var color = product.detail.colors[i];
                        if (productColor && productColor.id !== color.id) {
                            continue;
                        }
                        if (color && color.sizes && color.sizes.length > 0) {
                            var hasOldPrice = false;
                            var j;
                            for (var j = 0; j < color.sizes.length; j++) {
                                if (productSize && productSize.sku !== color.sizes[j].sku) {
                                    continue;
                                }
                                if (color.sizes[j].oldPrice != null) {
                                    hasOldPrice = true;
                                    break;
                                }
                            }
                            for (var j = 0; j < color.sizes.length; j++) {
                                var size = color.sizes[j];
                                if (productSize && productSize.sku !== size.sku) {
                                    continue;
                                }
                                // only take into account sizes that start with the same partnumber as the product, and those which aren't but
                                // have stock   
                                
                                if (size.price !== '') {
                                    hasPrice = true;
                                    if (minPrice == null) {
                                        minPrice = size.price;
                                    }
                                    if (maxPrice == null) {
                                        maxPrice = size.price;
                                    }
                                    minPrice = Math.min(minPrice, size.price);
                                    maxPrice = Math.max(maxPrice, size.price);
                                }
                                if (hasOldPrice) {
                                    if (minOldPrice == null) {
                                        minOldPrice = (size.oldPrice != null) ? size.oldPrice : size.price;
                                    }
                                    if (maxOldPrice == null) {
                                        maxOldPrice = (size.oldPrice != null) ? size.oldPrice : size.price;
                                    }
                                    minOldPrice = Math.min(minOldPrice, (size.oldPrice != null) ?
                                        size.oldPrice : size.price);
                                    maxOldPrice = Math.max(maxOldPrice, (size.oldPrice != null) ?
                                        size.oldPrice : size.price);
                                }
                            }
                        }
                    }
                    if (hasPrice) {
                        range['productId'] = product.id;
                        range['minPrice'] = minPrice;
                        range['maxPrice'] = maxPrice;
                        range['minOldPrice'] = minOldPrice;
                        range['maxOldPrice'] = maxOldPrice;
                        range['type'] = product.type;
                    }
                } else {
                    //product && !product.colors => colbenson product
                    hasPrice = true;
                    range['productBundleId'] = product.id;
                    range['minPrice'] = formatColbensonPrice(product.minPrice);
                    range['maxPrice'] = formatColbensonPrice(product.maxPrice);
                    range['minOldPrice'] = formatColbensonPrice(product.minOldPrice);
                    range['maxOldPrice'] = formatColbensonPrice(product.maxOldPrice);
                    range['type'] = product.type;
                }
                if (!hasPrice) {
                    range = null;
                }
                return range;
            }
        },
        /**
         * Get the summation of highest prices 
         * joyr.catalog.utils.getSummationBundlePrices(bundleProduct);
         * @param {Object} bundleOrProduct
         */
        getSummationBundlePrices: function (bundleProduct) {
            var maxSummationPrices = 0;

            if (bundleProduct && bundleProduct.bundleProductSummaries &&
                bundleProduct.bundleProductSummaries.length > 0) {
                for (var i = 0; i < bundleProduct.bundleProductSummaries.length; i++) {
                    var product = bundleProduct.bundleProductSummaries[i];
                    maxSummationPrices += getMaxPriceProduct(product);
                   
                }               
            }
            return maxSummationPrices;
            

            function getMaxPriceProduct(product, productColor, productSize) {
                var maxPrice = null;
                if (product.detail && product.detail.colors && product.detail.colors.length > 0) {
                    for (var i = 0; i < product.detail.colors.length; i++) {
                        var color = product.detail.colors[i];
                        if (productColor && productColor.id !== color.id) {
                            continue;
                        }
                        if (color && color.sizes && color.sizes.length > 0) {
                            for (var j = 0; j < color.sizes.length; j++) {
                                var size = color.sizes[j];
                                if (productSize && productSize.sku !== size.sku) {
                                    continue;
                                }
                                if (size.price !== '') {
                                    if (maxPrice == null) {
                                        maxPrice = size.price;
                                    }
                                    maxPrice = Math.max(maxPrice, size.price);
                                }
                            }
                        }
                    }
                } 
                return maxPrice;
            }
        },
        /**
         * Get price range HTML
         * @param {Object} priceRange
         * @returns {HTML}
         */
        getProductPriceRangesHtml: function (priceRange) {
            var retValue;
            if (typeof priceRange === 'object') {
                if (priceRange.min === priceRange.max) {
                    retValue = inditex.formatPrice(priceRange.min);
                } else {
                    retValue = inditex.formatPrice(priceRange.min) + '- ' + inditex.formatPrice(priceRange.max);
                }
            }
            return retValue;
        },
        /**
         * Get all filters for the product grid
         * @param {Array<Product>} products - The products
         * @returns {Object}
         */
        getFilters: function (products, attrFilters) {
            var filters = {};

            filters.colors = [];
            filters.prices = [];
            filters.attributes = {};
            filters.sizes = [];

            if (attrFilters) {
                for (var i = 0; i < attrFilters.length; i++) {
                    filters.attributes[attrFilters[i]] = [];
                }
            }

            for (var j = 0; j < products.length; j++) {
                filters.colors = filters.colors
                    .concat(this.getColors(products[j], joyr.constants.filters.COLOR_TYPE_FILTER));

                filters.sizes = filters.sizes
                    .concat(this.getSizes(products[j]));

                if (attrFilters) {
                    for (var k = 0; k < attrFilters.length; k++) {
                        filters.attributes[attrFilters[k]] =
                            filters.attributes[attrFilters[k]]
                                .concat(this.getAttributes(products[j], attrFilters[k]));
                    }
                }
            }

            //Get all the prices
            filters.prices = this.getPrices(products);
            filters.sizes = delDupsAndSortArray(filters.sizes);

            filters.colors = delDupsAndSortObjArray(filters.colors);
            if (attrFilters) {
                for (var l = 0; l < attrFilters.length; l++) {
                    filters.attributes[attrFilters[l]] = delDupsAndSortObjArray(filters.attributes[attrFilters[l]]);
                }
            }

            return filters;

            function delDupsAndSortArray(array) {
                var woDups = [];

                for (var i = 0; i < array.length; i++) {
                    if (woDups.indexOf(array[i]) === -1) {
                        woDups.push(array[i]);
                    }
                }

                // ordenamos el array
                woDups = woDups.sort();

                return woDups;
            }

            function delDupsAndSortObjArray(array) {
                var woDups = [];
                var uniqueValues = [];

                for (var i = 0; i < array.length; i++) {
                    if (uniqueValues.indexOf(array[i].value) === -1) {
                        uniqueValues.push(array[i].value);
                        woDups.push(array[i]);
                    }
                }

                woDups = woDups.sort(function (a, b) {
                    return a.label.localeCompare(b.label);
                });

                return woDups;
            }
        },
        /**
         * Get all prices
         * @param {Product[]} products
         * @returns {Object}
         */
        getPrices: function (products) {
            var priceRanges = [],
                minGridPrice = 0,
                maxGridPrice = 0,
                minStepPrice = 0,
                maxStepPrice = 0,
                sliderStep = inditex.iStoreJSON.details.sliderStep || 1;

            //1. Extract price range from the products
            for (var i = 0; i < products.length; i++) {
                var product = products[i];
                priceRanges.push(joyr.catalog.utils.getProductPriceRanges(product));
            }

            //2. Get min and max prices from product range
            for (var j = 0; j < priceRanges.length; j++) {
                var price = priceRanges[j];
                if (!minGridPrice) {
                    minGridPrice = price.minPrice;
                }

                if (!maxGridPrice) {
                    maxGridPrice = price.maxPrice;
                }

                minGridPrice = Math.min(minGridPrice, price.minPrice);
                maxGridPrice = Math.max(maxGridPrice, price.maxPrice);
            }

            //3. Get min and max steps
            if (maxGridPrice) {
                maxStepPrice = maxGridPrice;
            }

            //Obtenemos el siguiente numero mayor al max y multiplo de 10
            var decimals = inditex.iStoreJSON.details.locale.currencyDecimals;
            if (!decimals) {
                decimals = 0;
            }

            //Nos quedamos con la parte entera (sin decimales)
            var whole = parseInt(maxStepPrice
                .toString()
                .substring(maxStepPrice.toString().length - Math.abs(decimals), maxStepPrice.toString().length));

            maxStepPrice = parseInt(maxStepPrice
                .toString()
                .substring(0, maxStepPrice.toString().length - Math.abs(decimals)));

            if (whole && whole !== null && whole !== 0) {
                maxStepPrice += 1;
            }

            //Hayamos el siguiente valor multiplo de 10
            if (maxStepPrice % sliderStep) {
                maxStepPrice = maxStepPrice + (sliderStep - maxStepPrice % sliderStep);
            }

            //Anhadimos de nuevo los decimales que necesite (0s)
            maxStepPrice = maxStepPrice * Math.pow(10, Math.abs(decimals));

            //4. Get slider step
            // Multiplicamos el slider step por 10^numero_decimales para que el aumento
            // siempre sea de unidad en unidad de moneda (independientemente del numero de decimales)
            sliderStep = sliderStep * Math.pow(10, Math.abs(decimals));

            return {
                min: minStepPrice,
                max: maxStepPrice,
                minGrid: minGridPrice,
                maxGrid: maxGridPrice,
                minStep: minStepPrice,
                maxStep: maxStepPrice,
                sliderStep: sliderStep
            };
        },
        /**
         * Get Color filters
         * @param {Product} product
         * @param {String} type
         * @returns {Array}
         */
        getColors: function (product, type) {
            var attrs = [];

            for (var i = 0; i < product.attributes.length; i++) {
                var auxAttr = {
                    'label': product.attributes[i].value,
                    'value': product.attributes[i].name
                };

                if (product.attributes[i].type === type && !(auxAttr in attrs)) {
                    attrs.push(auxAttr);
                }
            }

            return attrs;
        },
        /**
         * Get Attributes filters
         * @param {Product} product
         * @param {String} type
         * @returns {Array}
         */
        getAttributes: function (product, type) {
            var attrs = [];

            function addAttr(attr) {
                var auxAttr = {
                    'type': attr.type,
                    'label': attr.value,
                    'value': attr.name
                };

                if (attr.type === type && !(auxAttr in attrs)) {
                    attrs.push(auxAttr);
                }
            }

            if (product.type === joyr.constants.product.PRODUCT_BEAN) {
                for (var i = 0; i < product.attributes.length; i++) {
                    addAttr(product.attributes[i]);
                }
            } else if (product.type === joyr.constants.product.BUNDLE_BEAN) {
                for (var j = 0; j < product.bundleProductSummaries.length; j++) {
                    for (var k = 0; k < product.bundleProductSummaries[j].attributes; k++) {
                        addAttr(product.bundleProductSummaries[j].attributes[k]);
                    }
                }
            }

            return attrs;
        },
        /**
         * Get Sizes filters
         * @param {Product} product
         * @param {Array<String>} visibilityMap
         * @returns {Array}
         */
        getSizes: function (product) {
            var sizes = [];

            if (product.type === joyr.constants.product.PRODUCT_BEAN) {
                for (var i = 0; i < product.detail.colors.length; i++) {
                    for (var j = 0; j < product.detail.colors[i].sizes.length; j++) {
                        var size = product.detail.colors[i].sizes[j];
                        if (size.visibility !== 'hidden' && size.visibility !== 'sold_out') {
                            sizes.push(size.name);
                        }
                    }
                }
            } else if (product.type === joyr.constants.product.BUNDLE_BEAN) {
                for (var k = 0; k < product.bundleProductSummaries.length; k++) {
                    var auxSizes = this.getSizes(product.bundleProductSummaries[k]);
                    sizes = sizes.concat(auxSizes);
                }
            }

            return sizes;
        },
        /** Process Product to get visibility
         * @param {Product} product to get visibility
         * @param {Array<Stock>} stock of the products
         * @param {boolean} noStock
         * @param {Array<Product>} products of the category. Useful when mocacos and bundles
         * @param {Array<String>} productVisibilityMap of all the products of the category. Useful when mocacos and bundles
         * @param {Array<String>} specialQualities
         * @returns {Array}
         **/
        processProductVisibility: function (product, stock, noStock, products, productVisibilityMap, specialQualities) {
            
            //IsBannerProduct
            if ((product.type === joyr.constants.product.PRODUCT_BEAN) && (product.onSpecial)) {
                product.visibility = joyr.constants.visibility.SHOW_VISIBILITY;
                return [product];
            }

            //IsBundleMocaco
            if ( (product.type === joyr.constants.product.BUNDLE_BEAN) && 
                  product.gridElemType === 'BUNDLE' && 
                  isBundleVisible(product)) {
                product.visibility = joyr.constants.visibility.SHOW_VISIBILITY;
                return [product];
            }

            var productBean = product;
            var productsWithMocacoExtracted = products ?
                extractMocacoProducts([product], products, productVisibilityMap) :
                [product];
            
            if (productsWithMocacoExtracted.length>1) {
                product = _.find(productsWithMocacoExtracted, function(mocacoProduct){
                    
                    return product.detail.displayReference === mocacoProduct.detail.displayReference;
                });
                if(!product){
                    product = productsWithMocacoExtracted[0];
                }
                //product = productsWithMocacoExtracted[0];
            }
            if(productsWithMocacoExtracted.length === 1){
                product = productsWithMocacoExtracted[0];
            }
            product.attributes = productBean.attributes;
            
            //product.name = productBean.name;
            product.detail.xmediaDefaultSet = productBean.detail.xmediaDefaultSet;

            var visibilityMap = inditex.getProductVisibilityMap([product], stock);

            joyr.catalog.visibility.setVisibility(product, visibilityMap);

            //Check if Mocaco product. If hidden visibility in the first color then extract the mocaco from the
            //visibleProducts list
            if (product.isMocaco) {
                if ((product.detail.colors && product.detail.colors.length>0 && product.detail.colors[0].visibility ===
                    joyr.constants.visibility.HIDDEN_VISIBILITY) || (product.visibility === joyr.constants.visibility.HIDDEN_VISIBILITY)){
                    return [];
                }
            }

            if (noStock || product.mocacoWithoutParent) {
                product.visibility = joyr.constants.visibility.SHOW_VISIBILITY;
            }
            
            if (inditex.iStoreJSON.details.showProductCategorySkuNoStock ===
                joyr.constants.store.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK) {
                joyr.catalog.visibility.setDisabledVisibility(product, visibilityMap, stock);
            }

            var bundlesWithSpecialQualitiesFiltered =
                filterSpecialQualityBundles([product], specialQualities);

            //Trim colors
            if (joyr.constants.store.SHOW_PRODUCT_SIZES_SKU_NO_STOCK === 'HIDE') {
                trimHiddenItems(bundlesWithSpecialQualitiesFiltered);
            }    

            //Trim product
            var noHiddenItems =
                trimHiddenProductsAndBundles(bundlesWithSpecialQualitiesFiltered);

            return extractOneProductBundles(noHiddenItems);
        },
        /** Function to order size array
         * @param {String} aSize1
         * @param {String} aSize2
         * @returns {Integer}
         **/
        sortSizesFunction: function (aSize1, aSize2) {
            var points = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];
            var aInPoints = false;
            var bInPoints = false;
            for (var i = 0; i < points.length; i++) {
                if (points[i] === aSize1) {
                    aInPoints = true;
                    break;
                }
            }
            for (var i = 0; i < points.length; i++) {
                if (points[i] === aSize2) {
                    bInPoints = true;
                    break;
                }
            }
            if (aInPoints && bInPoints) {
                var index1 = -1;
                var index2 = -1;
                for (var i = 0; i < points.length; i++) {
                    if (aSize1.toUpperCase() === points[i]) {
                        index1 = i;
                    }
                    if (aSize2.toUpperCase() === points[i]) {
                        index2 = i;
                    }
                }
                if (index1 === -1 && index2 === -1) {
                    if (aSize1 < aSize2) {
                        return -1;
                    } else if (aSize1 === aSize2) {
                        return 0;
                    } else {
                        return 1;
                    }
                } else {
                    return index1 - index2;
                }
            }
            else if (aInPoints) {
                return 1;
            }
            else if (bInPoints) {
                return -1;
            }
            else {
                var tmpA = aSize1.replace(/([0-9]+)/g, '$1#').replace(/([a-zA-Z]+)/g, '$1#').replace(/#$/, '');
                var tmpB = aSize2.replace(/([0-9]+)/g, '$1#').replace(/([a-zA-Z]+)/g, '$1#').replace(/#$/, '');

                var as = tmpA.split('#');
                var bs = tmpB.split('#');

                for (var i = 0; i < Math.min(as.length, bs.length); i++) {
                    var aHasNumber = /[0-9]/.test(as[i]);
                    var bHasNumber = /[0-9]/.test(bs[i]);
                    if (aHasNumber && bHasNumber) {
                        if (Number(as[i]) > Number(bs[i])) {
                            return 1;
                        }
                        else if (Number(as[i]) < Number(bs[i])) {
                            return -1;
                        }
                    }
                    else {
                        if (as[i] > bs[i]) {
                            return 1;
                        }
                        else if (as[i] < bs[i]) {
                            return -1;
                        }
                    }
                }
                return as.length - bs.length;
            }
        }
    };

    function filterSpecialQualityBundles(products, specialQualities) {
        var expandedList = [];
        for (var i = 0; i < products.length; i++) {
            filterSpecialQualityProducts(products[i], expandedList, specialQualities);
        }
        return expandedList;
    }

    function filterSpecialQualityProducts(product, expandedList, specialQualities) {
        if (joyr.catalog.utils.isBundle(product)) {
            lookForSpecialQualityAndFilter(product, expandedList, specialQualities);
        }
        else {
            expandedList.push(product);
        }
    }

    function lookForSpecialQualityAndFilter(bundle, expandedList, specialQualities) {
        if (!isSpecialQualityBundle(bundle, specialQualities)  ) {
            expandedList.push(bundle);
            bundle.specialQualitiesBundle = true;
        } else {
            if(isProductVisibility(bundle)){
                expandedList.push(bundle);
            }
        }
    }

    function isProductVisibility(bundle) {
        var checkProductMocacoVisibility = false;
        var products = bundle.bundleProductSummaries;
        for (var i = 0; i < products.length; i++) {
            if (isNotHidden(products[i])) {
                checkProductMocacoVisibility = true;
            }
        }
        return checkProductMocacoVisibility;
    }

    function isSpecialQualityBundle(bundle, specialQualities) {
        var products = bundle.bundleProductSummaries;
        var onlySpecialQualities = true;
        for (var i = 0; i < products.length; i++) {
            if (!isSpecialQualityProduct(products[i], specialQualities) &&
                isNotHidden(products[i])) {
                onlySpecialQualities = false;
            }
        }
        return onlySpecialQualities;
    }

    function isSpecialQualityProduct(product, specialQualities) {
        var colors = product.detail.colors;
        
        if(product.gridElemType === 'MOCACO' && product.bundleProductSummaries[0] && product.bundleProductSummaries[0].detail.colors){
            colors = product.bundleProductSummaries[0].detail.colors;
        }
        
        var onlySpecialQualities = false;
        if ((colors && colors.length > 0) && (isSpecialQualityColor(colors[0], specialQualities))) {
            onlySpecialQualities = true;
        }
        return onlySpecialQualities;
    }

    function isNotHidden(product) {
        var notHidden = true;
        if (product.type && (joyr.catalog.utils.isBundle(product) || joyr.catalog.utils.isProduct(product))) {
            if (inditex.iStoreJSON.details.showProductCategorySkuNoStock ===
                joyr.constants.store.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK) {
                notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY);
            }
            else {
                notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY &&
                product.visibility !== joyr.constants.visibility.SOLD_OUT_VISIBILITY);
            }
        } else {
            notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY);
        }
        return notHidden;
    }

    function isSpecialQualityColor(color, specialQualities) {
        var sizes = color.sizes;
        var onlySpecialQualities = false;
        if ((sizes && sizes.length > 0) && (isSpecialQualitySize(sizes[0], specialQualities))) {
            onlySpecialQualities = true;
        }
        return onlySpecialQualities;
    }

    function isSpecialQualitySize(size, specialQualities) {
        var qualityCode = getQualityNumber(size.partnumber);
        var isSpecial = false;
        if (qualityCode) {
            isSpecial = isInSpecialQualityCodes(qualityCode, specialQualities);
        }
        return isSpecial;
    }

    function getQualityNumber(partnumber) {
        var partnumberPrefix;
        if (partnumber.length > 7) {
            partnumberPrefix = partnumber.substring(5, 8);
        }
        return partnumberPrefix;
    }

    function isInSpecialQualityCodes(qualityCode, specialQualities) {
        var found = false;
        if (specialQualities) {
            for (var i = 0; i < specialQualities.length; i++) {
                if (specialQualities[i] === qualityCode) {
                    found = true;
                }
            }
        }
        return found;
    }

    function extractMocacoProducts(products, originalProducts, visibilityMap) {
        var expandedList = [];
        for (var i = 0; i < products.length; i++) {
            expandMocacoProduct(products[i], expandedList, originalProducts, visibilityMap);
        }
        return expandedList;
    }

    function expandMocacoProduct(object, expandedList, originalProducts, visibilityMap) {
        if (joyr.catalog.utils.isMocaco(object) && isNotHidden(object)) {
            addAllMocacoBundleProducts(object, expandedList, originalProducts, visibilityMap);
        } else {
            expandedList.push(object);
        }
    }

    function addAllMocacoBundleProducts(bundle, expandedList, originalProducts, visibilityMap) {
        for (var i = 0; i < bundle.bundleProductSummaries.length; i++) {
            var product = bundle.bundleProductSummaries[i];
            product.isMocaco = true;
            product.parentId = bundle.id;
            product.parent = bundle;

            //If original product found then take the mocaco color with the correct visibilities
            var productInGrid = findProductInGrid(product, originalProducts, visibilityMap);
            if (productInGrid) {
                product.detail.colors[0] = productInGrid.color; //Copy color with correct sizes
                product.visibility = productInGrid.color.visibility;
            } else {
                product.mocacoWithoutParent = true;
            }
            expandedList.push(product);
        }
    }

    /**
     * Find original product in grid.
     * If found then return the mocaco color and the original product
     */
    function findProductInGrid(product, originalProducts, visibilityMap) {
        for (var i = 0; i < originalProducts.length; i++) {
            var originalProduct = originalProducts[i];
            if (product.id === originalProduct.id) {
                joyr.catalog.visibility.setVisibility(originalProduct, visibilityMap);
                for (var j = 0; j < originalProduct.detail.colors.length; j++) {
                    if (originalProduct.detail.colors[j].id === product.detail.colors[0].id) {
                        return {
                            color: originalProduct.detail.colors[j],
                            product: originalProduct
                        };
                    }
                }
            }
        }
        return null;
    }

    function extractOneProductBundles(products) {
        var expandedList = [];
        for (var i = 0; i < products.length; i++) {
            expandOneProductBundles(products[i], expandedList);
        }
        return expandedList;
    }

    function expandOneProductBundles(object, expandedList) {
        if (!isSpecialQualitiesBundle(object) &&
            joyr.catalog.utils.isOneProductBundle(object) &&
            isNotHidden(object)) {
            addBundleProductToProductList(object, expandedList);
        }
        else {
            expandedList.push(object);
        }
    }

    function addBundleProductToProductList(bundle, productList) {
        if (bundle.bundleProductSummaries[0]) {
            productList.push(bundle.bundleProductSummaries[0]);
        }
    }

    function isSpecialQualitiesBundle(bundle) {
        return (bundle.specialQualitiesBundle === true);
    }

    function trimHiddenItems(products) {
        for (var i = 0; i < products.length; i++) {
            trimHiddenObjectsFromProductListItem(products[i]);
        }
    }

    function trimHiddenObjectsFromProductListItem(product) {
        if (joyr.catalog.utils.isBundle(product)) {
            trimHiddenProductsFromBundleAndSetVisibility(product);
        }
        else {
            if (joyr.catalog.utils.isProduct(product)) {
                trimHiddenColorsFromProduct(product);
            }
        }
    }
    
    function isBundleVisible(bundle) {
        if(!bundle.bundleProductSummaries || bundle.bundleProductSummaries.length === 0){
            return false;
        }
        var colors;
        for (var i = 0; i < bundle.bundleProductSummaries.length; i++) {
            if(bundle.bundleProductSummaries[i].gridElemType === 'MOCACO'){
                if(bundle.bundleProductSummaries[i].bundleProductSummaries.length === 0) {
                    return false;
                } else {
                    colors = bundle.bundleProductSummaries[i].bundleProductSummaries[0].detail.colors;
                    if(colors.length === 0){
                        return false;
                    } else {
                        var sizes = colors[0].sizes;
                        for (var z = 0; z < sizes.length; z++) {
                            if(sizes[z] && sizes[z].visibilityValue && sizes[z].visibilityValue.toLowerCase() == joyr.constants.visibility.SHOW_VISIBILITY){
                                return true;
                            }
                        }
                    }
                }                
            } else {
                colors = bundle.bundleProductSummaries[i].detail.colors;
                if(colors.length === 0){
                    return false;
                } else {
                    var sizes = colors[0].sizes;
                    for (var z = 0; z < sizes.length; z++) {
                        if(sizes[z] && sizes[z].visibilityValue && sizes[z].visibilityValue.toLowerCase() == joyr.constants.visibility.SHOW_VISIBILITY){
                            return true;
                        }
                    }
                    return true;
                }
            }
        }
    }

    function trimHiddenColorsFromProduct(product) {
        var colors = [];
        for (var i = 0; i < product.detail.colors.length; i++) {
            trimSizesFromColor(product.detail.colors[i]);
            //If no sizes, then remove color from the colors array
            if (product.detail.colors[i].sizes.length > 0) {
                colors.push(product.detail.colors[i]);
            }
        }
        product.detail.colors = colors;
        if (product.detail.colors.length === 0) {
            product.visibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
        }
    }

    function trimSizesFromColor(color) {
        var filteredSizes = [];
        for (var i = 0; i < color.sizes.length; i++) {
            if (isNotHidden(color.sizes[i])) {
                filteredSizes.push(color.sizes[i]);
            }
        }
        color.sizes = filteredSizes;
    }

    function trimHiddenProductsFromBundleAndSetVisibility(bundle) {
        var filtered = trimHiddenProductsFromBundle(bundle);
        bundle.bundleProductSummaries = filtered;
        if (bundle.bundleProductSummaries.length === 0) {
            bundle.visibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
        }
    }

    function trimHiddenProductsFromBundle(bundle) {
        var filtered = [];
        for (var i = 0; i < bundle.bundleProductSummaries.length; i++) {
            trimHiddenObjectsFromProductListItem(bundle.bundleProductSummaries[i]);
            if (isNotHidden(bundle.bundleProductSummaries[i])) {
                filtered.push(bundle.bundleProductSummaries[i]);
            }
        }
        return filtered;
    }

    function trimHiddenProductsAndBundles(filteredItems) {
        var filtered = [];
        for (var i = 0; i < filteredItems.length; i++) {
            if (isNotHidden(filteredItems[i])) {
                filtered.push(filteredItems[i]);
            }
        }
        return filtered;
    }

    function formatColbensonPrice(price) {
        var formattedPrice = price && inditex.iStoreJSON.details.locale.currencyDecimals != 0 ? price.replace('.', '') : price;
        return parseInt(formattedPrice) > 0 ? formattedPrice : null;
    }

    joyr.catalog.utils = utils;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.catalog.visibility
     */
    var visibility = {
        /**
         * Set product visibility property
         * @param {Object} product - The product
         * @param {Array<String>} visibilityMap - The visibilityMap
         */
        setVisibility: function (product, visibilityMap) {
            if (joyr.catalog.utils.isBundle(product)) {
                setBundleVisibility(product, visibilityMap);
            }else if (joyr.catalog.utils.isProduct(product)) {
                setProductVisibility(product, visibilityMap);
            }
            if (inditex.iStoreJSON.details.productWithImage && product.visibility !==
                joyr.constants.visibility.HIDDEN_VISIBILITY) {
                if (product.field5 === null) {
                    product.visibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
                    return;
                }
                if (joyr.catalog.utils.isBundle(product)) {
                    if (product.image === null) {
                        product.visibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
                        return;
                    }
                }
                if (joyr.catalog.utils.isProduct(product)) {
                    var productVisibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
                    if (product.detail && product.detail.colors && (product.detail.colors.length > 0)) {
                        for (var i = 0; i < product.detail.colors.length; i++) {
                            if (product.detail.colors[i].image &&
                                product.detail.colors[i].image.url &&
                                product.detail.colors[i].image.type &&
                                product.detail.colors[i].image.type.length > 0) {
                                productVisibility = joyr.constants.visibility.SHOW_VISIBILITY;
                            }
                        }
                    }
                    product.visibility = productVisibility;
                    return;
                }
            }
        },

        /**
         * Set Disabled sizes visibility
         * @param {Object} product - The product
         * @param {Array<String>} visibilityMap - The visibilityMap
         * @param {Array<Stock>} stocks - The stocks
         */
        setDisabledVisibility: function (product, visibilityMap, stocks) {
            if (joyr.catalog.utils.isBundle(product)) {
                setBundleDisabledSkusVisibility(product, stocks);
            } else {
                if (joyr.catalog.utils.isProduct(product)) {
                    setProductDisabledSkusVisibility(product, stocks);
                }
            }
        }
    };

    function setBundleVisibility(bundle, visibilityMap) {
        setHighestProductVisibility(bundle, visibilityMap);
    }

    function setHighestProductVisibility(bundle, visibilityMap) {
        for (var i = 0; i < bundle.bundleProductSummaries.length; i++) {
            setProductVisibility(bundle.bundleProductSummaries[i], visibilityMap);
        }
        bundle.visibility = getHighestVisibility(bundle.bundleProductSummaries);
    }

    function getHighestVisibility(objectList) {
        var previousVisibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
        for (var i = 0; i < objectList.length; i ++) {
            previousVisibility = compareVisibilities(previousVisibility,objectList[i].visibility);
        }
        return previousVisibility;
    }

    function compareVisibilities(visibility1, visibility2) {
        var visibility = (getVisibilityIndex(visibility1) <
        getVisibilityIndex(visibility2) ? visibility1 : visibility2);
        return visibility;
    }

    function getVisibilityIndex(visibility) {
        return [joyr.constants.visibility.SHOW_VISIBILITY,
            joyr.constants.visibility.BACK_SOON_VISIBILITY,
            joyr.constants.visibility.COMMING_SOON_VISIBILITY,
            joyr.constants.visibility.DISABLED_VISIBILITY,
            joyr.constants.visibility.SOLD_OUT_VISIBILITY,
            joyr.constants.visibility.HIDDEN_VISIBILITY]
            .map(function (e) { return e; }).indexOf(visibility);
    }

    function setProductVisibility(product, visibilityMap) {
        setObjectVisibility(product, visibilityMap);
        if (isNotHidden(product)) {
            setHighestColorVisibility(product, visibilityMap);
        }
    }

    function setObjectVisibility(object, visibilityMap) {
        var visibility = joyr.constants.visibility.SHOW_VISIBILITY;
        if (object.visibility !== joyr.constants.visibility.DISABLED_VISIBILITY) {
            if (object.id) {
                visibility = visibilityMap[object.id];
            }
            else {
                if (object.sku) {
                    visibility = visibilityMap[object.sku];
                }
            }
        }
        else {
            visibility = joyr.constants.visibility.DISABLED_VISIBILITY;
        }
        object.visibility = visibility;
    }

    function isNotHidden(product) {
        var notHidden = true;
        if (product.type && (joyr.catalog.utils.isBundle(product) || joyr.catalog.utils.isProduct(product))) {
            if (inditex.iStoreJSON.details.showProductCategorySkuNoStock ===
                joyr.constants.store.SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK) {
                notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY);
            }
            else {
                notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY &&
                product.visibility !== joyr.constants.visibility.SOLD_OUT_VISIBILITY);
            }
        } else {
            notHidden = (product.visibility !== joyr.constants.visibility.HIDDEN_VISIBILITY);
        }
        return notHidden;
    }

    function setHighestColorVisibility(product, visibilityMap) {
        setColorListVisibility(product.detail, visibilityMap);
        product.visibility = getHighestVisibility(product.detail.colors);
    }

    function setColorListVisibility(detail, visibilityMap) {
        for (var i = 0; i < detail.colors.length; i++) {
            detail.colors[i].visibility = joyr.constants.visibility.SHOW_VISIBILITY;
            if (detail.colors[i].image === null && (inditex.iStoreJSON.details.xmedia === null || detail.xmedia === null)) {
                detail.colors[i].visibility = joyr.constants.visibility.HIDDEN_VISIBILITY;
            } else {
                setHighestSizeVisibility(detail.colors[i], visibilityMap);
            }
        }
    }

    function setHighestSizeVisibility(color, visibilityMap) {
        setSizeListVisibility(color.sizes, visibilityMap);
        color.visibility = getHighestVisibility(color.sizes);
    }

    function setSizeListVisibility(sizes, visibilityMap) {
        for (var i = 0; i < sizes.length; i++) {
            setObjectVisibility(sizes[i], visibilityMap);
        }
    }

    function setBundleDisabledSkusVisibility(bundle, stocks) {
        for (var i = 0; i < bundle.bundleProductSummaries.length; i++) {
            setProductDisabledSkusVisibility(bundle.bundleProductSummaries[i], stocks);
        }
    }

    function setProductDisabledSkusVisibility(product, stocks) {
        for (var i = 0; i < stocks.length; i++) {
            if (product.detail && product.detail.colors) {
                setColorsDisabledSkusVisibility(product.detail.colors);
            }
        }
    }

    function setColorsDisabledSkusVisibility(colors) {
        for (var i = 0; i < colors.length; i++) {
            setSizesDisabledSkusVisibility(colors[i].sizes);
        }
    }

    function setSizesDisabledSkusVisibility(sizes) {
        for (var i = 0; i < sizes.length; i++) {
            setDisabledSkuVisibility(sizes[i]);
        }
    }

    function setDisabledSkuVisibility(sku) {
        if (sku.visibility === joyr.constants.visibility.SOLD_OUT_VISIBILITY) {
            sku.visibility = joyr.constants.visibility.DISABLED_VISIBILITY;
        }
    }

    joyr.catalog.visibility = visibility;

})(window.joyr);

(function (joyr) {

    'use strict';

    /**
     * @namespace
     * @alias joyr.user.utils
     */
    var utils = {

        /**
         * Check if the user is authenticated
         * @returns {boolean}
         */
        isAuthenticated: function () {
            return inditex.iUserJSON && inditex.iUserJSON.userType !== joyr.constants.user.GUEST;
        },

        /**
         * Check if the user is wallet
         * @returns {boolean}
         */
        isWalletUser: function () {
            return inditex.iUserJSON && inditex.iUserJSON.isWalletUser;
        },

        /**
         * Get user type
         * G: guest
         * S: semi-guest
         * R: register
         * W: wallet
         * WS: semi-wallet
         * @returns {joyr.Promise}
         */
        getUserType: function () {
            /*jshint -W030 */
            /*jshint -W016 */
            return new joyr.Promise(function (resolve, reject) {
                if (inditex.iUserJSON && inditex.iUserJSON.userType) {
                    if (inditex.iUserJSON.userType === joyr.constants.user.GUEST) {
                        resolve(joyr.constants.user.GUEST);
                    } else {
                        if (inditex.iFullAddressMask) {
                            if (inditex.iFullAddressMask &&
                                inditex.iUserJSON.personalDataLevel &&
                                ((inditex.iUserJSON.personalDataLevel & inditex.iFullAddressMask) ==
                                inditex.iFullAddressMask)) {
                                inditex.iUserJSON.isWalletUser ?
                                    resolve(joyr.constants.user.WALLET) : resolve(joyr.constants.user.REGISTER);
                            } else {
                                inditex.iUserJSON.isWalletUser ?
                                    resolve(joyr.constants.user.SEMI_WALLET) : resolve(joyr.constants.user.SEMI_GUEST);
                            }
                        } else {
                            inditex.getXconfiguracionValue('FULL_ADDRESS_MASK', function (status, value) {
                                inditex.iFullAddressMask = value;
                                if (inditex.iFullAddressMask &&
                                    inditex.iUserJSON.personalDataLevel &&
                                    ((inditex.iUserJSON.personalDataLevel & inditex.iFullAddressMask) ==
                                    inditex.iFullAddressMask)) {
                                    inditex.iUserJSON.isWalletUser ?
                                        resolve(joyr.constants.user.WALLET) : resolve(joyr.constants.user.REGISTER);
                                } else {
                                    inditex.iUserJSON.isWalletUser ?
                                        resolve(joyr.constants.user.SEMI_WALLET) : resolve(joyr.constants.user.SEMI_GUEST);
                                }
                            });
                        }
                    }
                } else {
                    resolve(joyr.constants.user.GUEST);
                }
            });
        },

        
        /**
         * Check if the rememberMe check should be available in the Login forms
         * @returns {boolean}
         */
        rememberMeAllowed: function () {
            return inditex.iStoreJSON.details.rememberMe === '1';
        },
        /**
         * Creates an empty user
         * An example of use is in the registration process with name, email and password only
         * @returns {User}
         */
        createEmptyUser: function () {
            return {
                'email': null,
                'emailConfirm': null,
                'password': null,
                'passwordConfirm': null,
                'primaryAddress': {
                    'firstName': '',
                    'lastName': '',
                    'isCompany': false,
                    'addressLines': [],
                    'city': '',
                    'stateCode': '',
                    'countryCode': inditex.iStoreJSON.countryCode,
                    'zipCode': '',
                    'gender': 'F',
                    'company': {'vatin': '','name': ''},
                    'phones': [{'countryCode': '', 'subscriberNumber': ''}]
                },
                'privacyPolicyAccepted': false,
                'newsletter': '',
                'rememberMe' : 0
            };
        }
        
    };

    joyr.user.utils = utils;

})(window.joyr);

